/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));


/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(786)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( matchesSelector ) {
      return factory( window, matchesSelector );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

}( window, function factory( window, matchesSelector ) {

'use strict';

var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }
  // return empty array if undefined or null. #6
  if ( obj === null || obj === undefined ) {
    return [];
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem.parentNode && elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  threshold = threshold || 100;
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    clearTimeout( timeout );

    var args = arguments;
    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));


/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// add, remove cell
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(249),
      __webpack_require__(977),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

}( window, function factory( window, Flickity, utils ) {

'use strict';

// append cells to a document fragment
function getCellsFragment( cells ) {
  var fragment = document.createDocumentFragment();
  cells.forEach( function( cell ) {
    fragment.appendChild( cell.element );
  } );
  return fragment;
}

// -------------------------- add/remove cell prototype -------------------------- //

var proto = Flickity.prototype;

/**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */
proto.insert = function( elems, index ) {
  var cells = this._makeCells( elems );
  if ( !cells || !cells.length ) {
    return;
  }
  var len = this.cells.length;
  // default to append
  index = index === undefined ? len : index;
  // add cells with document fragment
  var fragment = getCellsFragment( cells );
  // append to slider
  var isAppend = index == len;
  if ( isAppend ) {
    this.slider.appendChild( fragment );
  } else {
    var insertCellElement = this.cells[ index ].element;
    this.slider.insertBefore( fragment, insertCellElement );
  }
  // add to this.cells
  if ( index === 0 ) {
    // prepend, add to start
    this.cells = cells.concat( this.cells );
  } else if ( isAppend ) {
    // append, add to end
    this.cells = this.cells.concat( cells );
  } else {
    // insert in this.cells
    var endCells = this.cells.splice( index, len - index );
    this.cells = this.cells.concat( cells ).concat( endCells );
  }

  this._sizeCells( cells );
  this.cellChange( index, true );
};

proto.append = function( elems ) {
  this.insert( elems, this.cells.length );
};

proto.prepend = function( elems ) {
  this.insert( elems, 0 );
};

/**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */
proto.remove = function( elems ) {
  var cells = this.getCells( elems );
  if ( !cells || !cells.length ) {
    return;
  }

  var minCellIndex = this.cells.length - 1;
  // remove cells from collection & DOM
  cells.forEach( function( cell ) {
    cell.remove();
    var index = this.cells.indexOf( cell );
    minCellIndex = Math.min( index, minCellIndex );
    utils.removeFrom( this.cells, cell );
  }, this );

  this.cellChange( minCellIndex, true );
};

/**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */
proto.cellSizeChange = function( elem ) {
  var cell = this.getCell( elem );
  if ( !cell ) {
    return;
  }
  cell.getSize();

  var index = this.cells.indexOf( cell );
  this.cellChange( index );
};

/**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 * @param {Boolean} isPositioningSlider - Positions slider after selection
 */
proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
  var prevSelectedElem = this.selectedElement;
  this._positionCells( changedCellIndex );
  this._getWrapShiftCells();
  this.setGallerySize();
  // update selectedIndex
  // try to maintain position & select previous selected element
  var cell = this.getCell( prevSelectedElem );
  if ( cell ) {
    this.selectedIndex = this.getCellSlideIndex( cell );
  }
  this.selectedIndex = Math.min( this.slides.length - 1, this.selectedIndex );

  this.emitEvent( 'cellChange', [ changedCellIndex ] );
  // position slider
  this.select( this.selectedIndex );
  // do not position slider after lazy load
  if ( isPositioningSlider ) {
    this.positionSliderAtSelected();
  }
};

// -----  ----- //

return Flickity;

} ) );


/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// animate
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(977),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( utils ) {
      return factory( window, utils );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

}( window, function factory( window, utils ) {

'use strict';

// -------------------------- animate -------------------------- //

var proto = {};

proto.startAnimation = function() {
  if ( this.isAnimating ) {
    return;
  }

  this.isAnimating = true;
  this.restingFrames = 0;
  this.animate();
};

proto.animate = function() {
  this.applyDragForce();
  this.applySelectedAttraction();

  var previousX = this.x;

  this.integratePhysics();
  this.positionSlider();
  this.settle( previousX );
  // animate next frame
  if ( this.isAnimating ) {
    var _this = this;
    requestAnimationFrame( function animateFrame() {
      _this.animate();
    } );
  }
};

proto.positionSlider = function() {
  var x = this.x;
  // wrap position around
  if ( this.options.wrapAround && this.cells.length > 1 ) {
    x = utils.modulo( x, this.slideableWidth );
    x -= this.slideableWidth;
    this.shiftWrapCells( x );
  }

  this.setTranslateX( x, this.isAnimating );
  this.dispatchScrollEvent();
};

proto.setTranslateX = function( x, is3d ) {
  x += this.cursorPosition;
  // reverse if right-to-left and using transform
  x = this.options.rightToLeft ? -x : x;
  var translateX = this.getPositionValue( x );
  // use 3D transforms for hardware acceleration on iOS
  // but use 2D when settled, for better font-rendering
  this.slider.style.transform = is3d ?
    'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
};

proto.dispatchScrollEvent = function() {
  var firstSlide = this.slides[0];
  if ( !firstSlide ) {
    return;
  }
  var positionX = -this.x - firstSlide.target;
  var progress = positionX / this.slidesWidth;
  this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
};

proto.positionSliderAtSelected = function() {
  if ( !this.cells.length ) {
    return;
  }
  this.x = -this.selectedSlide.target;
  this.velocity = 0; // stop wobble
  this.positionSlider();
};

proto.getPositionValue = function( position ) {
  if ( this.options.percentPosition ) {
    // percent position, round to 2 digits, like 12.34%
    return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 ) + '%';
  } else {
    // pixel positioning
    return Math.round( position ) + 'px';
  }
};

proto.settle = function( previousX ) {
  // keep track of frames where x hasn't moved
  var isResting = !this.isPointerDown &&
      Math.round( this.x * 100 ) == Math.round( previousX * 100 );
  if ( isResting ) {
    this.restingFrames++;
  }
  // stop animating if resting for 3 or more frames
  if ( this.restingFrames > 2 ) {
    this.isAnimating = false;
    delete this.isFreeScrolling;
    // render position with translateX when settled
    this.positionSlider();
    this.dispatchEvent( 'settle', null, [ this.selectedIndex ] );
  }
};

proto.shiftWrapCells = function( x ) {
  // shift before cells
  var beforeGap = this.cursorPosition + x;
  this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
  // shift after cells
  var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
  this._shiftCells( this.afterShiftCells, afterGap, 1 );
};

proto._shiftCells = function( cells, gap, shift ) {
  for ( var i = 0; i < cells.length; i++ ) {
    var cell = cells[i];
    var cellShift = gap > 0 ? shift : 0;
    cell.wrapShift( cellShift );
    gap -= cell.size.outerWidth;
  }
};

proto._unshiftCells = function( cells ) {
  if ( !cells || !cells.length ) {
    return;
  }
  for ( var i = 0; i < cells.length; i++ ) {
    cells[i].wrapShift( 0 );
  }
};

// -------------------------- physics -------------------------- //

proto.integratePhysics = function() {
  this.x += this.velocity;
  this.velocity *= this.getFrictionFactor();
};

proto.applyForce = function( force ) {
  this.velocity += force;
};

proto.getFrictionFactor = function() {
  return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
};

proto.getRestingPosition = function() {
  // my thanks to Steven Wittens, who simplified this math greatly
  return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
};

proto.applyDragForce = function() {
  if ( !this.isDraggable || !this.isPointerDown ) {
    return;
  }
  // change the position to drag position by applying force
  var dragVelocity = this.dragX - this.x;
  var dragForce = dragVelocity - this.velocity;
  this.applyForce( dragForce );
};

proto.applySelectedAttraction = function() {
  // do not attract if pointer down or no slides
  var dragDown = this.isDraggable && this.isPointerDown;
  if ( dragDown || this.isFreeScrolling || !this.slides.length ) {
    return;
  }
  var distance = this.selectedSlide.target * -1 - this.x;
  var force = distance * this.options.selectedAttraction;
  this.applyForce( force );
};

return proto;

} ) );


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity.Cell
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(485),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( getSize ) {
      return factory( window, getSize );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

}( window, function factory( window, getSize ) {

'use strict';

function Cell( elem, parent ) {
  this.element = elem;
  this.parent = parent;

  this.create();
}

var proto = Cell.prototype;

proto.create = function() {
  this.element.style.position = 'absolute';
  this.element.setAttribute( 'aria-hidden', 'true' );
  this.x = 0;
  this.shift = 0;
  this.element.style[ this.parent.originSide ] = 0;
};

proto.destroy = function() {
  // reset style
  this.unselect();
  this.element.style.position = '';
  var side = this.parent.originSide;
  this.element.style[ side ] = '';
  this.element.style.transform = '';
  this.element.removeAttribute('aria-hidden');
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

proto.setPosition = function( x ) {
  this.x = x;
  this.updateTarget();
  this.renderPosition( x );
};

// setDefaultTarget v1 method, backwards compatibility, remove in v3
proto.updateTarget = proto.setDefaultTarget = function() {
  var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
  this.target = this.x + this.size[ marginProperty ] +
    this.size.width * this.parent.cellAlign;
};

proto.renderPosition = function( x ) {
  // render position of cell with in slider
  var sideOffset = this.parent.originSide === 'left' ? 1 : -1;

  var adjustedX = this.parent.options.percentPosition ?
    x * sideOffset * ( this.parent.size.innerWidth / this.size.width ) :
    x * sideOffset;

  this.element.style.transform = 'translateX(' +
    this.parent.getPositionValue( adjustedX ) + ')';
};

proto.select = function() {
  this.element.classList.add('is-selected');
  this.element.removeAttribute('aria-hidden');
};

proto.unselect = function() {
  this.element.classList.remove('is-selected');
  this.element.setAttribute( 'aria-hidden', 'true' );
};

/**
 * @param {Integer} shift - 0, 1, or -1
 */
proto.wrapShift = function( shift ) {
  this.shift = shift;
  this.renderPosition( this.x + this.parent.slideableWidth * shift );
};

proto.remove = function() {
  this.element.parentNode.removeChild( this.element );
};

return Cell;

} ) );


/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// drag
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(249),
      __webpack_require__(377),
      __webpack_require__(977),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, Unidragger, utils ) {
      return factory( window, Flickity, Unidragger, utils );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

}( window, function factory( window, Flickity, Unidragger, utils ) {

'use strict';

// ----- defaults ----- //

utils.extend( Flickity.defaults, {
  draggable: '>1',
  dragThreshold: 3,
} );

// ----- create ----- //

Flickity.createMethods.push('_createDrag');

// -------------------------- drag prototype -------------------------- //

var proto = Flickity.prototype;
utils.extend( proto, Unidragger.prototype );
proto._touchActionValue = 'pan-y';

// --------------------------  -------------------------- //

proto._createDrag = function() {
  this.on( 'activate', this.onActivateDrag );
  this.on( 'uiChange', this._uiChangeDrag );
  this.on( 'deactivate', this.onDeactivateDrag );
  this.on( 'cellChange', this.updateDraggable );
  // TODO updateDraggable on resize? if groupCells & slides change
};

proto.onActivateDrag = function() {
  this.handles = [ this.viewport ];
  this.bindHandles();
  this.updateDraggable();
};

proto.onDeactivateDrag = function() {
  this.unbindHandles();
  this.element.classList.remove('is-draggable');
};

proto.updateDraggable = function() {
  // disable dragging if less than 2 slides. #278
  if ( this.options.draggable == '>1' ) {
    this.isDraggable = this.slides.length > 1;
  } else {
    this.isDraggable = this.options.draggable;
  }
  if ( this.isDraggable ) {
    this.element.classList.add('is-draggable');
  } else {
    this.element.classList.remove('is-draggable');
  }
};

// backwards compatibility
proto.bindDrag = function() {
  this.options.draggable = true;
  this.updateDraggable();
};

proto.unbindDrag = function() {
  this.options.draggable = false;
  this.updateDraggable();
};

proto._uiChangeDrag = function() {
  delete this.isFreeScrolling;
};

// -------------------------- pointer events -------------------------- //

proto.pointerDown = function( event, pointer ) {
  if ( !this.isDraggable ) {
    this._pointerDownDefault( event, pointer );
    return;
  }
  var isOkay = this.okayPointerDown( event );
  if ( !isOkay ) {
    return;
  }

  this._pointerDownPreventDefault( event );
  this.pointerDownFocus( event );
  // blur
  if ( document.activeElement != this.element ) {
    // do not blur if already focused
    this.pointerDownBlur();
  }

  // stop if it was moving
  this.dragX = this.x;
  this.viewport.classList.add('is-pointer-down');
  // track scrolling
  this.pointerDownScroll = getScrollPosition();
  window.addEventListener( 'scroll', this );

  this._pointerDownDefault( event, pointer );
};

// default pointerDown logic, used for staticClick
proto._pointerDownDefault = function( event, pointer ) {
  // track start event position
  // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
  this.pointerDownPointer = {
    pageX: pointer.pageX,
    pageY: pointer.pageY,
  };
  // bind move and end events
  this._bindPostStartEvents( event );
  this.dispatchEvent( 'pointerDown', event, [ pointer ] );
};

var focusNodes = {
  INPUT: true,
  TEXTAREA: true,
  SELECT: true,
};

proto.pointerDownFocus = function( event ) {
  var isFocusNode = focusNodes[ event.target.nodeName ];
  if ( !isFocusNode ) {
    this.focus();
  }
};

proto._pointerDownPreventDefault = function( event ) {
  var isTouchStart = event.type == 'touchstart';
  var isTouchPointer = event.pointerType == 'touch';
  var isFocusNode = focusNodes[ event.target.nodeName ];
  if ( !isTouchStart && !isTouchPointer && !isFocusNode ) {
    event.preventDefault();
  }
};

// ----- move ----- //

proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > this.options.dragThreshold;
};

// ----- up ----- //

proto.pointerUp = function( event, pointer ) {
  delete this.isTouchScrolling;
  this.viewport.classList.remove('is-pointer-down');
  this.dispatchEvent( 'pointerUp', event, [ pointer ] );
  this._dragPointerUp( event, pointer );
};

proto.pointerDone = function() {
  window.removeEventListener( 'scroll', this );
  delete this.pointerDownScroll;
};

// -------------------------- dragging -------------------------- //

proto.dragStart = function( event, pointer ) {
  if ( !this.isDraggable ) {
    return;
  }
  this.dragStartPosition = this.x;
  this.startAnimation();
  window.removeEventListener( 'scroll', this );
  this.dispatchEvent( 'dragStart', event, [ pointer ] );
};

proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  if ( !this.isDraggable ) {
    return;
  }
  event.preventDefault();

  this.previousDragX = this.dragX;
  // reverse if right-to-left
  var direction = this.options.rightToLeft ? -1 : 1;
  if ( this.options.wrapAround ) {
    // wrap around move. #589
    moveVector.x %= this.slideableWidth;
  }
  var dragX = this.dragStartPosition + moveVector.x * direction;

  if ( !this.options.wrapAround && this.slides.length ) {
    // slow drag
    var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
    dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
    var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
    dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
  }

  this.dragX = dragX;

  this.dragMoveTime = new Date();
  this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
};

proto.dragEnd = function( event, pointer ) {
  if ( !this.isDraggable ) {
    return;
  }
  if ( this.options.freeScroll ) {
    this.isFreeScrolling = true;
  }
  // set selectedIndex based on where flick will end up
  var index = this.dragEndRestingSelect();

  if ( this.options.freeScroll && !this.options.wrapAround ) {
    // if free-scroll & not wrap around
    // do not free-scroll if going outside of bounding slides
    // so bounding slides can attract slider, and keep it in bounds
    var restingX = this.getRestingPosition();
    this.isFreeScrolling = -restingX > this.slides[0].target &&
      -restingX < this.getLastSlide().target;
  } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
    // boost selection if selected index has not changed
    index += this.dragEndBoostSelect();
  }
  delete this.previousDragX;
  // apply selection
  // TODO refactor this, selecting here feels weird
  // HACK, set flag so dragging stays in correct direction
  this.isDragSelect = this.options.wrapAround;
  this.select( index );
  delete this.isDragSelect;
  this.dispatchEvent( 'dragEnd', event, [ pointer ] );
};

proto.dragEndRestingSelect = function() {
  var restingX = this.getRestingPosition();
  // how far away from selected slide
  var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
  // get closet resting going up and going down
  var positiveResting = this._getClosestResting( restingX, distance, 1 );
  var negativeResting = this._getClosestResting( restingX, distance, -1 );
  // use closer resting for wrap-around
  var index = positiveResting.distance < negativeResting.distance ?
    positiveResting.index : negativeResting.index;
  return index;
};

/**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */
proto._getClosestResting = function( restingX, distance, increment ) {
  var index = this.selectedIndex;
  var minDistance = Infinity;
  var condition = this.options.contain && !this.options.wrapAround ?
    // if contain, keep going if distance is equal to minDistance
    function( dist, minDist ) {
      return dist <= minDist;
    } : function( dist, minDist ) {
      return dist < minDist;
    };
  while ( condition( distance, minDistance ) ) {
    // measure distance to next cell
    index += increment;
    minDistance = distance;
    distance = this.getSlideDistance( -restingX, index );
    if ( distance === null ) {
      break;
    }
    distance = Math.abs( distance );
  }
  return {
    distance: minDistance,
    // selected was previous index
    index: index - increment,
  };
};

/**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */
proto.getSlideDistance = function( x, index ) {
  var len = this.slides.length;
  // wrap around if at least 2 slides
  var isWrapAround = this.options.wrapAround && len > 1;
  var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
  var slide = this.slides[ slideIndex ];
  if ( !slide ) {
    return null;
  }
  // add distance for wrap-around slides
  var wrap = isWrapAround ? this.slideableWidth * Math.floor( index/len ) : 0;
  return x - ( slide.target + wrap );
};

proto.dragEndBoostSelect = function() {
  // do not boost if no previousDragX or dragMoveTime
  if ( this.previousDragX === undefined || !this.dragMoveTime ||
    // or if drag was held for 100 ms
    new Date() - this.dragMoveTime > 100 ) {
    return 0;
  }

  var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
  var delta = this.previousDragX - this.dragX;
  if ( distance > 0 && delta > 0 ) {
    // boost to next if moving towards the right, and positive velocity
    return 1;
  } else if ( distance < 0 && delta < 0 ) {
    // boost to previous if moving towards the left, and negative velocity
    return -1;
  }
  return 0;
};

// ----- staticClick ----- //

proto.staticClick = function( event, pointer ) {
  // get clickedCell, if cell was clicked
  var clickedCell = this.getParentCell( event.target );
  var cellElem = clickedCell && clickedCell.element;
  var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
  this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
};

// ----- scroll ----- //

proto.onscroll = function() {
  var scroll = getScrollPosition();
  var scrollMoveX = this.pointerDownScroll.x - scroll.x;
  var scrollMoveY = this.pointerDownScroll.y - scroll.y;
  // cancel click/tap if scroll is too much
  if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
    this._pointerDone();
  }
};

// ----- utils ----- //

function getScrollPosition() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset,
  };
}

// -----  ----- //

return Flickity;

} ) );


/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity main
/* eslint-disable max-params */
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(137),
      __webpack_require__(485),
      __webpack_require__(977),
      __webpack_require__(92),
      __webpack_require__(331),
      __webpack_require__(121),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
      return factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{ var _Flickity; }

}( window, function factory( window, EvEmitter, getSize,
    utils, Cell, Slide, animatePrototype ) {

/* eslint-enable max-params */
'use strict';

// vars
var jQuery = window.jQuery;
var getComputedStyle = window.getComputedStyle;
var console = window.console;

function moveElements( elems, toElem ) {
  elems = utils.makeArray( elems );
  while ( elems.length ) {
    toElem.appendChild( elems.shift() );
  }
}

// -------------------------- Flickity -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Flickity intances
var instances = {};

function Flickity( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // do not initialize twice on same element
  if ( this.element.flickityGUID ) {
    var instance = instances[ this.element.flickityGUID ];
    if ( instance ) instance.option( options );
    return instance;
  }

  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }
  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // kick things off
  this._create();
}

Flickity.defaults = {
  accessibility: true,
  // adaptiveHeight: false,
  cellAlign: 'center',
  // cellSelector: undefined,
  // contain: false,
  freeScrollFriction: 0.075, // friction when free-scrolling
  friction: 0.28, // friction when selecting
  namespaceJQueryEvents: true,
  // initialIndex: 0,
  percentPosition: true,
  resize: true,
  selectedAttraction: 0.025,
  setGallerySize: true,
  // watchCSS: false,
  // wrapAround: false
};

// hash of methods triggered on _create()
Flickity.createMethods = [];

var proto = Flickity.prototype;
// inherit EventEmitter
utils.extend( proto, EvEmitter.prototype );

proto._create = function() {
  // add id for Flickity.data
  var id = this.guid = ++GUID;
  this.element.flickityGUID = id; // expando
  instances[ id ] = this; // associate via id
  // initial properties
  this.selectedIndex = 0;
  // how many frames slider has been in same position
  this.restingFrames = 0;
  // initial physics properties
  this.x = 0;
  this.velocity = 0;
  this.originSide = this.options.rightToLeft ? 'right' : 'left';
  // create viewport & slider
  this.viewport = document.createElement('div');
  this.viewport.className = 'flickity-viewport';
  this._createSlider();

  if ( this.options.resize || this.options.watchCSS ) {
    window.addEventListener( 'resize', this );
  }

  // add listeners from on option
  for ( var eventName in this.options.on ) {
    var listener = this.options.on[ eventName ];
    this.on( eventName, listener );
  }

  Flickity.createMethods.forEach( function( method ) {
    this[ method ]();
  }, this );

  if ( this.options.watchCSS ) {
    this.watchCSS();
  } else {
    this.activate();
  }

};

/**
 * set options
 * @param {Object} opts - options to extend
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

proto.activate = function() {
  if ( this.isActive ) {
    return;
  }
  this.isActive = true;
  this.element.classList.add('flickity-enabled');
  if ( this.options.rightToLeft ) {
    this.element.classList.add('flickity-rtl');
  }

  this.getSize();
  // move initial cell elements so they can be loaded as cells
  var cellElems = this._filterFindCellElements( this.element.children );
  moveElements( cellElems, this.slider );
  this.viewport.appendChild( this.slider );
  this.element.appendChild( this.viewport );
  // get cells from children
  this.reloadCells();

  if ( this.options.accessibility ) {
    // allow element to focusable
    this.element.tabIndex = 0;
    // listen for key presses
    this.element.addEventListener( 'keydown', this );
  }

  this.emitEvent('activate');
  this.selectInitialIndex();
  // flag for initial activation, for using initialIndex
  this.isInitActivated = true;
  // ready event. #493
  this.dispatchEvent('ready');
};

// slider positions the cells
proto._createSlider = function() {
  // slider element does all the positioning
  var slider = document.createElement('div');
  slider.className = 'flickity-slider';
  slider.style[ this.originSide ] = 0;
  this.slider = slider;
};

proto._filterFindCellElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.cellSelector );
};

// goes through all children
proto.reloadCells = function() {
  // collection of item elements
  this.cells = this._makeCells( this.slider.children );
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
};

/**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */
proto._makeCells = function( elems ) {
  var cellElems = this._filterFindCellElements( elems );

  // create new Flickity for collection
  var cells = cellElems.map( function( cellElem ) {
    return new Cell( cellElem, this );
  }, this );

  return cells;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.getLastSlide = function() {
  return this.slides[ this.slides.length - 1 ];
};

// positions all cells
proto.positionCells = function() {
  // size all cells
  this._sizeCells( this.cells );
  // position all cells
  this._positionCells( 0 );
};

/**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */
proto._positionCells = function( index ) {
  index = index || 0;
  // also measure maxCellHeight
  // start 0 if positioning all cells
  this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
  var cellX = 0;
  // get cellX
  if ( index > 0 ) {
    var startCell = this.cells[ index - 1 ];
    cellX = startCell.x + startCell.size.outerWidth;
  }
  var len = this.cells.length;
  for ( var i = index; i < len; i++ ) {
    var cell = this.cells[i];
    cell.setPosition( cellX );
    cellX += cell.size.outerWidth;
    this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
  }
  // keep track of cellX for wrap-around
  this.slideableWidth = cellX;
  // slides
  this.updateSlides();
  // contain slides target
  this._containSlides();
  // update slidesWidth
  this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
};

/**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */
proto._sizeCells = function( cells ) {
  cells.forEach( function( cell ) {
    cell.getSize();
  } );
};

// --------------------------  -------------------------- //

proto.updateSlides = function() {
  this.slides = [];
  if ( !this.cells.length ) {
    return;
  }

  var slide = new Slide( this );
  this.slides.push( slide );
  var isOriginLeft = this.originSide == 'left';
  var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

  var canCellFit = this._getCanCellFit();

  this.cells.forEach( function( cell, i ) {
    // just add cell if first cell in slide
    if ( !slide.cells.length ) {
      slide.addCell( cell );
      return;
    }

    var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
      ( cell.size.outerWidth - cell.size[ nextMargin ] );

    if ( canCellFit.call( this, i, slideWidth ) ) {
      slide.addCell( cell );
    } else {
      // doesn't fit, new slide
      slide.updateTarget();

      slide = new Slide( this );
      this.slides.push( slide );
      slide.addCell( cell );
    }
  }, this );
  // last slide
  slide.updateTarget();
  // update .selectedSlide
  this.updateSelectedSlide();
};

proto._getCanCellFit = function() {
  var groupCells = this.options.groupCells;
  if ( !groupCells ) {
    return function() {
      return false;
    };
  } else if ( typeof groupCells == 'number' ) {
    // group by number. 3 -> [0,1,2], [3,4,5], ...
    var number = parseInt( groupCells, 10 );
    return function( i ) {
      return ( i % number ) !== 0;
    };
  }
  // default, group by width of slide
  // parse '75%
  var percentMatch = typeof groupCells == 'string' &&
    groupCells.match( /^(\d+)%$/ );
  var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
  return function( i, slideWidth ) {
    /* eslint-disable-next-line no-invalid-this */
    return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
  };
};

// alias _init for jQuery plugin .flickity()
proto._init =
proto.reposition = function() {
  this.positionCells();
  this.positionSliderAtSelected();
};

proto.getSize = function() {
  this.size = getSize( this.element );
  this.setCellAlign();
  this.cursorPosition = this.size.innerWidth * this.cellAlign;
};

var cellAlignShorthands = {
  // cell align, then based on origin side
  center: {
    left: 0.5,
    right: 0.5,
  },
  left: {
    left: 0,
    right: 1,
  },
  right: {
    right: 0,
    left: 1,
  },
};

proto.setCellAlign = function() {
  var shorthand = cellAlignShorthands[ this.options.cellAlign ];
  this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
};

proto.setGallerySize = function() {
  if ( this.options.setGallerySize ) {
    var height = this.options.adaptiveHeight && this.selectedSlide ?
      this.selectedSlide.height : this.maxCellHeight;
    this.viewport.style.height = height + 'px';
  }
};

proto._getWrapShiftCells = function() {
  // only for wrap-around
  if ( !this.options.wrapAround ) {
    return;
  }
  // unshift previous cells
  this._unshiftCells( this.beforeShiftCells );
  this._unshiftCells( this.afterShiftCells );
  // get before cells
  // initial gap
  var gapX = this.cursorPosition;
  var cellIndex = this.cells.length - 1;
  this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
  // get after cells
  // ending gap between last cell and end of gallery viewport
  gapX = this.size.innerWidth - this.cursorPosition;
  // start cloning at first cell, working forwards
  this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
};

proto._getGapCells = function( gapX, cellIndex, increment ) {
  // keep adding cells until the cover the initial gap
  var cells = [];
  while ( gapX > 0 ) {
    var cell = this.cells[ cellIndex ];
    if ( !cell ) {
      break;
    }
    cells.push( cell );
    cellIndex += increment;
    gapX -= cell.size.outerWidth;
  }
  return cells;
};

// ----- contain ----- //

// contain cell targets so no excess sliding
proto._containSlides = function() {
  if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
    return;
  }
  var isRightToLeft = this.options.rightToLeft;
  var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
  var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
  var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
  // content is less than gallery size
  var isContentSmaller = contentWidth < this.size.innerWidth;
  // bounds
  var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
  var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
  // contain each cell target
  this.slides.forEach( function( slide ) {
    if ( isContentSmaller ) {
      // all cells fit inside gallery
      slide.target = contentWidth * this.cellAlign;
    } else {
      // contain to bounds
      slide.target = Math.max( slide.target, beginBound );
      slide.target = Math.min( slide.target, endBound );
    }
  }, this );
};

// -----  ----- //

/**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery && this.$element ) {
    // default trigger with type if no event
    type += this.options.namespaceJQueryEvents ? '.flickity' : '';
    var $event = type;
    if ( event ) {
      // create jQuery event
      var jQEvent = new jQuery.Event( event );
      jQEvent.type = type;
      $event = jQEvent;
    }
    this.$element.trigger( $event, args );
  }
};

// -------------------------- select -------------------------- //

/**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */
proto.select = function( index, isWrap, isInstant ) {
  if ( !this.isActive ) {
    return;
  }
  index = parseInt( index, 10 );
  this._wrapSelect( index );

  if ( this.options.wrapAround || isWrap ) {
    index = utils.modulo( index, this.slides.length );
  }
  // bail if invalid index
  if ( !this.slides[ index ] ) {
    return;
  }
  var prevIndex = this.selectedIndex;
  this.selectedIndex = index;
  this.updateSelectedSlide();
  if ( isInstant ) {
    this.positionSliderAtSelected();
  } else {
    this.startAnimation();
  }
  if ( this.options.adaptiveHeight ) {
    this.setGallerySize();
  }
  // events
  this.dispatchEvent( 'select', null, [ index ] );
  // change event if new index
  if ( index != prevIndex ) {
    this.dispatchEvent( 'change', null, [ index ] );
  }
  // old v1 event name, remove in v3
  this.dispatchEvent('cellSelect');
};

// wraps position for wrapAround, to move to closest slide. #113
proto._wrapSelect = function( index ) {
  var len = this.slides.length;
  var isWrapping = this.options.wrapAround && len > 1;
  if ( !isWrapping ) {
    return index;
  }
  var wrapIndex = utils.modulo( index, len );
  // go to shortest
  var delta = Math.abs( wrapIndex - this.selectedIndex );
  var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
  var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
  if ( !this.isDragSelect && backWrapDelta < delta ) {
    index += len;
  } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
    index -= len;
  }
  // wrap position so slider is within normal area
  if ( index < 0 ) {
    this.x -= this.slideableWidth;
  } else if ( index >= len ) {
    this.x += this.slideableWidth;
  }
};

proto.previous = function( isWrap, isInstant ) {
  this.select( this.selectedIndex - 1, isWrap, isInstant );
};

proto.next = function( isWrap, isInstant ) {
  this.select( this.selectedIndex + 1, isWrap, isInstant );
};

proto.updateSelectedSlide = function() {
  var slide = this.slides[ this.selectedIndex ];
  // selectedIndex could be outside of slides, if triggered before resize()
  if ( !slide ) {
    return;
  }
  // unselect previous selected slide
  this.unselectSelectedSlide();
  // update new selected slide
  this.selectedSlide = slide;
  slide.select();
  this.selectedCells = slide.cells;
  this.selectedElements = slide.getCellElements();
  // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
  // Remove in v3?
  this.selectedCell = slide.cells[0];
  this.selectedElement = this.selectedElements[0];
};

proto.unselectSelectedSlide = function() {
  if ( this.selectedSlide ) {
    this.selectedSlide.unselect();
  }
};

proto.selectInitialIndex = function() {
  var initialIndex = this.options.initialIndex;
  // already activated, select previous selectedIndex
  if ( this.isInitActivated ) {
    this.select( this.selectedIndex, false, true );
    return;
  }
  // select with selector string
  if ( initialIndex && typeof initialIndex == 'string' ) {
    var cell = this.queryCell( initialIndex );
    if ( cell ) {
      this.selectCell( initialIndex, false, true );
      return;
    }
  }

  var index = 0;
  // select with number
  if ( initialIndex && this.slides[ initialIndex ] ) {
    index = initialIndex;
  }
  // select instantly
  this.select( index, false, true );
};

/**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */
proto.selectCell = function( value, isWrap, isInstant ) {
  // get cell
  var cell = this.queryCell( value );
  if ( !cell ) {
    return;
  }

  var index = this.getCellSlideIndex( cell );
  this.select( index, isWrap, isInstant );
};

proto.getCellSlideIndex = function( cell ) {
  // get index of slides that has cell
  for ( var i = 0; i < this.slides.length; i++ ) {
    var slide = this.slides[i];
    var index = slide.cells.indexOf( cell );
    if ( index != -1 ) {
      return i;
    }
  }
};

// -------------------------- get cells -------------------------- //

/**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */
proto.getCell = function( elem ) {
  // loop through cells to get the one that matches
  for ( var i = 0; i < this.cells.length; i++ ) {
    var cell = this.cells[i];
    if ( cell.element == elem ) {
      return cell;
    }
  }
};

/**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */
proto.getCells = function( elems ) {
  elems = utils.makeArray( elems );
  var cells = [];
  elems.forEach( function( elem ) {
    var cell = this.getCell( elem );
    if ( cell ) {
      cells.push( cell );
    }
  }, this );
  return cells;
};

/**
 * get cell elements
 * @returns {Array} cellElems
 */
proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  } );
};

/**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */
proto.getParentCell = function( elem ) {
  // first check if elem is cell
  var cell = this.getCell( elem );
  if ( cell ) {
    return cell;
  }
  // try to get parent cell elem
  elem = utils.getParent( elem, '.flickity-slider > *' );
  return this.getCell( elem );
};

/**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */
proto.getAdjacentCellElements = function( adjCount, index ) {
  if ( !adjCount ) {
    return this.selectedSlide.getCellElements();
  }
  index = index === undefined ? this.selectedIndex : index;

  var len = this.slides.length;
  if ( 1 + ( adjCount * 2 ) >= len ) {
    return this.getCellElements();
  }

  var cellElems = [];
  for ( var i = index - adjCount; i <= index + adjCount; i++ ) {
    var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
    var slide = this.slides[ slideIndex ];
    if ( slide ) {
      cellElems = cellElems.concat( slide.getCellElements() );
    }
  }
  return cellElems;
};

/**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */
proto.queryCell = function( selector ) {
  if ( typeof selector == 'number' ) {
    // use number as index
    return this.cells[ selector ];
  }
  if ( typeof selector == 'string' ) {
    // do not select invalid selectors from hash: #123, #/. #791
    if ( selector.match( /^[#.]?[\d/]/ ) ) {
      return;
    }
    // use string as selector, get element
    selector = this.element.querySelector( selector );
  }
  // get cell from element
  return this.getCell( selector );
};

// -------------------------- events -------------------------- //

proto.uiChange = function() {
  this.emitEvent('uiChange');
};

// keep focus on element when child UI elements are clicked
proto.childUIPointerDown = function( event ) {
  // HACK iOS does not allow touch events to bubble up?!
  if ( event.type != 'touchstart' ) {
    event.preventDefault();
  }
  this.focus();
};

// ----- resize ----- //

proto.onresize = function() {
  this.watchCSS();
  this.resize();
};

utils.debounceMethod( Flickity, 'onresize', 150 );

proto.resize = function() {
  // #1177 disable resize behavior when animating or dragging for iOS 15
  if ( !this.isActive || this.isAnimating || this.isDragging ) {
    return;
  }
  this.getSize();
  // wrap values
  if ( this.options.wrapAround ) {
    this.x = utils.modulo( this.x, this.slideableWidth );
  }
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
  this.emitEvent('resize');
  // update selected index for group slides, instant
  // TODO: position can be lost between groups of various numbers
  var selectedElement = this.selectedElements && this.selectedElements[0];
  this.selectCell( selectedElement, false, true );
};

// watches the :after property, activates/deactivates
proto.watchCSS = function() {
  var watchOption = this.options.watchCSS;
  if ( !watchOption ) {
    return;
  }

  var afterContent = getComputedStyle( this.element, ':after' ).content;
  // activate if :after { content: 'flickity' }
  if ( afterContent.indexOf('flickity') != -1 ) {
    this.activate();
  } else {
    this.deactivate();
  }
};

// ----- keydown ----- //

// go previous/next if left/right keys pressed
proto.onkeydown = function( event ) {
  // only work if element is in focus
  var isNotFocused = document.activeElement && document.activeElement != this.element;
  if ( !this.options.accessibility || isNotFocused ) {
    return;
  }

  var handler = Flickity.keyboardHandlers[ event.keyCode ];
  if ( handler ) {
    handler.call( this );
  }
};

Flickity.keyboardHandlers = {
  // left arrow
  37: function() {
    var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
    this.uiChange();
    this[ leftMethod ]();
  },
  // right arrow
  39: function() {
    var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
    this.uiChange();
    this[ rightMethod ]();
  },
};

// ----- focus ----- //

proto.focus = function() {
  // TODO remove scrollTo once focus options gets more support
  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
  //    #Browser_compatibility
  var prevScrollY = window.pageYOffset;
  this.element.focus({ preventScroll: true });
  // hack to fix scroll jump after focus, #76
  if ( window.pageYOffset != prevScrollY ) {
    window.scrollTo( window.pageXOffset, prevScrollY );
  }
};

// -------------------------- destroy -------------------------- //

// deactivate all Flickity functionality, but keep stuff available
proto.deactivate = function() {
  if ( !this.isActive ) {
    return;
  }
  this.element.classList.remove('flickity-enabled');
  this.element.classList.remove('flickity-rtl');
  this.unselectSelectedSlide();
  // destroy cells
  this.cells.forEach( function( cell ) {
    cell.destroy();
  } );
  this.element.removeChild( this.viewport );
  // move child elements back into element
  moveElements( this.slider.children, this.element );
  if ( this.options.accessibility ) {
    this.element.removeAttribute('tabIndex');
    this.element.removeEventListener( 'keydown', this );
  }
  // set flags
  this.isActive = false;
  this.emitEvent('deactivate');
};

proto.destroy = function() {
  this.deactivate();
  window.removeEventListener( 'resize', this );
  this.allOff();
  this.emitEvent('destroy');
  if ( jQuery && this.$element ) {
    jQuery.removeData( this.element, 'flickity' );
  }
  delete this.element.flickityGUID;
  delete instances[ this.guid ];
};

// -------------------------- prototype -------------------------- //

utils.extend( proto, animatePrototype );

// -------------------------- extras -------------------------- //

/**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */
Flickity.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.flickityGUID;
  return id && instances[ id ];
};

utils.htmlInit( Flickity, 'flickity' );

if ( jQuery && jQuery.bridget ) {
  jQuery.bridget( 'flickity', Flickity );
}

// set internal jQuery, for Webpack + jQuery v3, #478
Flickity.setJQuery = function( jq ) {
  jQuery = jq;
};

Flickity.Cell = Cell;
Flickity.Slide = Slide;

return Flickity;

} ) );


/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Flickity v2.3.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */

( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(249),
      __webpack_require__(170),
      __webpack_require__(824),
      __webpack_require__(728),
      __webpack_require__(453),
      __webpack_require__(943),
      __webpack_require__(766),
    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

} )( window, function factory( Flickity ) {
  return Flickity;
} );


/***/ }),

/***/ 766:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// lazyload
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(249),
      __webpack_require__(977),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

}( window, function factory( window, Flickity, utils ) {
'use strict';

Flickity.createMethods.push('_createLazyload');
var proto = Flickity.prototype;

proto._createLazyload = function() {
  this.on( 'select', this.lazyLoad );
};

proto.lazyLoad = function() {
  var lazyLoad = this.options.lazyLoad;
  if ( !lazyLoad ) {
    return;
  }
  // get adjacent cells, use lazyLoad option for adjacent count
  var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
  var cellElems = this.getAdjacentCellElements( adjCount );
  // get lazy images in those cells
  var lazyImages = [];
  cellElems.forEach( function( cellElem ) {
    var lazyCellImages = getCellLazyImages( cellElem );
    lazyImages = lazyImages.concat( lazyCellImages );
  } );
  // load lazy images
  lazyImages.forEach( function( img ) {
    new LazyLoader( img, this );
  }, this );
};

function getCellLazyImages( cellElem ) {
  // check if cell element is lazy image
  if ( cellElem.nodeName == 'IMG' ) {
    var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
    var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
    var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
    if ( lazyloadAttr || srcAttr || srcsetAttr ) {
      return [ cellElem ];
    }
  }
  // select lazy images in cell
  var lazySelector = 'img[data-flickity-lazyload], ' +
    'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
  var imgs = cellElem.querySelectorAll( lazySelector );
  return utils.makeArray( imgs );
}

// -------------------------- LazyLoader -------------------------- //

/**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Flickity} flickity - Flickity instance
 */
function LazyLoader( img, flickity ) {
  this.img = img;
  this.flickity = flickity;
  this.load();
}

LazyLoader.prototype.handleEvent = utils.handleEvent;

LazyLoader.prototype.load = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  // get src & srcset
  var src = this.img.getAttribute('data-flickity-lazyload') ||
    this.img.getAttribute('data-flickity-lazyload-src');
  var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
  // set src & serset
  this.img.src = src;
  if ( srcset ) {
    this.img.setAttribute( 'srcset', srcset );
  }
  // remove attr
  this.img.removeAttribute('data-flickity-lazyload');
  this.img.removeAttribute('data-flickity-lazyload-src');
  this.img.removeAttribute('data-flickity-lazyload-srcset');
};

LazyLoader.prototype.onload = function( event ) {
  this.complete( event, 'flickity-lazyloaded' );
};

LazyLoader.prototype.onerror = function( event ) {
  this.complete( event, 'flickity-lazyerror' );
};

LazyLoader.prototype.complete = function( event, className ) {
  // unbind events
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );

  var cell = this.flickity.getParentCell( this.img );
  var cellElem = cell && cell.element;
  this.flickity.cellSizeChange( cellElem );

  this.img.classList.add( className );
  this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
};

// -----  ----- //

Flickity.LazyLoader = LazyLoader;

return Flickity;

} ) );


/***/ }),

/***/ 728:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// page dots
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(249),
      __webpack_require__(475),
      __webpack_require__(977),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, Unipointer, utils ) {
      return factory( window, Flickity, Unipointer, utils );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

}( window, function factory( window, Flickity, Unipointer, utils ) {

// -------------------------- PageDots -------------------------- //

'use strict';

function PageDots( parent ) {
  this.parent = parent;
  this._create();
}

PageDots.prototype = Object.create( Unipointer.prototype );

PageDots.prototype._create = function() {
  // create holder element
  this.holder = document.createElement('ol');
  this.holder.className = 'flickity-page-dots';
  // create dots, array of elements
  this.dots = [];
  // events
  this.handleClick = this.onClick.bind( this );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PageDots.prototype.activate = function() {
  this.setDots();
  this.holder.addEventListener( 'click', this.handleClick );
  this.bindStartEvent( this.holder );
  // add to DOM
  this.parent.element.appendChild( this.holder );
};

PageDots.prototype.deactivate = function() {
  this.holder.removeEventListener( 'click', this.handleClick );
  this.unbindStartEvent( this.holder );
  // remove from DOM
  this.parent.element.removeChild( this.holder );
};

PageDots.prototype.setDots = function() {
  // get difference between number of slides and number of dots
  var delta = this.parent.slides.length - this.dots.length;
  if ( delta > 0 ) {
    this.addDots( delta );
  } else if ( delta < 0 ) {
    this.removeDots( -delta );
  }
};

PageDots.prototype.addDots = function( count ) {
  var fragment = document.createDocumentFragment();
  var newDots = [];
  var length = this.dots.length;
  var max = length + count;

  for ( var i = length; i < max; i++ ) {
    var dot = document.createElement('li');
    dot.className = 'dot';
    dot.setAttribute( 'aria-label', 'Page dot ' + ( i + 1 ) );
    fragment.appendChild( dot );
    newDots.push( dot );
  }

  this.holder.appendChild( fragment );
  this.dots = this.dots.concat( newDots );
};

PageDots.prototype.removeDots = function( count ) {
  // remove from this.dots collection
  var removeDots = this.dots.splice( this.dots.length - count, count );
  // remove from DOM
  removeDots.forEach( function( dot ) {
    this.holder.removeChild( dot );
  }, this );
};

PageDots.prototype.updateSelected = function() {
  // remove selected class on previous
  if ( this.selectedDot ) {
    this.selectedDot.className = 'dot';
    this.selectedDot.removeAttribute('aria-current');
  }
  // don't proceed if no dots
  if ( !this.dots.length ) {
    return;
  }
  this.selectedDot = this.dots[ this.parent.selectedIndex ];
  this.selectedDot.className = 'dot is-selected';
  this.selectedDot.setAttribute( 'aria-current', 'step' );
};

PageDots.prototype.onTap = // old method name, backwards-compatible
PageDots.prototype.onClick = function( event ) {
  var target = event.target;
  // only care about dot clicks
  if ( target.nodeName != 'LI' ) {
    return;
  }

  this.parent.uiChange();
  var index = this.dots.indexOf( target );
  this.parent.select( index );
};

PageDots.prototype.destroy = function() {
  this.deactivate();
  this.allOff();
};

Flickity.PageDots = PageDots;

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pageDots: true,
} );

Flickity.createMethods.push('_createPageDots');

var proto = Flickity.prototype;

proto._createPageDots = function() {
  if ( !this.options.pageDots ) {
    return;
  }
  this.pageDots = new PageDots( this );
  // events
  this.on( 'activate', this.activatePageDots );
  this.on( 'select', this.updateSelectedPageDots );
  this.on( 'cellChange', this.updatePageDots );
  this.on( 'resize', this.updatePageDots );
  this.on( 'deactivate', this.deactivatePageDots );
};

proto.activatePageDots = function() {
  this.pageDots.activate();
};

proto.updateSelectedPageDots = function() {
  this.pageDots.updateSelected();
};

proto.updatePageDots = function() {
  this.pageDots.setDots();
};

proto.deactivatePageDots = function() {
  this.pageDots.deactivate();
};

// -----  ----- //

Flickity.PageDots = PageDots;

return Flickity;

} ) );


/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// player & autoPlay
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(137),
      __webpack_require__(977),
      __webpack_require__(249),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter, utils, Flickity ) {
      return factory( EvEmitter, utils, Flickity );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

}( window, function factory( EvEmitter, utils, Flickity ) {

'use strict';

// -------------------------- Player -------------------------- //

function Player( parent ) {
  this.parent = parent;
  this.state = 'stopped';
  // visibility change event handler
  this.onVisibilityChange = this.visibilityChange.bind( this );
  this.onVisibilityPlay = this.visibilityPlay.bind( this );
}

Player.prototype = Object.create( EvEmitter.prototype );

// start play
Player.prototype.play = function() {
  if ( this.state == 'playing' ) {
    return;
  }
  // do not play if page is hidden, start playing when page is visible
  var isPageHidden = document.hidden;
  if ( isPageHidden ) {
    document.addEventListener( 'visibilitychange', this.onVisibilityPlay );
    return;
  }

  this.state = 'playing';
  // listen to visibility change
  document.addEventListener( 'visibilitychange', this.onVisibilityChange );
  // start ticking
  this.tick();
};

Player.prototype.tick = function() {
  // do not tick if not playing
  if ( this.state != 'playing' ) {
    return;
  }

  var time = this.parent.options.autoPlay;
  // default to 3 seconds
  time = typeof time == 'number' ? time : 3000;
  var _this = this;
  // HACK: reset ticks if stopped and started within interval
  this.clear();
  this.timeout = setTimeout( function() {
    _this.parent.next( true );
    _this.tick();
  }, time );
};

Player.prototype.stop = function() {
  this.state = 'stopped';
  this.clear();
  // remove visibility change event
  document.removeEventListener( 'visibilitychange', this.onVisibilityChange );
};

Player.prototype.clear = function() {
  clearTimeout( this.timeout );
};

Player.prototype.pause = function() {
  if ( this.state == 'playing' ) {
    this.state = 'paused';
    this.clear();
  }
};

Player.prototype.unpause = function() {
  // re-start play if paused
  if ( this.state == 'paused' ) {
    this.play();
  }
};

// pause if page visibility is hidden, unpause if visible
Player.prototype.visibilityChange = function() {
  var isPageHidden = document.hidden;
  this[ isPageHidden ? 'pause' : 'unpause' ]();
};

Player.prototype.visibilityPlay = function() {
  this.play();
  document.removeEventListener( 'visibilitychange', this.onVisibilityPlay );
};

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pauseAutoPlayOnHover: true,
} );

Flickity.createMethods.push('_createPlayer');
var proto = Flickity.prototype;

proto._createPlayer = function() {
  this.player = new Player( this );

  this.on( 'activate', this.activatePlayer );
  this.on( 'uiChange', this.stopPlayer );
  this.on( 'pointerDown', this.stopPlayer );
  this.on( 'deactivate', this.deactivatePlayer );
};

proto.activatePlayer = function() {
  if ( !this.options.autoPlay ) {
    return;
  }
  this.player.play();
  this.element.addEventListener( 'mouseenter', this );
};

// Player API, don't hate the ... thanks I know where the door is

proto.playPlayer = function() {
  this.player.play();
};

proto.stopPlayer = function() {
  this.player.stop();
};

proto.pausePlayer = function() {
  this.player.pause();
};

proto.unpausePlayer = function() {
  this.player.unpause();
};

proto.deactivatePlayer = function() {
  this.player.stop();
  this.element.removeEventListener( 'mouseenter', this );
};

// ----- mouseenter/leave ----- //

// pause auto-play on hover
proto.onmouseenter = function() {
  if ( !this.options.pauseAutoPlayOnHover ) {
    return;
  }
  this.player.pause();
  this.element.addEventListener( 'mouseleave', this );
};

// resume auto-play on hover off
proto.onmouseleave = function() {
  this.player.unpause();
  this.element.removeEventListener( 'mouseleave', this );
};

// -----  ----- //

Flickity.Player = Player;

return Flickity;

} ) );


/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// prev/next buttons
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(249),
      __webpack_require__(475),
      __webpack_require__(977),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, Unipointer, utils ) {
      return factory( window, Flickity, Unipointer, utils );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

}( window, function factory( window, Flickity, Unipointer, utils ) {
'use strict';

var svgURI = 'http://www.w3.org/2000/svg';

// -------------------------- PrevNextButton -------------------------- //

function PrevNextButton( direction, parent ) {
  this.direction = direction;
  this.parent = parent;
  this._create();
}

PrevNextButton.prototype = Object.create( Unipointer.prototype );

PrevNextButton.prototype._create = function() {
  // properties
  this.isEnabled = true;
  this.isPrevious = this.direction == -1;
  var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
  this.isLeft = this.direction == leftDirection;

  var element = this.element = document.createElement('button');
  element.className = 'flickity-button flickity-prev-next-button';
  element.className += this.isPrevious ? ' previous' : ' next';
  // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
  element.setAttribute( 'type', 'button' );
  // init as disabled
  this.disable();

  element.setAttribute( 'aria-label', this.isPrevious ? 'Previous' : 'Next' );

  // create arrow
  var svg = this.createSVG();
  element.appendChild( svg );
  // events
  this.parent.on( 'select', this.update.bind( this ) );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PrevNextButton.prototype.activate = function() {
  this.bindStartEvent( this.element );
  this.element.addEventListener( 'click', this );
  // add to DOM
  this.parent.element.appendChild( this.element );
};

PrevNextButton.prototype.deactivate = function() {
  // remove from DOM
  this.parent.element.removeChild( this.element );
  // click events
  this.unbindStartEvent( this.element );
  this.element.removeEventListener( 'click', this );
};

PrevNextButton.prototype.createSVG = function() {
  var svg = document.createElementNS( svgURI, 'svg' );
  svg.setAttribute( 'class', 'flickity-button-icon' );
  svg.setAttribute( 'viewBox', '0 0 100 100' );
  var path = document.createElementNS( svgURI, 'path' );
  var pathMovements = getArrowMovements( this.parent.options.arrowShape );
  path.setAttribute( 'd', pathMovements );
  path.setAttribute( 'class', 'arrow' );
  // rotate arrow
  if ( !this.isLeft ) {
    path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
  }
  svg.appendChild( path );
  return svg;
};

// get SVG path movmement
function getArrowMovements( shape ) {
  // use shape as movement if string
  if ( typeof shape == 'string' ) {
    return shape;
  }
  // create movement string
  return 'M ' + shape.x0 + ',50' +
    ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
    ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
    ' L ' + shape.x3 + ',50 ' +
    ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
    ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
    ' Z';
}

PrevNextButton.prototype.handleEvent = utils.handleEvent;

PrevNextButton.prototype.onclick = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.parent.uiChange();
  var method = this.isPrevious ? 'previous' : 'next';
  this.parent[ method ]();
};

// -----  ----- //

PrevNextButton.prototype.enable = function() {
  if ( this.isEnabled ) {
    return;
  }
  this.element.disabled = false;
  this.isEnabled = true;
};

PrevNextButton.prototype.disable = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.element.disabled = true;
  this.isEnabled = false;
};

PrevNextButton.prototype.update = function() {
  // index of first or last slide, if previous or next
  var slides = this.parent.slides;
  // enable is wrapAround and at least 2 slides
  if ( this.parent.options.wrapAround && slides.length > 1 ) {
    this.enable();
    return;
  }
  var lastIndex = slides.length ? slides.length - 1 : 0;
  var boundIndex = this.isPrevious ? 0 : lastIndex;
  var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
  this[ method ]();
};

PrevNextButton.prototype.destroy = function() {
  this.deactivate();
  this.allOff();
};

// -------------------------- Flickity prototype -------------------------- //

utils.extend( Flickity.defaults, {
  prevNextButtons: true,
  arrowShape: {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30,
  },
} );

Flickity.createMethods.push('_createPrevNextButtons');
var proto = Flickity.prototype;

proto._createPrevNextButtons = function() {
  if ( !this.options.prevNextButtons ) {
    return;
  }

  this.prevButton = new PrevNextButton( -1, this );
  this.nextButton = new PrevNextButton( 1, this );

  this.on( 'activate', this.activatePrevNextButtons );
};

proto.activatePrevNextButtons = function() {
  this.prevButton.activate();
  this.nextButton.activate();
  this.on( 'deactivate', this.deactivatePrevNextButtons );
};

proto.deactivatePrevNextButtons = function() {
  this.prevButton.deactivate();
  this.nextButton.deactivate();
  this.off( 'deactivate', this.deactivatePrevNextButtons );
};

// --------------------------  -------------------------- //

Flickity.PrevNextButton = PrevNextButton;

return Flickity;

} ) );


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// slide
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

}( window, function factory() {
'use strict';

function Slide( parent ) {
  this.parent = parent;
  this.isOriginLeft = parent.originSide == 'left';
  this.cells = [];
  this.outerWidth = 0;
  this.height = 0;
}

var proto = Slide.prototype;

proto.addCell = function( cell ) {
  this.cells.push( cell );
  this.outerWidth += cell.size.outerWidth;
  this.height = Math.max( cell.size.outerHeight, this.height );
  // first cell stuff
  if ( this.cells.length == 1 ) {
    this.x = cell.x; // x comes from first cell
    var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
    this.firstMargin = cell.size[ beginMargin ];
  }
};

proto.updateTarget = function() {
  var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
  var lastCell = this.getLastCell();
  var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
  var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
  this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.select = function() {
  this.cells.forEach( function( cell ) {
    cell.select();
  } );
};

proto.unselect = function() {
  this.cells.forEach( function( cell ) {
    cell.unselect();
  } );
};

proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  } );
};

return Slide;

} ) );


/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

( function( window, factory ) {
  /* jshint strict: false */ /* globals define, module */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See https://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );
  // round value for browser zoom. desandro/masonry#928
  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
  getSize.isBoxSizeOuter = isBoxSizeOuter;

  body.removeChild( div );
}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});


/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Unidragger v2.4.0
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(475)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Unipointer ) {
      return factory( window, Unipointer );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

}( window, function factory( window, Unipointer ) {

'use strict';

// -------------------------- Unidragger -------------------------- //

function Unidragger() {}

// inherit Unipointer & EvEmitter
var proto = Unidragger.prototype = Object.create( Unipointer.prototype );

// ----- bind start ----- //

proto.bindHandles = function() {
  this._bindHandles( true );
};

proto.unbindHandles = function() {
  this._bindHandles( false );
};

/**
 * Add or remove start event
 * @param {Boolean} isAdd
 */
proto._bindHandles = function( isAdd ) {
  // munge isAdd, default to true
  isAdd = isAdd === undefined ? true : isAdd;
  // bind each handle
  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
  var touchAction = isAdd ? this._touchActionValue : '';
  for ( var i=0; i < this.handles.length; i++ ) {
    var handle = this.handles[i];
    this._bindStartEvent( handle, isAdd );
    handle[ bindMethod ]( 'click', this );
    // touch-action: none to override browser touch gestures. metafizzy/flickity#540
    if ( window.PointerEvent ) {
      handle.style.touchAction = touchAction;
    }
  }
};

// prototype so it can be overwriteable by Flickity
proto._touchActionValue = 'none';

// ----- start event ----- //

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerDown = function( event, pointer ) {
  var isOkay = this.okayPointerDown( event );
  if ( !isOkay ) {
    return;
  }
  // track start event position
  // Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
  this.pointerDownPointer = {
    pageX: pointer.pageX,
    pageY: pointer.pageY,
  };

  event.preventDefault();
  this.pointerDownBlur();
  // bind move and end events
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// nodes that have text fields
var cursorNodes = {
  TEXTAREA: true,
  INPUT: true,
  SELECT: true,
  OPTION: true,
};

// input types that do not have text fields
var clickTypes = {
  radio: true,
  checkbox: true,
  button: true,
  submit: true,
  image: true,
  file: true,
};

// dismiss inputs with text fields. flickity#403, flickity#404
proto.okayPointerDown = function( event ) {
  var isCursorNode = cursorNodes[ event.target.nodeName ];
  var isClickType = clickTypes[ event.target.type ];
  var isOkay = !isCursorNode || isClickType;
  if ( !isOkay ) {
    this._pointerReset();
  }
  return isOkay;
};

// kludge to blur previously focused input
proto.pointerDownBlur = function() {
  var focused = document.activeElement;
  // do not blur body for IE10, metafizzy/flickity#117
  var canBlur = focused && focused.blur && focused != document.body;
  if ( canBlur ) {
    focused.blur();
  }
};

// ----- move event ----- //

/**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

// base pointer move logic
proto._dragPointerMove = function( event, pointer ) {
  var moveVector = {
    x: pointer.pageX - this.pointerDownPointer.pageX,
    y: pointer.pageY - this.pointerDownPointer.pageY
  };
  // start drag if pointer has moved far enough to start drag
  if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
    this._dragStart( event, pointer );
  }
  return moveVector;
};

// condition if pointer has moved far enough to start drag
proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
};

// ----- end event ----- //

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
  this._dragPointerUp( event, pointer );
};

proto._dragPointerUp = function( event, pointer ) {
  if ( this.isDragging ) {
    this._dragEnd( event, pointer );
  } else {
    // pointer didn't move enough for drag to start
    this._staticClick( event, pointer );
  }
};

// -------------------------- drag -------------------------- //

// dragStart
proto._dragStart = function( event, pointer ) {
  this.isDragging = true;
  // prevent clicks
  this.isPreventingClicks = true;
  this.dragStart( event, pointer );
};

proto.dragStart = function( event, pointer ) {
  this.emitEvent( 'dragStart', [ event, pointer ] );
};

// dragMove
proto._dragMove = function( event, pointer, moveVector ) {
  // do not drag if not dragging yet
  if ( !this.isDragging ) {
    return;
  }

  this.dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  event.preventDefault();
  this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
};

// dragEnd
proto._dragEnd = function( event, pointer ) {
  // set flags
  this.isDragging = false;
  // re-enable clicking async
  setTimeout( function() {
    delete this.isPreventingClicks;
  }.bind( this ) );

  this.dragEnd( event, pointer );
};

proto.dragEnd = function( event, pointer ) {
  this.emitEvent( 'dragEnd', [ event, pointer ] );
};

// ----- onclick ----- //

// handle all clicks and prevent clicks when dragging
proto.onclick = function( event ) {
  if ( this.isPreventingClicks ) {
    event.preventDefault();
  }
};

// ----- staticClick ----- //

// triggered after pointer down & up with no/tiny movement
proto._staticClick = function( event, pointer ) {
  // ignore emulated mouse up clicks
  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
    return;
  }

  this.staticClick( event, pointer );

  // set flag for emulated clicks 300ms after touchend
  if ( event.type != 'mouseup' ) {
    this.isIgnoringMouseUp = true;
    // reset flag after 300ms
    setTimeout( function() {
      delete this.isIgnoringMouseUp;
    }.bind( this ), 400 );
  }
};

proto.staticClick = function( event, pointer ) {
  this.emitEvent( 'staticClick', [ event, pointer ] );
};

// ----- utils ----- //

Unidragger.getPointerPoint = Unipointer.getPointerPoint;

// -----  ----- //

return Unidragger;

}));


/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Unipointer v2.4.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*global define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(137)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter ) {
      return factory( window, EvEmitter );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else // removed by dead control flow
{}

}( window, function factory( window, EvEmitter ) {

'use strict';

function noop() {}

function Unipointer() {}

// inherit EvEmitter
var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );

proto.bindStartEvent = function( elem ) {
  this._bindStartEvent( elem, true );
};

proto.unbindStartEvent = function( elem ) {
  this._bindStartEvent( elem, false );
};

/**
 * Add or remove start event
 * @param {Boolean} isAdd - remove if falsey
 */
proto._bindStartEvent = function( elem, isAdd ) {
  // munge isAdd, default to true
  isAdd = isAdd === undefined ? true : isAdd;
  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

  // default to mouse events
  var startEvent = 'mousedown';
  if ( 'ontouchstart' in window ) {
    // HACK prefer Touch Events as you can preventDefault on touchstart to
    // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
    startEvent = 'touchstart';
  } else if ( window.PointerEvent ) {
    // Pointer Events
    startEvent = 'pointerdown';
  }
  elem[ bindMethod ]( startEvent, this );
};

// trigger handler methods for events
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// returns the touch that we're keeping track of
proto.getTouch = function( touches ) {
  for ( var i=0; i < touches.length; i++ ) {
    var touch = touches[i];
    if ( touch.identifier == this.pointerIdentifier ) {
      return touch;
    }
  }
};

// ----- start event ----- //

proto.onmousedown = function( event ) {
  // dismiss clicks from right or middle buttons
  var button = event.button;
  if ( button && ( button !== 0 && button !== 1 ) ) {
    return;
  }
  this._pointerDown( event, event );
};

proto.ontouchstart = function( event ) {
  this._pointerDown( event, event.changedTouches[0] );
};

proto.onpointerdown = function( event ) {
  this._pointerDown( event, event );
};

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto._pointerDown = function( event, pointer ) {
  // dismiss right click and other pointers
  // button = 0 is okay, 1-4 not
  if ( event.button || this.isPointerDown ) {
    return;
  }

  this.isPointerDown = true;
  // save pointer identifier to match up touch events
  this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;

  this.pointerDown( event, pointer );
};

proto.pointerDown = function( event, pointer ) {
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// hash of events to be bound after start event
var postStartEvents = {
  mousedown: [ 'mousemove', 'mouseup' ],
  touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
  pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
};

proto._bindPostStartEvents = function( event ) {
  if ( !event ) {
    return;
  }
  // get proper events to match start event
  var events = postStartEvents[ event.type ];
  // bind events to node
  events.forEach( function( eventName ) {
    window.addEventListener( eventName, this );
  }, this );
  // save these arguments
  this._boundPointerEvents = events;
};

proto._unbindPostStartEvents = function() {
  // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
  if ( !this._boundPointerEvents ) {
    return;
  }
  this._boundPointerEvents.forEach( function( eventName ) {
    window.removeEventListener( eventName, this );
  }, this );

  delete this._boundPointerEvents;
};

// ----- move event ----- //

proto.onmousemove = function( event ) {
  this._pointerMove( event, event );
};

proto.onpointermove = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerMove( event, event );
  }
};

proto.ontouchmove = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerMove( event, touch );
  }
};

/**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerMove = function( event, pointer ) {
  this.pointerMove( event, pointer );
};

// public
proto.pointerMove = function( event, pointer ) {
  this.emitEvent( 'pointerMove', [ event, pointer ] );
};

// ----- end event ----- //


proto.onmouseup = function( event ) {
  this._pointerUp( event, event );
};

proto.onpointerup = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerUp( event, event );
  }
};

proto.ontouchend = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerUp( event, touch );
  }
};

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerUp = function( event, pointer ) {
  this._pointerDone();
  this.pointerUp( event, pointer );
};

// public
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
};

// ----- pointer done ----- //

// triggered on pointer up & pointer cancel
proto._pointerDone = function() {
  this._pointerReset();
  this._unbindPostStartEvents();
  this.pointerDone();
};

proto._pointerReset = function() {
  // reset properties
  this.isPointerDown = false;
  delete this.pointerIdentifier;
};

proto.pointerDone = noop;

// ----- pointer cancel ----- //

proto.onpointercancel = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerCancel( event, event );
  }
};

proto.ontouchcancel = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerCancel( event, touch );
  }
};

/**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerCancel = function( event, pointer ) {
  this._pointerDone();
  this.pointerCancel( event, pointer );
};

// public
proto.pointerCancel = function( event, pointer ) {
  this.emitEvent( 'pointerCancel', [ event, pointer ] );
};

// -----  ----- //

// utility function for getting x/y coords from event
Unipointer.getPointerPoint = function( pointer ) {
  return {
    x: pointer.pageX,
    y: pointer.pageY
  };
};

// -----  ----- //

return Unipointer;

}));


/***/ }),

/***/ 669:
/***/ (function(module) {

"use strict";
module.exports = jQuery;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";

;// ./node_modules/@shopify/theme-product-form/listeners.js
function Listeners() {
  this.entries = [];
}

Listeners.prototype.add = function(element, event, fn) {
  this.entries.push({ element: element, event: event, fn: fn });
  element.addEventListener(event, fn);
};

Listeners.prototype.removeAll = function() {
  this.entries = this.entries.filter(function(listener) {
    listener.element.removeEventListener(listener.event, listener.fn);
    return false;
  });
};

;// ./node_modules/@shopify/theme-product/theme-product.js
/**
 * Returns a product JSON object when passed a product URL
 * @param {*} url
 */
function getProductJson(handle) {
  return fetch('/products/' + handle + '.js').then(function(response) {
    return response.json();
  });
}

/**
 * Find a match in the project JSON (using a ID number) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Number} value Accepts Number (e.g. 6908023078973)
 * @returns {Object} The variant object once a match has been successful. Otherwise null will be return
 */
function getVariantFromId(product, value) {
  _validateProductStructure(product);

  if (typeof value !== 'number') {
    throw new TypeError(value + ' is not a Number.');
  }

  var result = product.variants.filter(function(variant) {
    return variant.id === value;
  });

  return result[0] || null;
}

/**
 * Convert the Object (with 'name' and 'value' keys) into an Array of values, then find a match & return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Object} collection Object with 'name' and 'value' keys (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */
function getVariantFromSerializedArray(product, collection) {
  _validateProductStructure(product);

  // If value is an array of options
  var optionArray = _createOptionArrayFromOptionCollection(product, collection);
  return getVariantFromOptionArray(product, optionArray);
}

/**
 * Find a match in the project JSON (using Array with option values) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Array} options List of submitted values (e.g. ['36', 'Black'])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */
function getVariantFromOptionArray(product, options) {
  _validateProductStructure(product);
  _validateOptionsArray(options);

  var result = product.variants.filter(function(variant) {
    return options.every(function(option, index) {
      return variant.options[index] === option;
    });
  });

  return result[0] || null;
}

/**
 * Creates an array of selected options from the object
 * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
 * @param {Object} product Product JSON object
 * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
 */
function _createOptionArrayFromOptionCollection(product, collection) {
  _validateProductStructure(product);
  _validateSerializedArray(collection);

  var optionArray = [];

  collection.forEach(function(option) {
    for (var i = 0; i < product.options.length; i++) {
      if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
        optionArray[i] = option.value;
        break;
      }
    }
  });

  return optionArray;
}

/**
 * Check if the product data is a valid JS object
 * Error will be thrown if type is invalid
 * @param {object} product Product JSON object
 */
function _validateProductStructure(product) {
  if (typeof product !== 'object') {
    throw new TypeError(product + ' is not an object.');
  }

  if (Object.keys(product).length === 0 && product.constructor === Object) {
    throw new Error(product + ' is empty.');
  }
}

/**
 * Validate the structure of the array
 * It must be formatted like jQuery's serializeArray()
 * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
 */
function _validateSerializedArray(collection) {
  if (!Array.isArray(collection)) {
    throw new TypeError(collection + ' is not an array.');
  }

  if (collection.length === 0) {
    return [];
  }

  if (collection[0].hasOwnProperty('name')) {
    if (typeof collection[0].name !== 'string') {
      throw new TypeError(
        'Invalid value type passed for name of option ' +
          collection[0].name +
          '. Value should be string.'
      );
    }
  } else {
    throw new Error(collection[0] + 'does not contain name key.');
  }
}

/**
 * Validate the structure of the array
 * It must be formatted as list of values
 * @param {Array} collection Array of object (e.g. ['36', 'Black'])
 */
function _validateOptionsArray(options) {
  if (Array.isArray(options) && typeof options[0] === 'object') {
    throw new Error(options + 'is not a valid array of options.');
  }
}

;// ./node_modules/@shopify/theme-product-form/theme-product-form.js



var selectors = {
  idInput: '[name="id"]',
  optionInput: '[name^="options"]',
  quantityInput: '[name="quantity"]',
  propertyInput: '[name^="properties"]'
};

// Public Methods
// -----------------------------------------------------------------------------

/**
 * Returns a URL with a variant ID query parameter. Useful for updating window.history
 * with a new URL based on the currently select product variant.
 * @param {string} url - The URL you wish to append the variant ID to
 * @param {number} id  - The variant ID you wish to append to the URL
 * @returns {string} - The new url which includes the variant ID query parameter
 */

function getUrlWithVariant(url, id) {
  if (/variant=/.test(url)) {
    return url.replace(/(variant=)[^&]+/, '$1' + id);
  } else if (/\?/.test(url)) {
    return url.concat('&variant=').concat(id);
  }

  return url.concat('?variant=').concat(id);
}

/**
 * Constructor class that creates a new instance of a product form controller.
 *
 * @param {Element} element - DOM element which is equal to the <form> node wrapping product form inputs
 * @param {Object} product - A product object
 * @param {Object} options - Optional options object
 * @param {Function} options.onOptionChange - Callback for whenever an option input changes
 * @param {Function} options.onQuantityChange - Callback for whenever an quantity input changes
 * @param {Function} options.onPropertyChange - Callback for whenever a property input changes
 * @param {Function} options.onFormSubmit - Callback for whenever the product form is submitted
 */
function ProductForm(element, product, options) {
  this.element = element;
  this.product = _validateProductObject(product);

  options = options || {};

  this._listeners = new Listeners();
  this._listeners.add(
    this.element,
    'submit',
    this._onSubmit.bind(this, options)
  );

  this.optionInputs = this._initInputs(
    selectors.optionInput,
    options.onOptionChange
  );

  this.quantityInputs = this._initInputs(
    selectors.quantityInput,
    options.onQuantityChange
  );

  this.propertyInputs = this._initInputs(
    selectors.propertyInput,
    options.onPropertyChange
  );
}

/**
 * Cleans up all event handlers that were assigned when the Product Form was constructed.
 * Useful for use when a section needs to be reloaded in the theme editor.
 */
ProductForm.prototype.destroy = function() {
  this._listeners.removeAll();
};

/**
 * Getter method which returns the array of currently selected option values
 *
 * @returns {Array} An array of option values
 */
ProductForm.prototype.options = function() {
  return _serializeOptionValues(this.optionInputs, function(item) {
    var regex = /(?:^(options\[))(.*?)(?:\])/;
    item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
    return item;
  });
};

/**
 * Getter method which returns the currently selected variant, or `null` if variant
 * doesn't exist.
 *
 * @returns {Object|null} Variant object
 */
ProductForm.prototype.variant = function() {
  return getVariantFromSerializedArray(this.product, this.options());
};

/**
 * Getter method which returns a collection of objects containing name and values
 * of property inputs
 *
 * @returns {Array} Collection of objects with name and value keys
 */
ProductForm.prototype.properties = function() {
  var properties = _serializePropertyValues(this.propertyInputs, function(
    propertyName
  ) {
    var regex = /(?:^(properties\[))(.*?)(?:\])/;
    var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'
    return name;
  });

  return Object.entries(properties).length === 0 ? null : properties;
};

/**
 * Getter method which returns the current quantity or 1 if no quantity input is
 * included in the form
 *
 * @returns {Array} Collection of objects with name and value keys
 */
ProductForm.prototype.quantity = function() {
  return this.quantityInputs[0]
    ? Number.parseInt(this.quantityInputs[0].value, 10)
    : 1;
};

// Private Methods
// -----------------------------------------------------------------------------
ProductForm.prototype._setIdInputValue = function(value) {
  var idInputElement = this.element.querySelector(selectors.idInput);

  if (!idInputElement) {
    idInputElement = document.createElement('input');
    idInputElement.type = 'hidden';
    idInputElement.name = 'id';
    this.element.appendChild(idInputElement);
  }

  idInputElement.value = value.toString();
};

ProductForm.prototype._onSubmit = function(options, event) {
  event.dataset = this._getProductFormEventData();

  this._setIdInputValue(event.dataset.variant.id);

  if (options.onFormSubmit) {
    options.onFormSubmit(event);
  }
};

ProductForm.prototype._onFormEvent = function(cb) {
  if (typeof cb === 'undefined') {
    return Function.prototype;
  }

  return function(event) {
    event.dataset = this._getProductFormEventData();
    cb(event);
  }.bind(this);
};

ProductForm.prototype._initInputs = function(selector, cb) {
  var elements = Array.prototype.slice.call(
    this.element.querySelectorAll(selector)
  );

  return elements.map(
    function(element) {
      this._listeners.add(element, 'change', this._onFormEvent(cb));
      return element;
    }.bind(this)
  );
};

ProductForm.prototype._getProductFormEventData = function() {
  return {
    options: this.options(),
    variant: this.variant(),
    properties: this.properties(),
    quantity: this.quantity()
  };
};

function _serializeOptionValues(inputs, transform) {
  return inputs.reduce(function(options, input) {
    if (
      input.checked || // If input is a checked (means type radio or checkbox)
      (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
    ) {
      options.push(transform({ name: input.name, value: input.value }));
    }

    return options;
  }, []);
}

function _serializePropertyValues(inputs, transform) {
  return inputs.reduce(function(properties, input) {
    if (
      input.checked || // If input is a checked (means type radio or checkbox)
      (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
    ) {
      properties[transform(input.name)] = input.value;
    }

    return properties;
  }, {});
}

function _validateProductObject(product) {
  if (typeof product !== 'object') {
    throw new TypeError(product + ' is not an object.');
  }

  if (typeof product.variants[0].options === 'undefined') {
    throw new TypeError(
      'Product object is invalid. Make sure you use the product object that is output from null or from the http://[your-product-url].js route'
    );
  }

  return product;
}

;// ./src/js/utils/format-money.js
/**
 * format money
 * edited version of the following script:
 * @see    https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
 * @param  {Number|String} cents    e.g. "1200"
 * @param  {String}        format   e.g. "amount_with_currency"
 * @param  {String}        currency e.g. "$"
 * @return {String}
 */
function formatMoney(cents, format) {
  var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '$';
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  switch (format) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_with_currency':
      value = currency + formatWithDelimiters(cents, 2);
      break;
    case 'amount_with_currency_without_trailing_zeros':
      value = currency + formatWithDelimiters(cents, 2);
      if (value.indexOf('.00') !== -1) {
        value = value.replace('.00', '');
      }
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return value;
}
/* harmony default export */ var format_money = (formatMoney);
;// ./src/js/lib/trap-focus.js
/**
 * Trap Focus
 * For ADA, prevents focusing outside of selected container
 */
function trapFocus(element) {
  /**
   * Init
   */
  function init() {
    trap();
  }

  /**
   * Trap
   */
  function trap() {
    var KEYCODE_TAB = 9; // Tab keycode
    var focusableEls = Array.prototype.slice.call(element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled])'));
    var _Object$keys = Object.keys(focusableEls),
      length = _Object$keys.length;

    // Removes all DOM-hidden elements from focusableEls
    while (focusableEls[length - 1].offsetParent === null) {
      try {
        delete focusableEls[length - 1];
        length -= 1;
      } catch (e) {
        length -= 1;
      }
    }
    var firstFocusableEl = focusableEls[0];
    var lastFocusableEl = focusableEls[length - 1];
    firstFocusableEl.focus();
    function addEvent(e) {
      var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
      if (!isTabPressed) return;
      if (e.shiftKey && document.activeElement === firstFocusableEl) /* shift + tab */{
          lastFocusableEl.focus();
          e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === lastFocusableEl) /* tab */{
          firstFocusableEl.focus();
          e.preventDefault();
        }
    }
    element.addEventListener('keydown', addEvent);
  }
  return init();
}
/* harmony default export */ var trap_focus = (trapFocus);
;// ./src/js/utils/helpers.js
/* unused harmony import specifier */ var miniCartUpSell;
/* unused harmony import specifier */ var helpers_trapFocus;


function loadScript(src) {
  return new Promise(function (resolve, reject) {
    var js = document.createElement('script');
    js.src = src;
    js.onload = function () {
      return resolve();
    };
    js.onerror = function () {
      return reject(new Error("Failed to load script ".concat(src)));
    };
    document.head.appendChild(js);
  });
}
var documentBodyStyle = null;
function getCssVar(varName) {
  try {
    documentBodyStyle = documentBodyStyle || window.getComputedStyle(document.body);
    return documentBodyStyle.getPropertyValue("--".concat(varName));
  } catch (err) {
    return null;
  }
}
function toggleMinicart() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var miniCart = document.querySelector('.minicart');
  var qucikAddMobile = document.querySelector('body > .quick-add__mobile');
  var navigation = document.getElementsByTagName('nav')[0];
  var $closeBag = document.getElementById('closeBag');

  // Render miniCart UpSell
  miniCartUpSell();
  var shouldOpen = options.shouldOpen;
  shouldOpen = shouldOpen || !miniCart.classList.contains('minicart--open');
  if (shouldOpen) {
    window.prevElementCart = document.activeElement;
    miniCart.classList.add('minicart--open');
    document.body.style.overflow = 'hidden';

    // check if Mobile Quick Add is open on cart icon click, if so disable bodyScrollLock
    if (qucikAddMobile && qucikAddMobile.classList.contains('open')) {
      bodyScrollLock.clearAllBodyScrollLocks();
    }

    // eslint-disable-next-line no-undef
    setTimeout(function () {
      // For ADA
      $closeBag.focus();
      helpers_trapFocus(miniCart);
      // Waits for cart animation
    }, 200);
  } else {
    miniCart.classList.remove('minicart--open');
    document.body.style.overflow = '';

    // check if Mobile Quick Add is open on cart icon click, if so add bodyScrollLock
    if (qucikAddMobile && qucikAddMobile.classList.contains('open')) {
      bodyScrollLock.disableBodyScroll(navigation);
    }
    if (window.prevElementCart) {
      window.prevElementCart.focus();
    }
  }
}

// from pipeline theme
var selectors$M = {
  drawerWrappper: '[data-drawer]',
  drawerScrolls: '[data-drawer-scrolls]',
  underlay: '[data-drawer-underlay]',
  stagger: '[data-stagger-animation]',
  drawerToggle: 'data-drawer-toggle',
  children: ':scope > * > [data-animates]',
  focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'
};
var classes$v = {
  isVisible: 'drawer--visible',
  displayNone: 'display-none'
};
var sections$i = (/* unused pure expression or super */ null && ({}));

// Guard module-eval: the cart drawer isn't present on every page (e.g. /cart).
// Without this, drawer.querySelector throws at import time and aborts all of app.js.
var drawer = document.querySelector('[data-drawer="drawer-cart"]');
var drawerScrolls = null;
var key = null;
var buttons = [];
if (drawer) {
  drawerScrolls = drawer.querySelector(selectors$M.drawerScrolls);
  key = drawer.dataset.drawer;
  var btnSelector = "[".concat(selectors$M.drawerToggle, "='").concat(key, "']");
  buttons = document.querySelectorAll(btnSelector);
}
function showDrawer() {
  drawer.classList.remove(classes$v.displayNone);
  // animates after display none is removed
  setTimeout(function () {
    buttons.forEach(function (el) {
      return el.setAttribute('aria-expanded', true);
    });
    drawer.classList.add(classes$v.isVisible);
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', {
      bubbles: true,
      detail: drawerScrolls
    }));
    var firstFocus = drawer.querySelector(selectors$M.focusable);
    trap_focus(drawer, {
      elementToFocus: firstFocus
    });
  }, 1);
}
function hideDrawer() {
  buttons.forEach(function (el) {
    return el.setAttribute('aria-expanded', false);
  });
  drawer.classList.remove(classes$v.isVisible);
  drawerScrolls.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
    bubbles: true
  }));
  document.dispatchEvent(new CustomEvent('theme:sliderule:close', {
    bubbles: false
  }));
  removeTrapFocus();

  // adds display none after animations
  setTimeout(function () {
    if (!drawer.classList.contains(classes$v.isVisible)) {
      drawer.classList.add(classes$v.displayNone);
    }
  }, 800);
}

// end pipeline theme

function sleep(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
}
function addClass(el, className) {
  if (!hasClass(el, className)) {
    if (el.classList) {
      el.classList.add(className);
    } else {
      el.className += ' ' + className;
    }
  }
}
function removeClass(el, className) {
  if (hasClass(el, className)) {
    if (el.classList) {
      el.classList.remove(className);
    } else {
      el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  }
}
function hasClass(el, className) {
  if (el.classList) {
    return el.classList.contains(className);
  } else {
    return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
  }
}
function mq(callback, view) {
  var config = {
      callback: null,
      view: null,
      views: {
        small_phone: '(max-width: 340px)',
        phone: '(max-width: 620px)',
        mobile: '(max-width: 1080px)',
        phone_to_desktop: '(min-width: 340px)',
        tablet: '(min-width: 620px)',
        tablet_only: '(min-width: 620px) and (max-width: 1080px)',
        desktop: '(min-width: 1080px)',
        desktop_to_large: '(min-width: 1081px) and (max-width: 1280px)',
        desktop_large: '(min-width: 1281px)',
        desktop_large_to_huge: '(min-width: 1281px) and (max-width: 1440px)'
      }
    },
    currentView = null,
    mq = {
      init: function init() {
        Object.keys(config.views).forEach(function (key) {
          if (key === view) {
            currentView = config.views[key];
          }
        });
        var query = window.matchMedia(currentView);
        if (query.matches === true) {
          callback();
        }
      }
    };
  return mq.init();
}

/**
 * set cookie
 * @param  {String} c_name name of the cookie
 * @param  {String} value  value of the cookie
 * @param  {Number} exdays number of days to set the cookie
 * @return {Function}      sets cookie
 */
function setCookie(cName, value, exdays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);
  var cValue = encodeURI(value) + (exdays === null ? '' : "; expires=".concat(exdate.toUTCString()));
  document.cookie = "".concat(cName, " = ").concat(cValue, "; path=/");
}
;

/**
 * get cookie
 * @param  {String} cName name of the cookie
 * @return {String}        value of the cookie
 */
function getCookie(cName) {
  var i;
  var x;
  var y;
  var ARRcookies = document.cookie.split(';');
  for (i = 0; i < ARRcookies.length; i += 1) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
    x = x.replace(/^\s+|\s+$/g, '');
    if (x === cName) {
      return decodeURI(y);
    }
  }
  return false;
}
;

/**
 * delete cookie
 * @param {string} cName name of the cookie
 */
function deleteCookie(cName) {
  document.cookie = "".concat(cName, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
}
;

/**
 * slide down
 * @param {el} DOM Element
 */
function slideDown(el) {
  if (el === undefined) el = null;
  if (el) {
    var hiddenStyles = getHiddenStyles(el);
    var menuHeight = hiddenStyles.elHeight;
    var padTop = hiddenStyles.elPaddingTop;
    var padBottom = hiddenStyles.elPaddingBottom;
    el.style.display = 'block';
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.height = 0;
    setTimeout(function () {
      el.style.height = "".concat(menuHeight, "px");
      el.style.paddingTop = padTop;
      el.style.paddingBottom = padBottom;
    }, 1);
  }
}

/**
 * slide up
 * @param {el} DOM Element
 */
function slideUp(el) {
  if (el === undefined) el = null;
  if (el) {
    el.style.height = el.offsetHeight + 'px';
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    setTimeout(function () {
      el.style.display = '';
    }, 400); // Waits until animation is done
  }
}
;

/**
 * get hidden height
 * @param {element}
 * @return {int}
 */
function getHiddenStyles(el) {
  var $clone = el.cloneNode(true);
  var $parent = el.parentNode;
  var posVal = window.getComputedStyle($parent).position;
  var body = document.body;
  var docEl = document.documentElement;
  var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  var clientTop = docEl.clientTop || body.clientTop || 0;
  var $cloneInDom = null;
  var cloneHeight = null;
  var cloneOffsetTop;
  var clonePaddingTop = null;
  var clonePaddingBottom = null;
  var cloneRect;
  if (posVal === 'static') {
    $parent.style.position = 'relative';
  }

  // Add attribute to track element for deletion;
  $clone.setAttribute('data-clone', 'true');

  // Append the new cloen to to the parent.
  $parent.appendChild($clone);

  // Select that new clone
  $cloneInDom = $parent.querySelector('[data-clone="true"]');

  // Display the clone with visibility hidden so that size can be retrieved.
  $cloneInDom.style.height = 'auto';
  $cloneInDom.style.display = 'block';
  $cloneInDom.style.visibility = 'hidden';
  $cloneInDom.style.position = 'absolute';

  // Get Height
  cloneHeight = $cloneInDom.offsetHeight;

  // Get Padding Top
  clonePaddingTop = window.getComputedStyle($cloneInDom).paddingTop;

  // Get Padding Bottom;
  clonePaddingBottom = window.getComputedStyle($cloneInDom).paddingBottom;

  // Get Rectangle
  cloneRect = $cloneInDom.getBoundingClientRect();

  // Get OffsetTop
  cloneOffsetTop = Math.round(cloneRect.top + scrollTop - clientTop);

  // Delete the clone
  $cloneInDom.remove();

  // Remove the position value added to the parent when its static.
  if (posVal === 'static') {
    $parent.style.position = '';
  }

  // Return values
  return {
    elHeight: cloneHeight,
    elOffsetTop: cloneOffsetTop,
    elPaddingTop: clonePaddingTop,
    elPaddingBottom: clonePaddingBottom
  };
}
;

/**
 * is object
 * @param  {*}       data any type
 * @return {boolean}
 */
function isObject(data) {
  return Object.prototype.toString.call(data) === '[object Object]';
}
;

/**
 * extend
 * extends a js object
 * @param  {Object} config
 * @param  {Object} obj
 * @return {Object}
 */
function extend(config, obj) {
  obj = obj || {};
  Object.keys(config).forEach(function (key) {
    if (obj[key] === undefined) {
      obj[key] = config[key];
    } else {
      if (obj[key] && isObject(obj[key]) && isObject(config[key])) {
        Object.keys(config[key]).forEach(function (childKey) {
          if (obj[key][childKey] === undefined) {
            obj[key][childKey] = config[key][childKey];
          }
        });
      }
    }
  });
  return obj;
}
;

/**
 * debounce
 * limits how often a function can fire
 * @param  {Function} func function to debounce
 * @param  {Number}   wait milliseconds to wait
 * @return {Function}
 */
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var timeout;
  return function executedFunction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var later = function later() {
      clearTimeout(timeout);
      func.apply(void 0, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
;

/**
 * throttle
 * ensures function is called at most once per interval
 * @param  {Function} func function to throttle
 * @param  {Number}   wait milliseconds to wait
 * @return {Function}
 */
function throttle(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var timeout;
  var previous = 0;
  return function executedFunction() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var now = Date.now();
    var remaining = wait - (now - previous);
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      func.apply(void 0, args);
    } else if (!timeout) {
      timeout = setTimeout(function () {
        previous = Date.now();
        timeout = null;
        func.apply(void 0, args);
      }, remaining);
    }
  };
}
;
;// ./src/js/utils/cart-api.js
function addItem(variantId, quantity, properties) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
      properties: properties || {}
    })
  }).then(handleResponse);
}
function getCart() {
  return fetch('/cart.js').then(handleResponse);
}
function updateCart() {
  return getCart().then(function (cart) {
    window.cart = cart;
    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      detail: {
        cart: cart
      },
      bubbles: true
    }));
    document.dispatchEvent(new CustomEvent('theme:cart:reload', {
      bubbles: true
    }));
    return cart;
  });
}
function handleResponse(response) {
  if (!response.ok) {
    return response.json().then(function (err) {
      throw err;
    });
  }
  return response.json();
}
;// ./src/js/components/sfs-policy.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * SFS storefront policy — the two public metafields are the full contract:
 *   fe_sfs.web_purchasable           false (or "false") blocks online purchase.
 *   fe_sfs.max_purchasable_quantity  positive integer caps online quantity.
 * Both fail open: anything missing/null/unreadable → current theme behavior.
 * Pure, DOM-free, unit-tested. Every add/quantity surface routes through this.
 */

var GIFT_CARD = 'Gift Card';

// Normalize a serialized entry into { webPurchasable, maxPurchasableQuantity }.
// Accepts the policy object, a legacy bare boolean/null, or undefined.
function parseSfsPolicy(raw) {
  var webRaw;
  var maxRaw;
  if (raw && _typeof(raw) === 'object') {
    webRaw = raw.web_purchasable;
    maxRaw = raw.max_purchasable_quantity;
  } else {
    webRaw = raw; // legacy bare boolean / null
    maxRaw = null;
  }
  var webPurchasable = !(webRaw === false || webRaw === 'false');
  var parsedMax = Number(maxRaw);
  var maxPurchasableQuantity = maxRaw !== null && maxRaw !== '' && Number.isInteger(parsedMax) && parsedMax > 0 ? parsedMax : null;
  return {
    webPurchasable: webPurchasable,
    maxPurchasableQuantity: maxPurchasableQuantity
  };
}

// Total quantity of `variantId` already in the cart (CartJS.cart.items shape).
function cartQuantityForVariant(cartItems, variantId) {
  if (!Array.isArray(cartItems) || variantId == null) {
    return 0;
  }
  var wanted = String(variantId);
  return cartItems.filter(function (item) {
    return String(item.id) === wanted || String(item.variant_id) === wanted;
  }).reduce(function (sum, item) {
    return sum + (Number(item.quantity) || 0);
  }, 0);
}

// The guard. `policy` is the output of parseSfsPolicy. options.name → gift-card exemption.
function validateSfsDesiredQuantity(policy, desiredQuantity) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var name = options.name || '';
  if (name.includes(GIFT_CARD)) {
    return {
      allowed: true
    };
  }
  if (policy.webPurchasable === false) {
    return {
      allowed: false
    };
  }
  if (policy.maxPurchasableQuantity && desiredQuantity > policy.maxPurchasableQuantity) {
    return {
      allowed: false
    };
  }
  return {
    allowed: true
  };
}
;// ./src/js/sections/product/product-configurables.js
/* provided dependency */ var $ = __webpack_require__(669);
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function product_configurables_typeof(o) { "@babel/helpers - typeof"; return product_configurables_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, product_configurables_typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == product_configurables_typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != product_configurables_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != product_configurables_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 *  Product Configurables
 */






var ProductConfigurables = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} opts
   */
  function ProductConfigurables(opts) {
    _classCallCheck(this, ProductConfigurables);
    // config
    this.c = {
      hiddenId: 'js-hidden-id',
      colorLabel: 'js-config-label-color',
      submitButton: 'js-add-to-bag',
      submitButtonText: 'js-add-to-bag-text',
      notifyMe: 'js-notify',
      photo: 'js-photo',
      price: 'js-price-original',
      priceCompare: 'js-price-compare',
      notify: 'js-product-notify',
      notifyForm: 'js-notify-form',
      thumbnail: 'js-thumb',
      sizeDisplay: 'js-size-display-trigger',
      sizeGuideInner: 'size-guide .size-guide__inner',
      sizePanel: 'js-size-panel',
      arrow: 'js-size-chevron',
      sizesWrapper: 'sizes-wrapper',
      selectSizeButton: 'js-select-size',
      cartCount: 'header__desktop__button .js-cart-number',
      cls: {
        open: 'open',
        active: 'is-active',
        is_hidden: 'is-hidden'
      },
      addToBagText: 'Add to Bag',
      preOrderText: 'Pre-order'
    };

    // elements
    this.$productForm = opts.productForm;
    this.$sizeContent = document.querySelectorAll('.' + this.c.sizePanel);
    this.$sizeContentInner = document.querySelectorAll('.' + this.c.sizePanel + ' > div');
    this.$cartCount = document.querySelectorAll('.' + this.c.cartCount);
    this.$price = document.querySelectorAll('.' + this.c.price + ' > .money');
    this.$submit = document.querySelectorAll('.' + this.c.submitButton);
    this.$notifyMe = document.querySelectorAll('.' + this.c.notifyMe);
    this.$submitText = document.querySelectorAll('.' + this.c.submitButtonText);
    this.$btnArrow = document.querySelectorAll('.' + this.c.arrow);
    this.$sizeGuideInner = document.querySelectorAll('.' + this.c.sizeGuideInner);
    this.$sizesWrapper = document.querySelectorAll('.' + this.c.sizesWrapper);
    this.$selectSizeButton = document.querySelectorAll('.product-section .' + this.c.selectSizeButton);
    this.currentVariant = window.currentVariant;
    this.product = window.productJson;
    this.isPreOrder = this.product && this.product.tags ? this.product.tags.includes('stamp_pre-order') : null;
    this.sfsPolicyByVariantId = this.getSfsWebPurchasableMap();
    this._initComplete = false;
    this.init();
  }
  return _createClass(ProductConfigurables, [{
    key: "getSfsWebPurchasableMap",
    value: function getSfsWebPurchasableMap() {
      var el = document.querySelector('[data-fe-sfs-web-purchasable]');
      if (!el) {
        return {};
      }
      try {
        var parsed = JSON.parse(el.textContent || '{}');
        return parsed && product_configurables_typeof(parsed) === 'object' ? parsed : {};
      } catch (error) {
        return {};
      }
    }
  }, {
    key: "isSfsBlockedVariantId",
    value: function isSfsBlockedVariantId(variantId) {
      if (!variantId) {
        return false;
      }

      // Pre-order products are exempt. SFS gates on
      // ship-from-store inventory, and a pre-order has none by definition — the metafield
      // comes back web_purchasable=false for EVERY variant, including sizes holding 20-30
      // units. Without this the gate hides the Pre-order button on load and blocks the add,
      // making the whole product unbuyable.
      if (this.isPreOrder) {
        return false;
      }
      return parseSfsPolicy(this.sfsPolicyByVariantId[String(variantId)]).webPurchasable === false;
    }
  }, {
    key: "isSfsBlockedVariant",
    value: function isSfsBlockedVariant(variant) {
      return this.isSfsBlockedVariantId(variant && variant.id);
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var mobileSizes, pvSelectSize, urlVariantId, urlVariant;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (this.$productForm) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              // Bind events BEFORE any await. `this.product` is already populated
              // synchronously in the constructor from `window.productJson`, which
              // sections/product.liquid renders inline in a parser-blocking script — so the
              // fetch below is re-fetching data the page already has. Binding after it left
              // #btnAddToBag painted, enabled and completely inert until the network came
              // back: on mobile that window is long enough to swallow a real tap, and the
              // customer has to press Add to Bag a second time. Nothing in these three
              // depends on the fetch (the single `this.product` deref in addEvents is
              // already null-guarded), so there is nothing to wait for.
              this.addEvents();
              this.onColorHover();
              this.otherFabricsToggle();
              console.log('cart bug update');

              // get product data
              _context.n = 2;
              return ProductConfigurables.getProductJson(this.$productForm.dataset.productHandle);
            case 2:
              this.product = _context.v;
              // init product form (skip if product data unavailable)
              if (this.product) {
                this.productForm = new ProductForm(this.$productForm, this.product, {
                  onOptionChange: this.onFormOptionChange.bind(this)
                });
              }
              mobileSizes = this.$sizesWrapper[0] ? this.$sizesWrapper[0].querySelectorAll('.product__circle') : [];
              if (this.$sizesWrapper[0] && mobileSizes.length < 5) {
                this.$sizesWrapper[0].classList.add('js-is-less-then-five');
              }

              // init o/s if single (skip select-size hide for bundle products — they need it until all sizes are chosen)
              if (mobileSizes.length == 1 && mobileSizes[0].dataset.value == 'O/S') {
                mobileSizes[0].click();
                if (!this.hasBundle) {
                  pvSelectSize = document.querySelector('.pv__select-size');
                  if (pvSelectSize) pvSelectSize.style.display = 'none';
                }
              }
              if (this.product && this.product.type === 'Gift Card') {
                this.selectLastGiftCardValue();
              }

              // stockCheck disabled — SFS metafield (fe_sfs.web_purchasable) now gates variant availability
              // const productSection = document.querySelector('.product-section');
              // const enableMadisonThreshold = productSection?.dataset.enableMadisonThreshold === 'true';
              // if (enableMadisonThreshold && this.product) {
              //   await this.stockCheck();
              // }

              // Mark SFS-blocked variants as disabled on size swatches
              if (this.product && this.product.variants) {
                this.product.variants.forEach(function (v) {
                  if (_this.isSfsBlockedVariant(v)) {
                    $(".product__circle[data-variant-id=\"".concat(v.id, "\"]")).addClass('disabled');
                  }
                });
              }

              // Apply SFS availability for direct ?variant= URLs (only when variant is SFS-blocked)
              urlVariantId = new URLSearchParams(window.location.search).get('variant');
              if (urlVariantId && this.product && this.product.variants) {
                urlVariant = this.product.variants.find(function (v) {
                  return String(v.id) === String(urlVariantId);
                });
                if (urlVariant && this.isSfsBlockedVariant(urlVariant)) {
                  this.updatePrice(urlVariant);
                  this.updateSubmitButton(urlVariant);
                }
              }
              this._initComplete = true;
              // this.quickAdd();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "stockCheck",
    value: (
    /**
     * Check stock across warehouse locations for all variants
     * If variant stock is only available at Madison NYC location with qty < threshold,
     * apply 'disabled' class to trigger Klaviyo notify.
     * If exclude_madison_inventory_online metafield is true, completely exclude Madison
     * inventory (ignore threshold, treat as unavailable if only Madison has stock).
     */
    function () {
      var _stockCheck = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var isStaging, MADISON_NYC_LOCATION_ID, productSection, LOW_STOCK_THRESHOLD, excludeMadisonInventory, inventoryItemMap, inventoryItemIds, inventoryByItemId, stockReport, self, i, variant, sizeCircle, inventoryItemId, inventoryData, madisonStock, otherLocationsStock, totalOtherStock, madisonQty, shouldDisable, productJsonVariant, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              // Use different location IDs based on domain
              isStaging = window.location.hostname === 'frank-and-eileen-staging.myshopify.com';
              MADISON_NYC_LOCATION_ID = isStaging ? '65543405665' : '73061761098';
              productSection = document.querySelector('.product-section');
              LOW_STOCK_THRESHOLD = parseInt(productSection === null || productSection === void 0 ? void 0 : productSection.dataset.lowStockThreshold, 10) || 2;
              excludeMadisonInventory = (productSection === null || productSection === void 0 ? void 0 : productSection.dataset.excludeMadisonInventory) === 'true';
              if (!(!this.product || !this.product.variants)) {
                _context2.n = 1;
                break;
              }
              console.warn('Product or variants not available for stock check');
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return this.fetchInventoryItemMap(this.product.id);
            case 2:
              inventoryItemMap = _context2.v;
              if (inventoryItemMap) {
                _context2.n = 3;
                break;
              }
              console.warn('Stock check: could not load variants.json — skipping');
              return _context2.a(2);
            case 3:
              inventoryItemIds = Object.values(inventoryItemMap);
              _context2.n = 4;
              return this.fetchInventoryLevelsByItem(inventoryItemIds);
            case 4:
              inventoryByItemId = _context2.v;
              if (inventoryByItemId) {
                _context2.n = 5;
                break;
              }
              console.warn('Stock check: could not load inventory_levels.json — skipping');
              return _context2.a(2);
            case 5:
              _context2.p = 5;
              stockReport = [];
              self = this;
              i = 0;
            case 6:
              if (!(i < this.product.variants.length)) {
                _context2.n = 10;
                break;
              }
              variant = this.product.variants[i]; // Find the corresponding size circle element
              sizeCircle = document.querySelector('.product__circle[data-variant-id="' + variant.id + '"]');
              if (sizeCircle) {
                _context2.n = 7;
                break;
              }
              return _context2.a(3, 9);
            case 7:
              // Look up this variant's inventory from the batched maps fetched above
              inventoryItemId = inventoryItemMap[variant.id];
              inventoryData = inventoryItemId && inventoryByItemId[inventoryItemId];
              if (inventoryData) {
                _context2.n = 8;
                break;
              }
              return _context2.a(3, 9);
            case 8:
              // Check if stock is only available at Madison NYC location with low quantity
              madisonStock = inventoryData.find(function (loc) {
                return loc.location_id.toString() === MADISON_NYC_LOCATION_ID;
              });
              otherLocationsStock = inventoryData.filter(function (loc) {
                return loc.location_id.toString() !== MADISON_NYC_LOCATION_ID;
              }); // Calculate total stock in other locations
              totalOtherStock = otherLocationsStock.reduce(function (sum, loc) {
                return sum + (loc.available || 0);
              }, 0); // Collect stock data
              madisonQty = madisonStock ? madisonStock.available : 0;
              stockReport.push({
                variantId: variant.id,
                variantTitle: variant.title,
                madisonNYC: madisonQty,
                oakCanyon: totalOtherStock
              });

              // Determine if variant should be disabled
              shouldDisable = false;
              if (excludeMadisonInventory) {
                // If exclude_madison_inventory_online is true:
                // Disable if ONLY Madison has stock (any quantity), other locations have 0
                shouldDisable = madisonQty > 0 && totalOtherStock === 0;
              } else {
                // Normal threshold check:
                // Disable if Madison stock is below threshold AND other locations have 0
                shouldDisable = madisonStock && madisonStock.available < LOW_STOCK_THRESHOLD && totalOtherStock === 0;
              }
              if (shouldDisable) {
                sizeCircle.classList.add('disabled');
                stockReport[stockReport.length - 1].status = excludeMadisonInventory ? 'DISABLED - Madison inventory excluded, no stock at other locations' : 'DISABLED - Low stock at Madison NYC, no stock at other locations';

                // Mark variant as unavailable for Klaviyo back-in-stock
                variant.available = false;

                // Also update window.productJson which Klaviyo reads from
                if (window.productJson && window.productJson.variants) {
                  productJsonVariant = window.productJson.variants.find(function (v) {
                    return v.id === variant.id;
                  });
                  if (productJsonVariant) {
                    productJsonVariant.available = false;
                  }
                }
              } else {
                stockReport[stockReport.length - 1].status = 'Available';
              }
            case 9:
              i++;
              _context2.n = 6;
              break;
            case 10:
              // Log all stock data as one consolidated output
              console.log('=== STOCK CHECK COMPLETE ===');
              console.table(stockReport);
              _context2.n = 12;
              break;
            case 11:
              _context2.p = 11;
              _t = _context2.v;
              console.error('Error in stockCheck:', _t);
            case 12:
              return _context2.a(2);
          }
        }, _callee2, this, [[5, 11]]);
      }));
      function stockCheck() {
        return _stockCheck.apply(this, arguments);
      }
      return stockCheck;
    }()
    /**
     * Fetch the product's variants.json once and build a { variantId: inventory_item_id } map.
     * Called once at the start of stockCheck so per-variant inventory lookups don't re-fetch
     * this same payload N times.
     * @param {Number} productId
     * @returns {Promise<Object|null>} Map of variantId → inventory_item_id, or null on failure
     */
    )
  }, {
    key: "fetchInventoryItemMap",
    value: (function () {
      var _fetchInventoryItemMap = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(productId) {
        var isStaging, shopDomain, variantsUrl, variantsResponse, variantsData, map, _iterator, _step, v, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              isStaging = window.location.hostname === 'frank-and-eileen-staging.myshopify.com';
              shopDomain = isStaging ? 'frank-and-eileen-staging.myshopify.com' : 'frankandeileen.myshopify.com';
              variantsUrl = "https://good-dog-cors.herokuapp.com/https://".concat(shopDomain, "/admin/api/2023-10/products/").concat(productId, "/variants.json");
              _context3.n = 1;
              return fetch(variantsUrl);
            case 1:
              variantsResponse = _context3.v;
              if (variantsResponse.ok) {
                _context3.n = 2;
                break;
              }
              console.error("Failed to fetch variants for product ".concat(productId, ":"), variantsResponse.status);
              return _context3.a(2, null);
            case 2:
              _context3.n = 3;
              return variantsResponse.json();
            case 3:
              variantsData = _context3.v;
              if (!(!variantsData.variants || variantsData.variants.length === 0)) {
                _context3.n = 4;
                break;
              }
              console.warn("No variants found for product ".concat(productId));
              return _context3.a(2, null);
            case 4:
              map = {};
              _iterator = _createForOfIteratorHelper(variantsData.variants);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  v = _step.value;
                  if (v.inventory_item_id) map[v.id] = v.inventory_item_id;
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              return _context3.a(2, map);
            case 5:
              _context3.p = 5;
              _t2 = _context3.v;
              console.error("Error fetching variants for product ".concat(productId, ":"), _t2);
              return _context3.a(2, null);
          }
        }, _callee3, null, [[0, 5]]);
      }));
      function fetchInventoryItemMap(_x) {
        return _fetchInventoryItemMap.apply(this, arguments);
      }
      return fetchInventoryItemMap;
    }()
    /**
     * Batched per-location inventory lookup. Joins inventory_item_ids in a single
     * inventory_levels.json call (Shopify caps inventory_item_ids at 50 per request,
     * so we chunk and run chunks in parallel).
     * @param {Array<Number>} inventoryItemIds
     * @returns {Promise<Object|null>} Map of inventory_item_id → [{location_id, available}]
     */
    )
  }, {
    key: "fetchInventoryLevelsByItem",
    value: (function () {
      var _fetchInventoryLevelsByItem = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(inventoryItemIds) {
        var isStaging, shopDomain, CHUNK_SIZE, chunks, i, chunkResults, map, _iterator2, _step2, level, itemId, _t3, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!(!inventoryItemIds || inventoryItemIds.length === 0)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, null);
            case 1:
              _context5.p = 1;
              isStaging = window.location.hostname === 'frank-and-eileen-staging.myshopify.com';
              shopDomain = isStaging ? 'frank-and-eileen-staging.myshopify.com' : 'frankandeileen.myshopify.com';
              CHUNK_SIZE = 50;
              chunks = [];
              for (i = 0; i < inventoryItemIds.length; i += CHUNK_SIZE) {
                chunks.push(inventoryItemIds.slice(i, i + CHUNK_SIZE));
              }
              _context5.n = 2;
              return Promise.all(chunks.map(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(chunk) {
                  var inventoryUrl, response, data;
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.n) {
                      case 0:
                        inventoryUrl = "https://good-dog-cors.herokuapp.com/https://".concat(shopDomain, "/admin/api/2023-10/inventory_levels.json?inventory_item_ids=").concat(chunk.join(','), "&limit=250");
                        _context4.n = 1;
                        return fetch(inventoryUrl);
                      case 1:
                        response = _context4.v;
                        if (response.ok) {
                          _context4.n = 2;
                          break;
                        }
                        console.error('Failed to fetch inventory_levels:', response.status);
                        return _context4.a(2, []);
                      case 2:
                        _context4.n = 3;
                        return response.json();
                      case 3:
                        data = _context4.v;
                        return _context4.a(2, data.inventory_levels || []);
                    }
                  }, _callee4);
                }));
                return function (_x3) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 2:
              chunkResults = _context5.v;
              map = {};
              _iterator2 = _createForOfIteratorHelper(chunkResults.flat());
              _context5.p = 3;
              _iterator2.s();
            case 4:
              if ((_step2 = _iterator2.n()).done) {
                _context5.n = 7;
                break;
              }
              level = _step2.value;
              itemId = level.inventory_item_id;
              if (itemId) {
                _context5.n = 5;
                break;
              }
              return _context5.a(3, 6);
            case 5:
              if (!map[itemId]) map[itemId] = [];
              map[itemId].push({
                location_id: level.location_id.toString(),
                available: level.available || 0
              });
            case 6:
              _context5.n = 4;
              break;
            case 7:
              _context5.n = 9;
              break;
            case 8:
              _context5.p = 8;
              _t3 = _context5.v;
              _iterator2.e(_t3);
            case 9:
              _context5.p = 9;
              _iterator2.f();
              return _context5.f(9);
            case 10:
              return _context5.a(2, map);
            case 11:
              _context5.p = 11;
              _t4 = _context5.v;
              console.error('Error fetching inventory levels:', _t4);
              return _context5.a(2, null);
          }
        }, _callee5, null, [[3, 8, 9, 10], [1, 11]]);
      }));
      function fetchInventoryLevelsByItem(_x2) {
        return _fetchInventoryLevelsByItem.apply(this, arguments);
      }
      return fetchInventoryLevelsByItem;
    }())
  }, {
    key: "otherFabricsToggle",
    value: function otherFabricsToggle() {
      var toggleButtons = document.querySelectorAll('.other-fabrics-toggle');
      toggleButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var otherFabricsToggleEls = document.querySelectorAll('.other-fabrics-toggle');
          var otherFabrics = document.querySelectorAll('.other-fabrics');
          otherFabricsToggleEls.forEach(function (el) {
            el.classList.toggle('open');
          });
          otherFabrics.forEach(function (el) {
            el.classList.toggle('open');
          });
          var spanEl = this.querySelector('span');
          if (this.classList.contains('open')) {
            if (spanEl) spanEl.textContent = 'See Less';
          } else {
            if (spanEl) spanEl.innerHTML = 'See More';
          }
        });
      });
    }

    // Find the .pv-details__fabric label belonging to THIS swatch's group.
    //
    // Replaces a fixed `for (i < 5) parent = parent.parentElement` walk followed by
    // `querySelector('.pv-details__fabric')`. Two things were wrong with that. The hop count
    // is a guess — the swatch sits at a different depth in the toggle layout
    // (.toggle-content > .pv-details__fabric + configurable-colors, product-variant-options.liquid:20-79)
    // than in the flat one (:181-203) — and once it overshoots into an ancestor holding every
    // group, querySelector returns the FIRST label in document order, not this group's. So
    // hovering the second or third fabric group relabelled the first one.
    //
    // Instead: climb until an ancestor contains exactly one label. That ancestor is this
    // swatch's own group. If we reach one holding several we have gone too far and return
    // null rather than pick arbitrarily.
  }, {
    key: "onColorHover",
    value: function onColorHover() {
      // Skip swatches inside .other-fabrics. They match this selector too, but their heading
      // is a .config__group-title handled by the second block below — so they were firing
      // BOTH handlers and relabelling two headings at once, which is the double.
      var productColorEls = Array.prototype.filter.call(document.querySelectorAll('[data-product-color]'), function (el) {
        return !el.closest('.other-fabrics');
      });

      // product toggles
      productColorEls.forEach(function (el) {
        // Skip other-fabrics swatches; they have their own dedicated handler below.
        // Without this, hovering an other-fabrics swatch also mutates the main
        // .pv-details__fabric title of the first group.
        if (el.closest('.other-fabrics')) return;
        el.addEventListener('mouseover', function () {
          var fabric = ProductConfigurables.fabricLabelForSwatch(this);
          if (!fabric) return;
          // Store original text on first hover
          if (!fabric.dataset.originalColor) {
            fabric.dataset.originalColor = fabric.textContent;
          }
          var newColor = this.dataset.productColor;
          // The hovered swatch's own fabric (product-fabric-label.liquid), not the page's: a
          // solid set hovered on a mixed-color set's page shows one fabric, not the pair.
          // Swatches without the attribute keep the page's label.
          var newFabric = this.dataset.productFabric || fabric.dataset.originalColor;
          fabric.textContent = newFabric + ' | ' + newColor;
        });
        el.addEventListener('mouseout', function () {
          var fabric = ProductConfigurables.fabricLabelForSwatch(this);
          if (fabric && fabric.dataset.originalColor) {
            fabric.textContent = fabric.dataset.originalColor;
          }
        });
      });

      // other fabrics
      var otherFabricsColorEls = document.querySelectorAll('.other-fabrics [data-product-color]');
      otherFabricsColorEls.forEach(function (el) {
        el.addEventListener('mouseover', function () {
          var parent = this.parentElement;
          if (parent && parent.parentElement) parent = parent.parentElement;
          var title = parent ? parent.previousElementSibling : null;
          if (!title || !title.classList.contains('config__group-title')) return;
          // Store original text on first hover
          if (!title.dataset.originalColor) {
            title.dataset.originalColor = title.textContent;
          }
          var newColor = this.dataset.productColor;
          title.innerHTML = title.dataset.originalColor + ' | ' + '<span class="hover-color" style="color:#747167; padding-left:4px; text-transform:initial"> ' + newColor + ' </span>';
          setTimeout(function () {
            var hoverColor = document.querySelector('.hover-color');
            if (hoverColor) hoverColor.classList.add('show');
          }, 100);
        });
        el.addEventListener('mouseout', function () {
          var parent = this.parentElement;
          if (parent && parent.parentElement) parent = parent.parentElement;
          var title = parent ? parent.previousElementSibling : null;
          if (title && title.dataset.originalColor) {
            title.textContent = title.dataset.originalColor;
          }
        });
      });
    }
  }, {
    key: "onFormOptionChange",
    value: function onFormOptionChange(event) {
      if (!this._initComplete) return;
      var variant = event.dataset.variant ? event.dataset.variant : window.currentVariant;
      this.currentVariant = variant;
      // window.currentVariant = variant;

      this.updatePrice(variant);
      this.updateSubmitButton(variant);
      if (this.product.type === 'Gift Card') {
        //this.updateGiftCardImage(variant);
        this.updateGiftCardVariantTitle(variant);
      }
    }
  }, {
    key: "onBundleOptionChange",
    value: function onBundleOptionChange() {
      // For bundle products, check if all items have sizes selected
      var totalBundleItems = document.querySelectorAll('.product__options').length;
      var selectedBundleItems = document.querySelectorAll('.product__circle.is-bundle.current').length;

      // Check if all selected sizes are in stock (not disabled)
      var selectedOutOfStock = document.querySelectorAll('.product__circle.is-bundle.current.disabled').length;
      var allInStock = selectedOutOfStock === 0;

      // Bundle OOS message element
      var bundleOosMessage = document.querySelector('.config__group-title--bundle-oos');

      // Update button state based on selection completeness and stock
      if (selectedBundleItems === totalBundleItems && totalBundleItems > 0 && allInStock) {
        // All bundle items have sizes selected and all are in stock - enable the button
        this.$selectSizeButton.forEach(function (el) {
          el.classList.add('is-hidden');
        });
        this.$submit.forEach(function (el) {
          el.disabled = false;
        });
        this.$submit.forEach(function (el) {
          el.classList.remove('is-hidden');
        });
        var preorderEl = document.querySelector('.pv__add-to-bag--preorder');
        if (preorderEl) preorderEl.classList.add('active');
        this.$notifyMe.forEach(function (el) {
          el.classList.add('is-hidden');
        });
        if (bundleOosMessage) bundleOosMessage.classList.add('hide');
        var self = this;
        if (this.isPreOrder) {
          this.$submitText.forEach(function (el) {
            el.textContent = self.c.preOrderText;
          });
        } else {
          this.$submitText.forEach(function (el) {
            el.textContent = self.c.addToBagText;
          });
        }

        // Remove the size placeholder if it exists
        var sizePlaceholder = document.querySelector('.pv__size-placeholder');
        if (sizePlaceholder) {
          sizePlaceholder.remove();
        }
      } else {
        // Not all sizes selected OR any out of stock - show select size
        this.$submit.forEach(function (el) {
          el.disabled = true;
        });
        this.$submit.forEach(function (el) {
          el.classList.add('is-hidden');
        });
        this.$selectSizeButton.forEach(function (el) {
          el.classList.remove('is-hidden');
        });
        this.$notifyMe.forEach(function (el) {
          el.classList.add('is-hidden');
        });

        // Show OOS message if sizes are selected but out of stock
        if (selectedBundleItems === totalBundleItems && selectedOutOfStock > 0) {
          if (selectedOutOfStock === totalBundleItems) {
            if (bundleOosMessage) {
              bundleOosMessage.textContent = 'Set Unavailable - Out of Stock';
              bundleOosMessage.classList.remove('hide');
            }
          } else {
            if (bundleOosMessage) {
              bundleOosMessage.textContent = 'Set Unavailable - One Item Out of Stock';
              bundleOosMessage.classList.remove('hide');
            }
          }
        } else {
          if (bundleOosMessage) bundleOosMessage.classList.add('hide');
        }
      }
    }

    // updateCart is now imported from cart-api.js
  }, {
    key: "addEvents",
    value: function addEvents() {
      var _self = this;
      var sizeDisplayEls = document.querySelectorAll('.' + this.c.sizeDisplay);
      sizeDisplayEls.forEach(function (el) {
        el.addEventListener('click', _self.toggleSizeDisplay.bind(_self));
      });
      var hasBundle = false;
      if (this.$submit && this.$submit[0]) {
        hasBundle = this.$submit[0].dataset.hasBundle;
      }

      // Store hasBundle flag for later use
      this.hasBundle = hasBundle === 'true';

      // Listen for bundle size change events from product-size-guide.js
      if (this.hasBundle) {
        document.addEventListener('bundle:size-changed', function () {
          _self.onBundleOptionChange();
        });
      }
      if (this.hasBundle) {
        this.$submit.forEach(function (el) {
          el.addEventListener('click', _self.addBundleProductsToCart.bind(_self));
        });
      } else {
        var self = this;
        if (document.querySelector('body[data-template-type="product.rise-gift-card"]') === null) {
          this.$submit.forEach(function (el) {
            if (!el.classList.contains('qa')) {
              el.addEventListener('click', self.addToCart.bind(self));
            }
          });
        }
      }

      // The Add to Bag handler now exists. If the customer tapped while it did not — the
      // window runs from first paint to DOMContentLoaded, see the recorder in
      // snippets/product-actions.liquid — replay that tap instead of making them press twice.
      // Must come after BOTH branches above so the bundle path is covered too.
      if (window.feAddToBagReleasePendingTap) {
        window.feAddToBagReleasePendingTap();
      }

      // check sizes and append warning if none selected
      var addInnerEls = document.querySelectorAll('.product-section .pv__add-inner');
      addInnerEls.forEach(function (el) {
        el.addEventListener('click', function () {
          var currentSizes = document.querySelectorAll('.product__sizes .current');
          var addToBagWarning = document.querySelector('.add-to-bag-warning');
          if (currentSizes.length === 0 && !addToBagWarning && location.pathname.includes('gift-card') === false) {
            var productForm = document.getElementById('product__form');
            if (productForm) {
              productForm.insertAdjacentHTML('afterend', '<div style="padding:8px; text-align:center; background:transparent; margin-bottom:8px; color:#dc0000;" class="add-to-bag-warning">Please select a size</div>');
            }
            // AMP106: this live region is the ONLY announcement channel for this message.
            // The warning div above is deliberately left without role="alert" — that role is
            // an implicit assertive live region, so having both made NVDA say "Please select
            // a size" twice. The div stays purely visual; announcing is this region's job.
            var liveRegion = document.getElementById('add-to-bag-live-region');
            if (liveRegion) {
              liveRegion.textContent = '';
              setTimeout(function () {
                liveRegion.textContent = 'Please select a size';
              }, 100);
            }
          }
        });
      });
      if (document.querySelector('.product-type--bundle') || document.querySelector('.product-type--bundle-app')) return; // skip for bundle products
      var productCircles = document.querySelectorAll('.product-section .product__sizes .product__circle');
      productCircles.forEach(function (el) {
        el.addEventListener('click', function () {
          var addToBagWarning = document.querySelector('.add-to-bag-warning');
          if (addToBagWarning) addToBagWarning.remove();
          if (el.classList.contains('disabled')) {
            // show hide notify message
            var oosTitle = document.querySelector('.config__group-title--oos');
            var configGroupTitle = document.querySelector('h4.config__group-title');
            if (oosTitle) oosTitle.classList.remove('hide');
            if (configGroupTitle) configGroupTitle.classList.add('oos-active');
          } else {
            var oosTitle = document.querySelector('.config__group-title--oos');
            var configGroupTitle = document.querySelector('h4.config__group-title');
            if (oosTitle) oosTitle.classList.add('hide');
            if (configGroupTitle) configGroupTitle.classList.remove('oos-active');
          }
          var index = Array.from(el.parentElement.children).indexOf(el);
          _self.checkSizeStock(index);

          // Handle Klaviyo notify integration for disabled/OOS sizes
          if (el.classList.contains('disabled')) {
            // Get the variant ID for this size
            var variantId = el.dataset.variantId;

            // Mark this size as selected/current
            document.querySelectorAll('.product__sizes .product__circle').forEach(function (c) {
              c.classList.remove('current');
            });
            el.classList.add('current');

            // Update the selected variant for Klaviyo to use
            if (variantId && _self.product) {
              var variant = _self.product.variants.find(function (v) {
                return v.id == variantId;
              });
              if (variant) {
                // Update current variant in multiple places for Klaviyo
                _self.currentVariant = variant;
                window.currentVariant = variant;

                // Update meta product variant for Klaviyo
                if (window.meta && window.meta.product) {
                  window.meta.product.selected_or_first_available_variant = variant;
                }

                // Update productJson global (Klaviyo might read from this)
                if (window.productJson) {
                  var productJsonVariant = window.productJson.variants.find(function (v) {
                    return v.id == variantId;
                  });
                  if (productJsonVariant) {
                    productJsonVariant.available = false;
                  }
                }

                // Update price display
                _self.updatePrice(variant);

                // When notify button is clicked, inject this variant into Klaviyo iframe
                var klaviyoBisTrigger = document.querySelector('.klaviyo-bis-trigger');
                if (klaviyoBisTrigger) {
                  klaviyoBisTrigger.addEventListener('click', function klaviyoHandler() {
                    var attempts = 0;
                    var maxAttempts = 10;
                    var injectVariant = setInterval(function () {
                      attempts++;
                      var klaviyoIframe = document.querySelector('#klaviyo-bis-iframe');
                      if (klaviyoIframe) {
                        try {
                          var iframeDoc = klaviyoIframe.contentDocument || klaviyoIframe.contentWindow.document;
                          var klaviyoVariantSelect = iframeDoc.querySelector('select#variants');
                          if (klaviyoVariantSelect) {
                            var existingOption = klaviyoVariantSelect.querySelector('option[value="' + variantId + '"]');
                            if (!existingOption) {
                              var option = iframeDoc.createElement('option');
                              option.value = variantId;
                              option.textContent = variant.title;
                              klaviyoVariantSelect.appendChild(option);
                            }

                            // Select the variant in the dropdown
                            klaviyoVariantSelect.value = variantId;
                            clearInterval(injectVariant);
                          }
                        } catch (e) {
                          // Iframe not accessible yet, will retry
                        }
                      }
                      if (attempts >= maxAttempts) {
                        clearInterval(injectVariant);
                      }
                    }, 200);
                  });
                }
              }
            }

            // Enable and show notify button for disabled sizes
            // Hide add to bag button and select size button
            _self.$submit.forEach(function (btn) {
              btn.classList.add(_self.c.cls.is_hidden);
              btn.style.display = 'none';
            });
            _self.$selectSizeButton.forEach(function (btn) {
              btn.classList.add(_self.c.cls.is_hidden);
              btn.style.display = 'none';
            });

            // Show the notify button - user will click it to open Klaviyo
            _self.$notifyMe.forEach(function (btn) {
              btn.classList.remove(_self.c.cls.is_hidden);
              btn.style.display = '';
            });
            var pvNotify = document.querySelector('.pv__notify');
            var jsNotify = document.querySelector('.js-notify');
            if (pvNotify) {
              pvNotify.classList.remove(_self.c.cls.is_hidden);
              pvNotify.classList.add('show');
              pvNotify.style.display = '';
            }
            if (jsNotify) {
              jsNotify.classList.remove(_self.c.cls.is_hidden);
              jsNotify.style.display = '';
            }
          } else {
            // Show add to bag button and hide notify button when selecting available size
            _self.$submit.forEach(function (btn) {
              btn.classList.remove(_self.c.cls.is_hidden);
              btn.style.display = '';
            });
            _self.$notifyMe.forEach(function (btn) {
              btn.classList.add(_self.c.cls.is_hidden);
              btn.style.display = 'none';
            });
            var pvNotify = document.querySelector('.pv__notify');
            var jsNotify = document.querySelector('.js-notify');
            if (pvNotify) {
              pvNotify.classList.add(_self.c.cls.is_hidden);
              pvNotify.classList.remove('show');
              pvNotify.style.display = 'none';
            }
            if (jsNotify) {
              jsNotify.classList.add(_self.c.cls.is_hidden);
              jsNotify.style.display = 'none';
            }
          }

          // If this is a bundle product, trigger bundle option change
          if (_self.hasBundle && el.classList.contains('is-bundle')) {
            _self.onBundleOptionChange();
          }
        });
        el.addEventListener('touchstart', function () {
          var addToBagWarning = document.querySelector('.add-to-bag-warning');
          if (addToBagWarning) addToBagWarning.remove();
          if (el.classList.contains('disabled')) {
            var oosTitle = document.querySelector('.config__group-title--oos');
            var configGroupTitle = document.querySelector('h4.config__group-title');
            if (oosTitle) oosTitle.classList.remove('hide');
            if (configGroupTitle) configGroupTitle.classList.add('oos-active');
          } else {
            var oosTitle = document.querySelector('.config__group-title--oos');
            var configGroupTitle = document.querySelector('h4.config__group-title');
            if (oosTitle) oosTitle.classList.add('hide');
            if (configGroupTitle) configGroupTitle.classList.remove('oos-active');
          }
          var index = Array.from(el.parentElement.children).indexOf(el);
          _self.checkSizeStock(index);
          if (_self.hasBundle && el.classList.contains('is-bundle')) {
            _self.onBundleOptionChange();
          }
        });
      });
      if (innerWidth > 768) {
        productCircles.forEach(function (el) {
          el.addEventListener('mouseover', function () {
            // Show/hide OOS message based on hovered size
            if (el.classList.contains('disabled')) {
              var oosTitle = document.querySelector('.config__group-title--oos');
              var configGroupTitle = document.querySelector('h4.config__group-title');
              if (oosTitle) oosTitle.classList.remove('hide');
              if (configGroupTitle) configGroupTitle.classList.add('oos-active');
            } else {
              var oosTitle = document.querySelector('.config__group-title--oos');
              var configGroupTitle = document.querySelector('h4.config__group-title');
              if (oosTitle) oosTitle.classList.add('hide');
              if (configGroupTitle) configGroupTitle.classList.remove('oos-active');
            }
          });
          el.addEventListener('mouseout', function () {
            // On mouseout, restore OOS state based on currently selected size
            var currentSelected = document.querySelector('.product-section .product__sizes .product__circle.current');
            if (currentSelected && currentSelected.classList.contains('disabled')) {
              var oosTitle = document.querySelector('.config__group-title--oos');
              var configGroupTitle = document.querySelector('h4.config__group-title');
              if (oosTitle) oosTitle.classList.remove('hide');
              if (configGroupTitle) configGroupTitle.classList.add('oos-active');
            } else {
              var oosTitle = document.querySelector('.config__group-title--oos');
              var configGroupTitle = document.querySelector('h4.config__group-title');
              if (oosTitle) oosTitle.classList.add('hide');
              if (configGroupTitle) configGroupTitle.classList.remove('oos-active');
            }
          });
        });
      }
    }
  }, {
    key: "checkSizeStock",
    value: function checkSizeStock(index) {
      if (document.querySelector('.product-type--bundle') || document.querySelector('.product-type--bundle-app')) return; // skip for bundle products

      var sizeStockEls = document.querySelectorAll('[data-size-stock]');
      sizeStockEls.forEach(function (el) {
        var sizeStock = JSON.parse(el.dataset.sizeStock);
        if (sizeStock[index] == 0) {
          el.classList.add('swatch-out-of-stock');
        } else {
          el.classList.remove('swatch-out-of-stock');
        }
      });
    }
  }, {
    key: "toggleSizeDisplay",
    value: function toggleSizeDisplay() {
      var hasOpen = this.$sizeContent[0] && this.$sizeContent[0].classList.contains(this.c.cls.open);
      if (hasOpen) {
        this.$sizeContent.forEach(function (el) {
          el.classList.remove('open');
        });
        this.$sizeContentInner.forEach(function (el) {
          el.classList.remove('open');
        });
        this.$btnArrow.forEach(function (el) {
          el.classList.remove('is-active');
        });
      } else {
        this.removeConflictingStyles();
        this.$sizeContent.forEach(function (el) {
          el.classList.add('open');
        });
        this.$sizeContentInner.forEach(function (el) {
          el.classList.add('open');
        });
        this.$btnArrow.forEach(function (el) {
          el.classList.add('is-active');
        });
      }
    }
  }, {
    key: "removeConflictingStyles",
    value: function removeConflictingStyles() {
      this.$sizeGuideInner.forEach(function (el) {
        el.style.height = '';
        el.classList.remove('is-taller');
      });
    }
  }, {
    key: "addBundleProductsToCart",
    value: function addBundleProductsToCart() {
      var sizePlaceholder = document.querySelector('.pv__size-placeholder');
      var productType = this.product ? this.product.type : null;

      // Handle 'Bundle' type - add individual component variants
      if (productType === 'Bundle') {
        var properties = {
          _tags: this.product.tags,
          _bundledProduct: true,
          _bundleHandle: this.product.handle
        };

        // Get mother product variant IDs to exclude them
        var motherVariantIds = this.product.variants.map(function (v) {
          return v.id;
        });
        var variantBundle = [];
        var currentCircles = document.querySelectorAll('.product__circle.current');
        currentCircles.forEach(function (el) {
          var variantId = el.dataset.variantId;
          // Only add if variantId exists and is NOT a mother product variant
          if (variantId && !motherVariantIds.includes(parseInt(variantId))) {
            variantBundle.unshift({
              id: variantId,
              quantity: 1
            });
          }
        });

        // If no size is selected, prevent add to cart and open "select size" display
        if (sizePlaceholder) {
          if (!this.$sizeContent[0] || !this.$sizeContent[0].classList.contains(this.c.cls.open)) {
            this.toggleSizeDisplay();
          }
        } else {
          // Add items sequentially to prevent race conditions
          var addItemsSequentially = /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
              var _iterator3, _step3, item, data, hasAmountValue, optionValue, _t5;
              return _regenerator().w(function (_context6) {
                while (1) switch (_context6.p = _context6.n) {
                  case 0:
                    _iterator3 = _createForOfIteratorHelper(variantBundle);
                    _context6.p = 1;
                    _iterator3.s();
                  case 2:
                    if ((_step3 = _iterator3.n()).done) {
                      _context6.n = 5;
                      break;
                    }
                    item = _step3.value;
                    _context6.n = 3;
                    return addItem(item.id, item.quantity, properties);
                  case 3:
                    data = _context6.v;
                    hasAmountValue = data.options_with_values[0].name === 'Amount';
                    if (hasAmountValue) {
                      optionValue = data.options_with_values[0].value;
                    } else {
                      optionValue = data.options_with_values[1].value;
                    }
                    window.bagItems.unshift({
                      product_data: data,
                      id: data.id,
                      price: data.price,
                      sku: data.sku,
                      size: optionValue,
                      subtitle: data.productSubtitle
                    });
                  case 4:
                    _context6.n = 2;
                    break;
                  case 5:
                    _context6.n = 7;
                    break;
                  case 6:
                    _context6.p = 6;
                    _t5 = _context6.v;
                    _iterator3.e(_t5);
                  case 7:
                    _context6.p = 7;
                    _iterator3.f();
                    return _context6.f(7);
                  case 8:
                    // Only show drawer and update cart after ALL items are added
                    showDrawer();
                    localStorage.pdpAddtoCart = true;
                    updateCart();
                  case 9:
                    return _context6.a(2);
                }
              }, _callee6, null, [[1, 6, 7, 8]]);
            }));
            return function addItemsSequentially() {
              return _ref2.apply(this, arguments);
            };
          }();
          addItemsSequentially().catch(function (error) {
            var errorMessage = error.message || error.description || 'Error adding to cart';
            console.error('Error: ' + errorMessage + '!');
            var productForm = document.getElementById('product__form');
            if (productForm) {
              productForm.insertAdjacentHTML('afterend', '<div style="padding:8px; text-align:center; background:transparent; margin-bottom:8px; color:#dc0000;" class="add-to-bag-warning">' + errorMessage + '</div>');
            }
          });
        }

        // Handle 'Bundle App' type - find and add matching mother bundle variant
      } else {
        var properties = {
          _tags: this.product ? this.product.tags : []
        };

        // Only collect sizes from circles that map to a bundle option.
        // Standalone O/S circles (no data-option-index) are visual-only — they represent
        // components that the Bundle App did NOT create a variant option for, so they
        // must not contribute to the variant match or the length check below will fail.
        // Ordered by data-option-index so it aligns with variant.option1/option2/option3.
        var selectedSizesMap = {};
        var matchedCircles = document.querySelectorAll('.product__circle.current[data-option-index]');
        matchedCircles.forEach(function (el) {
          var sizeValue = el.dataset.value;
          var optionIndex = el.dataset.optionIndex;
          if (sizeValue && optionIndex !== undefined && optionIndex !== null) {
            selectedSizesMap[optionIndex] = sizeValue;
          }
        });
        var selectedIndexes = Object.keys(selectedSizesMap);

        // Find the mother bundle product variant matching all selected sizes.
        // Match per option slot rather than requiring a selection for every option:
        // a component belonging to a non-active style toggle is not rendered at all
        // (see product-size-opts.liquid), so its slot has no circle to select and a
        // strict length check would never match. Prefer an in-stock variant.
        var bundleVariantId = null;
        if (selectedIndexes.length > 0 && this.product && this.product.variants) {
          var matchesSelection = function matchesSelection(v) {
            var variantOptions = [v.option1, v.option2, v.option3];
            return selectedIndexes.every(function (index) {
              return variantOptions[Number(index)] === selectedSizesMap[index];
            });
          };
          var matchingVariant = this.product.variants.find(function (v) {
            return v.available && matchesSelection(v);
          }) || this.product.variants.find(matchesSelection);
          if (matchingVariant) {
            bundleVariantId = matchingVariant.id;
          }
        }

        // If no size is selected, prevent add to cart and open "select size" display
        if (sizePlaceholder || !bundleVariantId) {
          if (!this.$sizeContent[0] || !this.$sizeContent[0].classList.contains(this.c.cls.open)) {
            this.toggleSizeDisplay();
          }
          // If a size is selected, add the bundle product to cart
        } else {
          addItem(bundleVariantId, 1, properties).then(function (data) {
            var hasAmountValue = data.options_with_values[0] && data.options_with_values[0].name === 'Amount';
            var optionValue;
            if (hasAmountValue) {
              optionValue = data.options_with_values[0].value;
            } else {
              optionValue = data.options_with_values[1] && data.options_with_values[1].value || data.options_with_values[0] && data.options_with_values[0].value;
            }
            window.bagItems.unshift({
              product_data: data,
              id: data.id,
              price: data.price,
              sku: data.sku,
              size: optionValue,
              subtitle: data.productSubtitle
            });
            showDrawer();
            localStorage.pdpAddtoCart = true;
            updateCart();
          }).catch(function (error) {
            var errorMessage = error.message || error.description || 'Error adding to cart';
            console.error('Error: ' + errorMessage + '!');
            var productForm = document.getElementById('product__form');
            if (productForm) {
              productForm.insertAdjacentHTML('afterend', '<div style="padding:8px; text-align:center; background:transparent; margin-bottom:8px; color:#dc0000;" class="add-to-bag-warning">' + errorMessage + '</div>');
            }
          });
        }
      }
    }
  }, {
    key: "addToCart",
    value: function addToCart() {
      // One add at a time. There was no guard here at all, so a fast double-tap posted
      // /cart/add.js twice and put two units in the bag. It also has to hold now that a
      // swallowed tap can be replayed — replay plus a real second tap is the same race.
      if (this._addInFlight) return;

      // `this.product` is NOT safe to deref bare. init() reassigns it from
      // getProductJson(), which resolves to null on any failed or unparseable response, and
      // this line is the first thing every tap runs.
      if (!this.product) return;
      var properties = {
        _tags: this.product.tags
      };
      var quantity = 1;
      var sizePlaceholder = document.querySelector('.pv__size-placeholder');
      var sizeSelections = document.querySelectorAll('.product__sizes.sizes-wrapper.flex-around');

      // If no size is selected, prevent add to cart and open "select size" display
      if (sizePlaceholder) {
        // Only opens the "select size" display, doesn't toggle open and closed
        if (!this.$sizeContent[0] || !this.$sizeContent[0].classList.contains(this.c.cls.open)) {
          this.toggleSizeDisplay();
        }

        // If a size is selected, proceed to add item to cart
      } else {
        var self = this;
        var currentCircle = document.querySelector('.product-section .product__circle.current');
        var checkedLabel = document.querySelector('body #configGroupTitle .config__variant input:checked + label');
        // The last three fallbacks come from the SFS work: the gate below needs a variant
        // id even on surfaces where no size circle is marked current (direct ?variant= URL,
        // hidden form input, vendor product form).
        var variantToAdd = currentCircle && currentCircle.dataset.variantId || checkedLabel && checkedLabel.dataset.variantId || this.productForm && this.productForm.variant() && this.productForm.variant().id || this.$productForm && this.$productForm.querySelector('input[name="id"]') && this.$productForm.querySelector('input[name="id"]').value || new URLSearchParams(window.location.search).get('variant');
        if (variantToAdd) {
          // SFS gate: refuse variants the fe_sfs.web_purchasable metafield marks as not
          // purchasable online, and enforce the max purchasable quantity against what is
          // already in the cart. Silent by design — the gate stops the add, no message.
          var sfsVariant = (this.product && this.product.variants || []).find(function (v) {
            return String(v.id) === String(variantToAdd);
          });
          var sfsPolicy = parseSfsPolicy(this.sfsPolicyByVariantId[String(variantToAdd)]);
          var sfsCartItems = window.CartJS && CartJS.cart && CartJS.cart.items || [];
          var sfsDesiredQuantity = cartQuantityForVariant(sfsCartItems, variantToAdd) + quantity;
          var sfsResult = validateSfsDesiredQuantity(sfsPolicy, sfsDesiredQuantity, {
            name: sfsVariant ? sfsVariant.name : ''
          });
          // Pre-order is exempt here too — see isSfsBlockedVariantId.
          if (!this.isPreOrder && !sfsResult.allowed) return;
          this._addInFlight = true;
          addItem(variantToAdd, quantity, properties).then(function (data) {
            var hasAmountValue = data.options_with_values[0].name === 'Amount';
            var optionValue;
            if (hasAmountValue) {
              optionValue = data.options_with_values[0].value;
            } else {
              optionValue = data.options_with_values[1].value;
            }
            window.bagItems.unshift({
              product_data: data,
              id: data.id,
              quantity: data.quantity,
              price: data.price,
              sku: data.sku,
              size: optionValue,
              subtitle: data.productSubtitle
            });
            // ga4 add_to_cart
            dataLayer.push({
              event: 'add_to_cart',
              ecommerce: {
                items: [{
                  item_name: data.product_title,
                  item_id: data.id,
                  price: (data.price / 100).toFixed(2),
                  item_brand: data.vendor,
                  item_category: data.product_type,
                  item_variant: data.variant_title,
                  index: 1,
                  quantity: 1
                }]
              }
            });

            // algolia addToCard
            var urlParams = new URLSearchParams(window.location.search);
            var queryID = urlParams.get('queryID');
            if (queryID && sessionStorage.objectID) {
              var shopifyIndex = 'shopify_products';
              aa('sendEvents', [{
                eventType: 'conversion',
                eventName: 'Add To Cart',
                index: shopifyIndex,
                queryID: queryID,
                objectIDs: [sessionStorage.objectID.toString()],
                objectData: [{
                  price: (data.price / 100).toFixed(2),
                  quantity: data.quantity
                }],
                value: (data.price / 100).toFixed(2),
                currency: localStorage.currency
              }, {
                eventType: 'conversion',
                eventName: 'Product Converted',
                index: shopifyIndex,
                queryID: queryID,
                objectIDs: [sessionStorage.objectID.toString()],
                objectData: [{
                  price: (data.price / 100).toFixed(2),
                  quantity: data.quantity
                }],
                value: (data.price / 100).toFixed(2),
                currency: localStorage.currency
              }], {
                headers: {
                  'X-Algolia-Application-Id': 'KGAFHAS2GH',
                  'X-Algolia-API-Key': 'd8ad85f4e5e1afac9683fea28cf67954'
                },
                inferQueryID: true
              });
            }
            window.liQ.push({
              "event": "conversion",
              "name": "addToCart",
              "items": [{
                name: data.product_title,
                quantity: data.quantity,
                price: data.price,
                id: data.id
              }]
            });
            showDrawer();
            localStorage.pdpAddtoCart = true;
            updateCart();
          }).catch(function (err) {
            var errorMessage = err.message || err.description || 'Error adding to cart';
            console.error('Error: ' + errorMessage + '!');
          }).then(function () {
            // Cleared on success AND failure — a failed add must leave the button usable.
            self._addInFlight = false;
          });
        }
      }
    }
  }, {
    key: "setCartCount",
    value: function setCartCount(elm) {
      var newCount = Number(elm.textContent) + 1;
      elm.textContent = newCount;
    }
  }, {
    key: "quickAdd",
    value: function quickAdd() {
      var self = this;
      var qaButtons = document.querySelectorAll('.js-add-to-bag.qa');
      qaButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var variantId = window.qaVarId;
          var tagData = btn.dataset.tags;
          var properties = {
            _tags: tagData ? tagData.split(',') : []
          };
          var quantity = 1;
          if (variantId && variantId.length) {
            addItem(variantId, quantity, properties).then(function (data) {
              var hasAmountValue = data.options_with_values[0].name === 'Amount';
              var optionValue;
              if (hasAmountValue) {
                optionValue = data.options_with_values[0].value;
              } else {
                optionValue = data.options_with_values[1].value;
              }
              window.bagItems.unshift({
                product_data: data,
                id: data.id,
                price: data.price,
                sku: data.sku,
                size: optionValue,
                subtitle: data.productSubtitle
              });
              showDrawer();
              updateCart();
              var closeBtn = document.querySelector('.quick-add__content .close');
              if (closeBtn) closeBtn.click(); // close qa modal
            }).catch(function (err) {
              var errorMessage = err.message || err.description || 'Error adding to cart';
              console.error('Error: ' + errorMessage + '!');
            });
          } else {
            var sibling = btn.previousElementSibling;
            var hasWarning = sibling && sibling.classList.contains('add-to-bag-warning');
            if (!hasWarning) {
              btn.insertAdjacentHTML('beforebegin', '<div style="padding:8px; text-align:center; background:transparent; margin-bottom:8px; color:#dc0000;" class="add-to-bag-warning">Please select a size</div>');
              // AMP: Announce to screen readers via live region
              var liveRegion = document.getElementById('add-to-bag-live-region');
              if (liveRegion) {
                liveRegion.textContent = '';
                setTimeout(function () {
                  liveRegion.textContent = 'Please select a size';
                }, 100);
              }
            }
          }
        });
      });
    }
  }, {
    key: "updateGiftCardImage",
    value: function updateGiftCardImage(variant) {
      var giftCardGallery = document.querySelector('.gift-card-gallery');
      var images = giftCardGallery.querySelectorAll('img');
      var variantValue = variant.option2.replace(/[^0-9\.]/g, '');
      images.forEach(function (image) {
        var altText = image.getAttribute('alt');
        if (altText === variantValue) {
          image.classList.remove('hidden');
        } else {
          image.classList.add('hidden');
        }
      });
    }
  }, {
    key: "updateGiftCardVariantTitle",
    value: function updateGiftCardVariantTitle(variant) {
      var checkedRadio = document.querySelector('.js-config-radio:checked + label');
      var price = checkedRadio ? checkedRadio.textContent.trim() : '';
      var giftCardValue = document.querySelector('.config__header .config__group-title.js-gift-card-value');
      if (giftCardValue) giftCardValue.textContent = price + ' Gift Card';
      // update sku
      var skuEl = document.querySelector('.js-sku');
      if (skuEl) skuEl.textContent = 'Style Code: ' + variant.sku;
    }
  }, {
    key: "selectLastGiftCardValue",
    value: function selectLastGiftCardValue() {
      var options = document.querySelectorAll('.config__btn--title');
      var optionLast = options[options.length - 1];
      if (optionLast) optionLast.click();
    }
  }, {
    key: "updatePrice",
    value: function updatePrice(variant) {
      if (!variant || !this.$price) return;
      this.$price.forEach(function (el) {
        el.textContent = format_money(variant.price, 'amount_with_currency_without_trailing_zeros');
      });
    }
  }, {
    key: "updateSubmitButton",
    value: function updateSubmitButton(variant) {
      var self = this;
      this.$selectSizeButton.forEach(function (el) {
        el.classList.add(self.c.cls.is_hidden);
      });
      var pvNotify = document.querySelector('.pv__notify');
      // SFS: never surface Notify Me from here. It appears only once the customer actively
      // selects a blocked size (handled in the .product__circle click handler).
      if (pvNotify) pvNotify.classList.remove('show');
      var currentSizes = document.querySelectorAll('.product__sizes .current');
      if (!variant) {
        this.$submit.forEach(function (el) {
          el.disabled = true;
        });
        this.$submitText.forEach(function (el) {
          el.textContent = 'Unavailable';
        });

        // SFS: no size has been actively selected yet — e.g. a direct ?variant= URL pointing
        // at an SFS-blocked or out-of-stock size. Stay in the no-size-selected state and show
        // "Select size"; Notify Me must never appear from a URL param alone.
      } else if (!variant.name.includes('Gift Card') && currentSizes.length === 0) {
        this.$submit.forEach(function (el) {
          el.disabled = true;
          el.classList.add(self.c.cls.is_hidden);
          el.style.display = 'none';
        });
        this.$notifyMe.forEach(function (el) {
          el.classList.add(self.c.cls.is_hidden);
          el.style.display = 'none';
        });
        if (pvNotify) {
          pvNotify.classList.add(self.c.cls.is_hidden);
          pvNotify.classList.remove('show');
          pvNotify.style.display = 'none';
        }
        this.$selectSizeButton.forEach(function (el) {
          el.classList.remove(self.c.cls.is_hidden);
          el.style.display = '';
        });
      } else if (!this.isSfsBlockedVariant(variant) && (variant.available && currentSizes.length > 0 || variant.name.includes('Gift Card'))) {
        this.$submit.forEach(function (el) {
          el.disabled = false;
        });
        this.$submit.forEach(function (el) {
          el.classList.remove(self.c.cls.is_hidden);
        });
        var preorderEl = document.querySelector('.pv__add-to-bag--preorder');
        if (preorderEl) preorderEl.classList.add('active');
        this.$notifyMe.forEach(function (el) {
          el.classList.add(self.c.cls.is_hidden);
        });
        if (this.isPreOrder) {
          this.$submitText.forEach(function (el) {
            el.textContent = self.c.preOrderText;
          });
        } else {
          this.$submitText.forEach(function (el) {
            el.textContent = self.c.addToBagText;
          });
        }
      } else {
        this.$submit.forEach(function (el) {
          el.disabled = true;
        });
        this.$submit.forEach(function (el) {
          el.classList.add(self.c.cls.is_hidden);
        });
        this.$notifyMe.forEach(function (el) {
          el.classList.remove(self.c.cls.is_hidden);
        });
        this.$submitText.forEach(function (el) {
          el.textContent = 'Out of Stock';
        });
      }
    }
  }], [{
    key: "getProductJson",
    value: function getProductJson(handle) {
      if (!handle) return Promise.resolve(null);
      return fetch("/products/".concat(handle, ".js")).then(function (response) {
        if (!response.ok) return null;
        return response.json().catch(function () {
          return null;
        });
      }).catch(function () {
        return null;
      });
    }
  }, {
    key: "fabricLabelForSwatch",
    value: function fabricLabelForSwatch(swatch) {
      var node = swatch;
      while (node && node !== document.body) {
        var labels = node.querySelectorAll('.pv-details__fabric');
        if (labels.length === 1) return labels[0];
        if (labels.length > 1) return null;
        node = node.parentElement;
      }
      return null;
    }
  }]);
}();
/* harmony default export */ var product_configurables = (ProductConfigurables);
;// ./src/js/sections/product/product-size-chart.js
function product_size_chart_typeof(o) { "@babel/helpers - typeof"; return product_size_chart_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, product_size_chart_typeof(o); }
function product_size_chart_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function product_size_chart_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, product_size_chart_toPropertyKey(o.key), o); } }
function product_size_chart_createClass(e, r, t) { return r && product_size_chart_defineProperties(e.prototype, r), t && product_size_chart_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function product_size_chart_toPropertyKey(t) { var i = product_size_chart_toPrimitive(t, "string"); return "symbol" == product_size_chart_typeof(i) ? i : i + ""; }
function product_size_chart_toPrimitive(t, r) { if ("object" != product_size_chart_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != product_size_chart_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


/**
 * Product Size Chart
 */
var ProductSizeChart = /*#__PURE__*/function () {
  function ProductSizeChart() {
    product_size_chart_classCallCheck(this, ProductSizeChart);
    this.config = {
      dom: {
        trigger: 'js-chart-trigger',
        content: 'pvSizeChart',
        close: 'size-chart__close',
        scrollingContent: 'js-scrolling-content'
      },
      cls: {
        open: 'open'
      }
    };
    this.chart = document.getElementById(this.config.dom.content);
    this.scrollingContent = document.querySelector('.' + this.config.dom.scrollingContent);
    this.init();
  }
  return product_size_chart_createClass(ProductSizeChart, [{
    key: "init",
    value: function init() {
      this.addEvents();
    }
  }, {
    key: "addEvents",
    value: function addEvents() {
      var self = this;
      var triggers = document.querySelectorAll('.' + this.config.dom.trigger);
      triggers.forEach(function (el) {
        el.addEventListener('click', self.toggleVisibility.bind(self));
      });
      var closeBtns = document.querySelectorAll('.' + this.config.dom.close);
      closeBtns.forEach(function (el) {
        el.addEventListener('click', self.closeChart.bind(self));
      });
    }
  }, {
    key: "toggleVisibility",
    value: function toggleVisibility() {
      var triggers = document.querySelectorAll('.' + this.config.dom.trigger);
      if (this.chart.classList.contains(this.config.cls.open)) {
        this.closeChart();
        triggers.forEach(function (el) {
          el.setAttribute('aria-expanded', false);
        });
      } else {
        this.openChart();
        triggers.forEach(function (el) {
          el.setAttribute('aria-expanded', true);
        });
      }
    }
  }, {
    key: "closeChart",
    value: function closeChart() {
      this.chart.classList.remove(this.config.cls.open);
      bodyScrollLock.clearAllBodyScrollLocks();
      var triggers = document.querySelectorAll('.' + this.config.dom.trigger);
      triggers.forEach(function (el) {
        el.setAttribute('aria-expanded', false);
        el.setAttribute('aria-hidden', true);
      });
    }
  }, {
    key: "openChart",
    value: function openChart() {
      if (this.scrollingContent) this.scrollingContent.scrollTop = 0;
      this.chart.classList.add(this.config.cls.open);
      var triggers = document.querySelectorAll('.' + this.config.dom.trigger);
      triggers.forEach(function (el) {
        el.setAttribute('aria-expanded', true);
        el.setAttribute('aria-hidden', true);
      });
    }
  }]);
}();
/* harmony default export */ var product_size_chart = (ProductSizeChart);
// EXTERNAL MODULE: ./node_modules/flickity/js/index.js
var js = __webpack_require__(522);
var js_default = /*#__PURE__*/__webpack_require__.n(js);
;// ./src/js/sections/product/product-style-with.js


/**
 * Product Style With
 */
function productStyleWith() {
  var $styleWithWrap = document.getElementById('styleWithList');
  function init() {
    // initCarousel()
  }
  function initCarousel() {
    var flickityOptions = {
      prevNextButtons: false,
      watchCSS: true,
      pageDots: true
    };
    if ($styleWithWrap) {
      // eslint-disable-next-line
      var flkty = new (js_default())($styleWithWrap, flickityOptions);
    }
  }
  return init();
}
/* harmony default export */ var product_style_with = (productStyleWith);
;// ./src/js/utils/localStorage.js
function doesLocalStorageExist() {
  try {
    window.localStorage.setItem('test', 'test');
    window.localStorage.removeItem('test');
    return true;
  } catch (error) {
    return false;
  }
}
function setLocalStorage(key, value) {
  if (!doesLocalStorageExist()) return; // eslint-disable-line curly

  window.localStorage.setItem(key, value);
}
function getLocalStorage(key) {
  if (!doesLocalStorageExist()) return null; // eslint-disable-line curly

  return window.localStorage.getItem(key);
}
;// ./src/js/sections/product/product-size-guide.js
function product_size_guide_typeof(o) { "@babel/helpers - typeof"; return product_size_guide_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, product_size_guide_typeof(o); }
function _defineProperty(e, r, t) { return (r = product_size_guide_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function product_size_guide_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function product_size_guide_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, product_size_guide_toPropertyKey(o.key), o); } }
function product_size_guide_createClass(e, r, t) { return r && product_size_guide_defineProperties(e.prototype, r), t && product_size_guide_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function product_size_guide_toPropertyKey(t) { var i = product_size_guide_toPrimitive(t, "string"); return "symbol" == product_size_guide_typeof(i) ? i : i + ""; }
function product_size_guide_toPrimitive(t, r) { if ("object" != product_size_guide_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != product_size_guide_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Product Size Guide
 */




var product_size_guide_selectors = {
  productForm: '.js-product-form',
  addToCart: '[data-add-to-cart]',
  addToCartText: '[data-add-to-cart-text]',
  comparePrice: '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  originalSelectorId: '[data-product-select]',
  priceWrapper: '[data-price-wrapper]',
  productImageWrapper: '[data-product-image-wrapper]',
  productFeaturedImage: '[data-product-featured-image]',
  productJson: '[data-product-json]',
  currentVariantJson: '[data-current-variant-json]',
  productPrice: '[data-product-price]',
  productThumbs: '[data-product-single-thumbnail]',
  singleOptionSelector: '[data-single-option-selector]',
  patternSelector: '.pattern-selector',
  patternDropdown: '.pattern-selector-others',
  patternSelectorWrap: '.pattern-selector-wrap',
  descriptionWrap: '.info__text',
  productTitle: '#productTitle:not(.dropdown-disabled)',
  selectedColor: '[data-selected-color]',
  collectionLoader: '.collection__loader',
  selectSizeButton: 'js-select-size',
  isHidden: 'is-hidden',
  optionSelector: '.option-selector',
  productOptions: {
    panel: '.product__options',
    colors: '.product__options__color',
    sizes: '.product__options__size',
    close: '#sizeClose'
  },
  arrow: '.js-size-chevron',
  sizePanel: '.js-size-panel',
  sizeGuide: {
    backButton: '.size-guide .back-button',
    cancelButton: '.size-guide__cancel',
    container: '.js-size-guide',
    sizeChart: '.size-chart',
    sizeChartOpen: '.size-guide__chart-open',
    sizeChartClose: '.size-chart__close',
    close: '.size-guide__close',
    cta: '.size-guide__cta',
    desktopParent: '.product__options__size',
    pageContainer: '.size-guide .page__container',
    sizeGuideInner: '.size-guide .size-guide__inner',
    dropdowns: '[data-size-guide-dropdown]',
    desktopOptions: '.desktop--options',
    mobileOpen: '.js-size-mobile-open',
    pageThree: '.page__three',
    redo: '.page__redo',
    recommendation: '.size-guide__recommended',
    scrollingContent: '.js-scrolling-content',
    sizesBottom: '.product__options__size .sizes-bottom',
    sizesTop: '.product__options__size .sizes-top',
    soldOut: '.page__sold-out',
    soldOutOptions: '.page__sold-out__option',
    soldOutOptionContainer: '.page__sold-out__option-container',
    steps: '[data-size-guide-step]',
    trigger: '#sizeChartTrigger'
  }
};
var debugPage = false;

// Helper function for find functionality
function find(arr, conditions) {
  return arr.find(function (item) {
    return Object.keys(conditions).every(function (key) {
      return item[key] === conditions[key];
    });
  });
}
var ProductSizeGuide = /*#__PURE__*/function () {
  function ProductSizeGuide() {
    product_size_guide_classCallCheck(this, ProductSizeGuide);
    this.quantitiesBySize = {};
    this.quantitiesByColor = {};
    this.sizeQuantitiesByColor = {};
    this.initSizePicker.apply(this);
    this.init();
  }
  return product_size_guide_createClass(ProductSizeGuide, [{
    key: "init",
    value: function init() {
      var self = this;
      var sizeGuide = document.querySelector(product_size_guide_selectors.sizeGuide.container);
      var sizeChartTrigger = document.querySelector(product_size_guide_selectors.sizeGuide.trigger);
      var outerParent = document.querySelector(product_size_guide_selectors.productOptions.panel);
      var backButton = document.querySelector(product_size_guide_selectors.sizeGuide.backButton);
      var cancelButton = document.querySelector(product_size_guide_selectors.sizeGuide.cancelButton);
      var addToCartButtons = document.querySelectorAll(product_size_guide_selectors.addToCart);
      var closeButtons = document.querySelectorAll(product_size_guide_selectors.sizeGuide.close);
      var sizeChart = document.querySelector(product_size_guide_selectors.sizeGuide.sizeChart);
      var sizeChartOpen = document.querySelector(product_size_guide_selectors.sizeGuide.sizeChartOpen);
      var sizeChartClose = document.querySelector(product_size_guide_selectors.sizeGuide.sizeChartClose);
      var mobileOpen = document.querySelector(product_size_guide_selectors.sizeGuide.mobileOpen);
      var pageThree = document.querySelector(product_size_guide_selectors.sizeGuide.pageThree);
      var scrollingContent = document.querySelector(product_size_guide_selectors.sizeGuide.scrollingContent);
      var sizesTop = document.querySelector(product_size_guide_selectors.sizeGuide.sizesTop);
      var sizeGuidePageContainer = document.querySelector(product_size_guide_selectors.sizeGuide.pageContainer);
      var sizeGuideInner = document.querySelector(product_size_guide_selectors.sizeGuide.sizeGuideInner);
      var dropdowns = document.querySelectorAll(product_size_guide_selectors.sizeGuide.dropdowns);
      var variantSizeDropdown = document.querySelector('.option-Size');
      var variantColorDropdown = document.querySelector('.option-Color');
      var recommendation = document.querySelector(product_size_guide_selectors.sizeGuide.recommendation);
      var redo = document.querySelector(product_size_guide_selectors.sizeGuide.redo);
      var soldOut = document.querySelector(product_size_guide_selectors.sizeGuide.soldOut);
      var soldOutOptionContainer = document.querySelector(product_size_guide_selectors.sizeGuide.soldOutOptionContainer);
      var soldOutOptionTemplate = document.querySelector(product_size_guide_selectors.sizeGuide.soldOutOptions + '.template');
      var steps = document.querySelectorAll(product_size_guide_selectors.sizeGuide.steps);
      var cta = document.querySelector(product_size_guide_selectors.sizeGuide.cta);
      var productFormEl = document.querySelector(product_size_guide_selectors.productForm);
      var infoCTAWrappers = document.querySelectorAll('.info__cta-wrapper');
      var mobileSizeGuideCTA = infoCTAWrappers[2];
      var selectSizeButtons = document.querySelectorAll('.' + product_size_guide_selectors.selectSizeButton);
      var step = 0;
      var recommendedSize = null;
      var showingColors = false;
      var showingSizes = false;
      var colorTrigger = document.querySelector(product_size_guide_selectors.optionSelector + '.color');
      var sizeTrigger = document.querySelector(product_size_guide_selectors.optionSelector + '.size');
      var panel = document.querySelector(product_size_guide_selectors.productOptions.panel);
      var colors = document.querySelector(product_size_guide_selectors.productOptions.colors);
      var sizes = document.querySelector(product_size_guide_selectors.productOptions.sizes);
      var small = getCssVar('small') || '620px';
      this.desktopMq = window.matchMedia('(min-width: ' + small + ')');

      // product data
      if (!productJson) return;
      this.productSingleObject = productJson;
      this.initialVariant = currentVariant;

      // Set the option number for color and for size
      this.colorOptionNumber = this.productSingleObject.options.indexOf('Color') + 1;
      this.sizeOptionNumber = this.productSingleObject.options.indexOf('Size') + 1;
      function doTransition() {
        if (panel) panel.classList.remove('open');
        if (productFormEl) productFormEl.classList.remove('open');
        if (colors) colors.classList.remove('open');
        if (sizes) sizes.classList.remove('open');
        if (colorTrigger) colorTrigger.classList.remove('open');
        if (sizeTrigger) sizeTrigger.classList.remove('open');
        var patternWrap = document.querySelector(product_size_guide_selectors.patternSelectorWrap);
        var descWrap = document.querySelector(product_size_guide_selectors.descriptionWrap);
        var prodTitle = document.querySelector(product_size_guide_selectors.productTitle);
        if (patternWrap) patternWrap.classList.remove('pattern-selector-wrap--dekstop-open');
        if (descWrap) descWrap.classList.remove('pattern-selector-wrap--dekstop-open');
        if (prodTitle) prodTitle.classList.remove('dropdown-open');
      }
      self.enteredData = {
        height: null,
        weight: null
      };
      self.initDropdowns.call(this, dropdowns);
      var isLasses = sizeGuide && sizeGuide.classList.contains('lasses');
      var isLads = sizeGuide && sizeGuide.classList.contains('lads');
      if (mobileOpen) {
        mobileOpen.addEventListener('click', function () {
          if (isLads) {
            openSizeChart();
          } else {
            openSizeGuide();
          }
        });
      }
      if (sizeGuide) {
        sizeGuide.addEventListener('click', function () {
          if (isLads) {
            openSizeChart();
          } else {
            openSizeGuide();
          }
        });
      }
      if (sizeChartTrigger) {
        sizeChartTrigger.addEventListener('click', function () {
          if (self.desktopMq.matches) {
            openSizeChart();
          }
        });
      }
      closeButtons.forEach(function (btn) {
        btn.addEventListener('click', closeSizeGuide.bind(self));
      });
      if (cancelButton) {
        cancelButton.addEventListener('click', closeSizeGuide);
      }
      if (sizeChartOpen) {
        sizeChartOpen.addEventListener('click', openSizeChart);
      }
      if (sizeChartClose) {
        sizeChartClose.addEventListener('click', closeSizeChart);
      }
      dropdowns.forEach(function (dropdown) {
        dropdown.addEventListener('change', updateValue);
      });
      if (cta) {
        cta.addEventListener('click', handleCtaClick);
      }
      if (redo) {
        redo.addEventListener('click', reset);
      }
      if (backButton) {
        backButton.addEventListener('click', function () {
          setStep(step - 1);
        });
      }
      addToCartButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          closeSizeGuide();
          showingSizes = !showingSizes;
          showingColors = false;
          doTransition();
        });
      });
      this.desktopMq.addListener(function () {
        closeSizeChart();
        closeSizeGuide();
      });
      removeSizeFromSKU();
      function removeSizeFromSKU() {
        var skuEls = document.querySelectorAll('.js-sku');
        if (skuEls.length > 0) {
          var newSku = skuEls[0].innerHTML.split('-');
          newSku.pop();
          newSku = newSku.join('-');
          skuEls.forEach(function (sku) {
            sku.innerHTML = newSku;
          });
        }
      }
      function updateValue(evt) {
        var value = evt.target.value;
        var numberedSizing = evt.target.dataset.numberedSizing;
        var data = evt.target.dataset.sizeGuideDropdown;
        self.enteredData[data] = value;
        if (data === 'height') setStep(2, 750);else if (data === 'weight') {
          setStep(3, 750);
          calculateRecommendedSize(numberedSizing);
        }
        setCtaState();
      }
      function setCtaState() {
        var valid = false;
        if (step === 1) {
          valid = self.enteredData.height;
        } else if (step === 2) {
          valid = self.enteredData.weight;
        } else if (step === 3) {
          valid = true;
          applySizeToSelection();
        }
        if (valid && cta) cta.classList.remove('disabled');else if (cta) cta.classList.add('disabled');
      }
      function handleCtaClick(ev) {
        if (ev && ev.stopPropagation) ev.stopPropagation();
        if (cta && cta.classList.contains('disabled')) return;
        if (step === 3) {
          applySizeToSelection();
          closeSizeGuide();
          return;
        }
        if (step === 2) {
          calculateRecommendedSize();
        }
        setStep(step + 1);
      }
      function calculateRecommendedSize(numberedSizing) {
        /* eslint-disable */
        var heightWeightMatrix = [/* 100   105   110   115   120   125   130   135   140   145   150   155   160   165   170   175   180   185   190   195   200 */
        /* "60 "*/
        ['xs', 'xs', 'xs', 'xs', 's', 's', 'm', 'm', 'm', 'm', 'm', 'l', 'l', 'l', 'xl', 'xl', 'xl', 'xl', 'xl', 'xl', 'xl'], /* "61 "*/
        ['xs', 'xs', 'xs', 'xs', 's', 's', 'm', 'm', 'm', 'm', 'm', 'l', 'l', 'l', 'xl', 'xl', 'xl', 'xl', 'xl', 'xl', 'xl'], /* "62 "*/
        ['xs', 'xs', 'xs', 'xs', 's', 's', 's', 's', 'm', 'm', 'm', 'l', 'l', 'l', 'xl', 'xl', 'xl', 'xl', 'xl', 'xl', 'xl'], /* "63 "*/
        ['xs', 'xs', 'xs', 'xs', 's', 's', 's', 's', 'm', 'm', 'm', 'm', 'm', 'l', 'l', 'l', 'l', 'xl', 'xl', 'xl', 'xl'], /* "64 "*/
        ['xs', 'xs', 'xs', 'xs', 's', 's', 's', 's', 'm', 'm', 'm', 'm', 'm', 'l', 'l', 'l', 'l', 'xl', 'xl', 'xl', 'xl'], /* "65 "*/
        ['xs', 'xs', 'xs', 'xs', 's', 's', 's', 's', 'm', 'm', 'm', 'm', 'm', 'l', 'l', 'l', 'l', 'xl', 'xl', 'xl', 'xl'], /* "66 "*/
        ['xs', 'xs', 'xs', 'xs', 's', 's', 's', 's', 'm', 'm', 'm', 'm', 'm', 'l', 'l', 'l', 'l', 'xl', 'xl', 'xl', 'xl'], /* "67 "*/
        ['xs', 'xs', 'xs', 'xs', 's', 's', 's', 's', 'm', 'm', 'm', 'm', 'm', 'l', 'l', 'l', 'l', 'xl', 'xl', 'xl', 'xl'], /* "68 "*/
        ['xs', 'xs', 'xs', 'xs', 's', 's', 's', 's', 'm', 'm', 'm', 'm', 'm', 'l', 'l', 'l', 'l', 'xl', 'xl', 'xl', 'xl'], /* "69 "*/
        ['xs', 'xs', 'xs', 'xs', 's', 's', 's', 's', 'm', 'm', 'm', 'm', 'm', 'l', 'l', 'l', 'l', 'xl', 'xl', 'xl', 'xl'], /* "70 "*/
        ['xs', 'xs', 'xs', 'xs', 's', 's', 's', 's', 'm', 'm', 'm', 'm', 'm', 'l', 'l', 'l', 'l', 'xl', 'xl', 'xl', 'xl'], /* "71 "*/
        ['s', 's', 's', 's', 's', 's', 's', 's', 'm', 'm', 'm', 'm', 'm', 'l', 'l', 'l', 'l', 'xl', 'xl', 'xl', 'xl'], /* "72 "*/
        ['s', 's', 's', 's', 's', 's', 'm', 'm', 'm', 'm', 'm', 'm', 'm', 'l', 'l', 'l', 'l', 'xl', 'xl', 'xl', 'xl']];
        var heightWeightNumberedMatrix = [/* 100   105   110   115   120   125   130   135   140   145   150   155   160   165   170   175   180   185   190   195   200 */
        /* "60 "*/
        ['0', '0', '0', '0', '2', '2', '4', '4', '6', '6', '6', '8', '8', '10', '10', '12', '12', '12', '12', '12', '12'], /* "61 "*/
        ['0', '0', '0', '0', '2', '2', '4', '4', '6', '6', '6', '8', '8', '10', '10', '12', '12', '12', '12', '12', '12'], /* "62 "*/
        ['0', '0', '0', '0', '2', '2', '4', '4', '6', '6', '6', '8', '8', '10', '10', '12', '12', '12', '12', '12', '12'], /* "63 "*/
        ['0', '0', '0', '0', '2', '2', '4', '4', '6', '6', '6', '8', '8', '10', '10', '12', '12', '12', '12', '12', '12'], /* "64 "*/
        ['0', '0', '0', '0', '2', '4', '4', '4', '6', '6', '6', '8', '8', '10', '10', '12', '12', '12', '12', '12', '12'], /* "65 "*/
        ['0', '0', '0', '0', '2', '4', '4', '6', '6', '6', '6', '8', '8', '10', '10', '12', '12', '12', '12', '12', '12'], /* "66 "*/
        ['2', '2', '2', '2', '2', '4', '4', '6', '6', '6', '6', '8', '8', '10', '10', '12', '12', '12', '12', '12', '12'],
        /* "67 "*
        ['2', '2', '2', '2', '2', '4', '6', '6', '6', '6', '8', '8', '8', '10', '10', '12', '12', '12', '12', '12', '12'],
        /* "68 "*/
        ['4', '4', '4', '4', '4', '4', '6', '6', '6', '6', '8', '8', '8', '10', '10', '12', '12', '12', '12', '12', '12'], /* "69 "*/
        ['4', '4', '4', '4', '6', '6', '6', '6', '6', '6', '8', '8', '8', '10', '10', '12', '12', '12', '12', '12', '12'], /* "70 "*/
        ['4', '6', '6', '6', '6', '8', '8', '8', '8', '8', '8', '8', '8', '10', '10', '12', '12', '12', '12', '12', '12'], /* "71 "*/
        ['4', '6', '6', '6', '6', '8', '8', '8', '8', '8', '8', '8', '8', '10', '10', '12', '12', '12', '12', '12', '12'], /* "72 "*/
        ['4', '6', '6', '6', '6', '8', '8', '8', '8', '8', '8', '8', '8', '10', '10', '12', '12', '12', '12', '12', '12']];
        /* eslint-enable */

        var heightIndex;
        var weightIndex;
        var inches;
        try {
          inches = 60 + Number(self.enteredData.height);
          if (inches < 60 || inches > 72) {
            throw new Error('out of range');
          }
          heightIndex = inches - 60;
          weightIndex = self.enteredData.weight;
          recommendedSize = numberedSizing ? heightWeightNumberedMatrix[heightIndex][weightIndex] : heightWeightMatrix[heightIndex][weightIndex];
        } catch (err) {
          console.warn(err);
          recommendedSize = null;
        } finally {
          if (debugPage) {
            console.log('%c height weight', 'background:#bada55; color:#222;', {
              heightIndex: heightIndex,
              weightIndex: weightIndex,
              recommendedSize: recommendedSize,
              inches: inches
            });
          }
        }
        if (!recommendedSize) {
          setStep(4);
          toggleTallerLayout(true);

          // but keep showing the size chart button
          if (cancelButton) cancelButton.classList.remove('show');
          if (sizeChartOpen) sizeChartOpen.classList.remove('hidden');
          if (sizeGuidePageContainer) sizeGuidePageContainer.style.height = '130px';
          return;
        }
        if (window.productJson.type === 'TeeLab') {
          if (recommendedSize === 'xxs') {
            recommendedSize = 'xs';
          } else if (recommendedSize === 'xl') {
            recommendedSize = 'l';
          }
        }

        // Store the recommended size in localStorage so it can be the default
        setLocalStorage('graysonSize', recommendedSize);
        if (recommendation) recommendation.textContent = recommendedSize;

        /**
          The recommended size can be:
              1) available in this color
              2) sold out for all colors
              3) available in two other colors
              4) available in only one other color
          */

        // See if the recommended size is available in the currently chosen color
        var colorOption = 'option' + self.colorOptionNumber;
        var sizeOption = 'option' + self.sizeOptionNumber;
        var recommendedVariant = productJson.variants.find(function (variant) {
          return variant.option2.toLowerCase() === recommendedSize;
        });

        // 1) available in this color
        if (recommendedVariant && recommendedVariant.available) {
          return;
        } else {
          if (soldOut) {
            soldOut.classList.remove('hidden');
            soldOut.classList.add('no-border');
          }
        }
        if (soldOut) soldOut.classList.remove('no-border');
        toggleTallerLayout(true);

        // 2) sold out for all colors
        if (self.quantitiesBySize[recommendedSize] <= 0) {
          var messageEl = soldOut ? soldOut.querySelector('.message') : null;
          if (messageEl) messageEl.textContent = 'This size is sold out';
          return;
        }

        // 3 & 4 (at least 1 alternative color is not sold out)
        // randomize the colorOptions array
        window.colorOptions.sort(function () {
          return 0.5 - Math.random();
        });
        var alternativeColors = window.colorOptions.filter(function (colorName) {
          var variant = find(productJson.variants, _defineProperty(_defineProperty({}, colorOption, colorName), sizeOption, recommendedSize));
          return variant && variant.available;
        });

        // we only need 2
        alternativeColors = alternativeColors.slice(0, 2);
        if (debugPage) {
          console.log('%calternativeColors', 'background:#bada55; color:#222;', alternativeColors);
        }

        // 3) available in two other colors
        var messageEl = soldOut ? soldOut.querySelector('.message') : null;
        if (alternativeColors.length >= 2) {
          if (messageEl) messageEl.innerHTML = 'This style is sold out in your size';
        }

        // 4) available in only one other color
        else {
          if (messageEl) messageEl.innerHTML = 'This style is sold out in your size.';
        }
        var colorNameArray = []; // reset color name array
        if (soldOutOptionContainer) soldOutOptionContainer.innerHTML = ''; // reset container

        alternativeColors.forEach(function (colorName) {
          var alternativeVariant = find(productJson.variants, _defineProperty(_defineProperty({}, colorOption, colorName), sizeOption, recommendedSize));
          var alternativeImg = self.colorImageSets ? self.colorImageSets[colorName].image3 : '';
          if (debugPage) {
            console.log('%c alternativeVariant', 'background:pink;', {
              alternativeVariant: alternativeVariant,
              alternativeImg: alternativeImg,
              colorName: colorName
            });
          }
          var alternative = soldOutOptionTemplate ? soldOutOptionTemplate.cloneNode(true) : document.createElement('div');
          alternative.classList.remove('template');
          var fabricEl = alternative.querySelector('.fabric');
          var colorEl = alternative.querySelector('.color');
          var imgEl = alternative.querySelector('img');
          if (fabricEl) fabricEl.textContent = self.currentFabricName;
          if (colorEl) colorEl.textContent = colorName;
          if (imgEl) imgEl.setAttribute('src', alternativeImg);
          alternative.addEventListener('click', function (ev) {
            if (ev && ev.stopPropagation) {
              ev.stopPropagation();
            }
            applyColorToSelection(colorName);
            applySizeToSelection();
            closeSizeGuide();
          });
          if (colorNameArray.indexOf(colorName) === -1) {
            // prevent duplicate product
            colorNameArray.push(colorName);
            // This has to be appended AFTER the click event
            if (soldOutOptionContainer) soldOutOptionContainer.appendChild(alternative);
          }
        });
      }
      function toggleTallerLayout(taller) {
        taller = taller !== undefined ? taller : true;
        if (taller) {
          if (cancelButton) cancelButton.classList.add('show');
          if (sizeChartOpen) sizeChartOpen.classList.add('hidden');
          if (pageThree) pageThree.classList.add('sold-out');
          if (sizeGuidePageContainer) sizeGuidePageContainer.style.height = '555px';
          if (sizeGuideInner) {
            sizeGuideInner.style.height = '700px';
            sizeGuideInner.classList.add('is-taller');
          }
          if (soldOut) soldOut.classList.remove('hidden');
        } else {
          if (cancelButton) cancelButton.classList.remove('show');
          if (sizeChartOpen) sizeChartOpen.classList.remove('hidden');
          if (pageThree) pageThree.classList.remove('sold-out');
          if (soldOut) soldOut.classList.add('hidden');
          if (sizeGuidePageContainer) sizeGuidePageContainer.style.height = '270px';
          if (sizeGuideInner) {
            sizeGuideInner.style.height = '';
            sizeGuideInner.classList.remove('is-taller');
          }
        }
      }
      function applySizeToSelection() {
        if (!recommendedSize) return;
        selectSizeButtons.forEach(function (el) {
          el.classList.add(product_size_guide_selectors.isHidden);
        });
        self.$sizeCircles.forEach(function (el) {
          el.classList.remove('current');
        });
        var recommendedCircle = document.querySelector('.product__circle[data-value="' + recommendedSize.toUpperCase() + '"]');
        if (recommendedCircle) recommendedCircle.classList.add('current');
        if (variantSizeDropdown) {
          variantSizeDropdown.value = recommendedSize;
          variantSizeDropdown.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
        var currentSizeEl = document.querySelector('#pvActiveSize');
        var currentSizeMobile = document.querySelector('#pvActiveSize');
        if (currentSizeEl) {
          currentSizeEl.innerHTML = recommendedSize;
          currentSizeEl.classList.add('size-selected');
        }
        if (currentSizeMobile) {
          currentSizeMobile.innerHTML = recommendedSize;
          currentSizeMobile.classList.add('size-selected');
        }
        self.setSizeInForm(recommendedSize);
      }
      function applyColorToSelection(alternativeColor) {
        if (!alternativeColor) return;
        var colorCircles = document.querySelectorAll('.product__options__color .product__circle');
        colorCircles.forEach(function (el) {
          el.classList.remove('current');
        });
        var targetSwatch = document.querySelector('.product__swatch[data-value="' + alternativeColor + '"] .product__circle');
        if (targetSwatch) targetSwatch.classList.add('current');
        if (variantColorDropdown) {
          variantColorDropdown.value = alternativeColor;
          variantColorDropdown.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
      }
      function setStep(newStep, delay) {
        delay = delay || 0;
        step = newStep;
        steps.forEach(function (el) {
          el.classList.remove('active');
        });
        setCtaState();
        if (step <= 1 && cta) cta.textContent = 'NEXT';else if (step === 2 && cta) cta.textContent = 'SEE MY FIT';else if (step === 3 && cta) cta.classList.add('hidden');
        if (step === 3) {
          if (productFormEl) productFormEl.classList.remove('size-guide-in-progress');
          if (outerParent) outerParent.classList.remove('size-guide-in-progress');
          if (mobileSizeGuideCTA) {
            mobileSizeGuideCTA.classList.add('visible');
          }
        }
        var showBackButton = step === 2;
        if (backButton) {
          if (showBackButton) {
            backButton.classList.remove('hidden');
          } else {
            backButton.classList.add('hidden');
          }
        }
        var thisStep = document.querySelector('[data-size-guide-step="' + step + '"]');
        setTimeout(function () {
          if (thisStep) thisStep.classList.add('active');
        }, delay);
      }
      function openSizeGuide(ev) {
        if (ev && ev.stopPropagation) ev.stopPropagation();
        if (!self.desktopMq.matches) {
          // lock the body from scrolling if this is mobile
          bodyScrollLock.disableBodyScroll();
        }
        if (sizeGuide && sizeGuide.classList.contains('opened')) return;
        if (productFormEl) productFormEl.classList.add('size-guide-in-progress');
        if (outerParent) outerParent.classList.add('size-guide-in-progress');
        setStep(1, 750);
        var topHeight = sizesTop ? sizesTop.offsetHeight : 0;
        if (cta) cta.classList.add('active');
        if (sizeGuide) sizeGuide.classList.add('opened');
        if (sizesTop) {
          sizesTop.style.maxHeight = topHeight + 'px';
          sizesTop.classList.add('hidden');
        }
      }
      function reset(newStep) {
        newStep = typeof newStep === 'number' ? newStep : 1;
        if (cta) cta.classList.remove('hidden');
        if (mobileSizeGuideCTA) {
          mobileSizeGuideCTA.classList.remove('visible');
        }
        toggleTallerLayout(false);
        dropdowns.forEach(function (el) {
          el.selectedIndex = 0;
        });
        setStep(newStep);
        recommendedSize = null;
        if (recommendation) recommendation.textContent = '';
        if (productFormEl) productFormEl.classList.add('size-guide-in-progress');
        if (outerParent) outerParent.classList.add('size-guide-in-progress');
        self.enteredData = {
          height: null,
          weight: null
        };
        var soldOutOptions = document.querySelectorAll(product_size_guide_selectors.sizeGuide.soldOutOptions);
        soldOutOptions.forEach(function (el) {
          if (!el.classList.contains('template')) el.remove();
        });
      }
      function closeSizeGuide(ev) {
        if (ev && ev.stopPropagation) ev.stopPropagation();
        document.body.style.overflow = '';

        // on final step, 'x' click should close entire panel
        if (this && (step === 0 || step >= 3)) {
          this.closeSizePanel();
        }
        closeSizeChart();
        if (cta) cta.classList.remove('active');
        if (sizeGuide) sizeGuide.classList.remove('opened');
        reset(0);
        if (productFormEl) productFormEl.classList.remove('size-guide-in-progress');
        if (outerParent) outerParent.classList.remove('size-guide-in-progress');

        // reset the height of the desktop's size option selector
        var desktopParentEl = document.querySelector(product_size_guide_selectors.sizeGuide.desktopParent);
        var newHeight = desktopParentEl ? desktopParentEl.offsetHeight : 0;
        if (sizesTop) {
          sizesTop.style.maxHeight = newHeight + 'px';
          sizesTop.classList.remove('hidden');
        }
        setTimeout(function () {
          if (sizesTop && !sizesTop.classList.contains('hidden')) {
            sizesTop.style.maxHeight = 'none';
          }
        }, 500);
      }
      function openSizeChart() {
        if (productFormEl) productFormEl.classList.add('size-guide-in-progress');
        if (outerParent) outerParent.classList.add('size-guide-in-progress');
        if (scrollingContent) scrollingContent.classList.add('size-guide-in-progress');
        if (sizeChart) sizeChart.classList.add('open');
        toggleTallerLayout(true);
        if (cancelButton) cancelButton.classList.add('hide');

        // AMP: Move focus to dialog and trap focus for accessibility
        if (sizeChart) {
          // Set aria-modal for screen readers
          sizeChart.setAttribute('role', 'dialog');
          sizeChart.setAttribute('aria-modal', 'true');
          // Trap focus within the dialog
          trap_focus(sizeChart);
        }
        if (sizeChartClose) sizeChartClose.focus();
      }
      function closeSizeChart() {
        // AMP: Remove modal attributes when closing
        if (sizeChart) {
          sizeChart.removeAttribute('aria-modal');
        }
        if (productFormEl) productFormEl.classList.remove('size-guide-in-progress');
        if (outerParent) outerParent.classList.remove('size-guide-in-progress');
        if (scrollingContent) scrollingContent.classList.remove('size-guide-in-progress');
        if (sizeChart) sizeChart.classList.remove('open');
        if (cancelButton) cancelButton.classList.remove('hide');
        toggleTallerLayout(false);

        // CLOSE SIZE GUIDE
        document.body.style.overflow = '';
        if (cta) cta.classList.remove('active');
        if (sizeGuide) sizeGuide.classList.remove('opened');
        bodyScrollLock.clearAllBodyScrollLocks();
        reset(0);
        // reset the height of the desktop's size option selector
        var desktopParentEl = document.querySelector(product_size_guide_selectors.sizeGuide.desktopParent);
        var newHeight = desktopParentEl ? desktopParentEl.offsetHeight : 0;
        if (sizesTop) {
          sizesTop.style.maxHeight = newHeight + 'px';
          sizesTop.classList.remove('hidden');
        }
        setTimeout(function () {
          if (sizesTop && !sizesTop.classList.contains('hidden')) {
            sizesTop.style.maxHeight = 'none';
          }
        }, 500);
      }
    }
  }, {
    key: "initSizePicker",
    value: function initSizePicker() {
      this.$sizeDropdown = document.querySelector('.option-Size');
      this.$sizeCircles = document.querySelectorAll('.product__sizes .product__circle');
      var self = this;
      this.$sizeCircles.forEach(function (circle) {
        var value = circle.getAttribute('data-value');
        if (value && value.toLowerCase() === 'o/s' && circle.classList.contains('current')) {
          self.setSize(circle, value, false);
        }
      });
      this.$sizeCircles.forEach(function (circle) {
        circle.addEventListener('click', function () {
          var value = this.getAttribute('data-value');
          self.setSize(this, value);
          self.closeSizePanel();
        });
      });
    }
  }, {
    key: "closeSizePanel",
    value: function closeSizePanel() {
      if (this.desktopMq.matches) {
        var sizePanels = document.querySelectorAll(product_size_guide_selectors.sizePanel);
        sizePanels.forEach(function (el) {
          el.classList.remove('open');
        });
        var sizePanelDivs = document.querySelectorAll(product_size_guide_selectors.sizePanel + ' > div');
        sizePanelDivs.forEach(function (el) {
          el.classList.remove('open');
        });
        var arrows = document.querySelectorAll(product_size_guide_selectors.arrow);
        arrows.forEach(function (el) {
          el.classList.remove('is-active');
        });
      }
    }
  }, {
    key: "setSize",
    value: function setSize(button, newSize, triggerChange) {
      triggerChange = triggerChange !== undefined ? triggerChange : true;
      var currentSizeEl = document.querySelector('#pvActiveSize');
      var skuEls = document.querySelectorAll('.js-sku');
      var selectSizeButtons = document.querySelectorAll('.' + product_size_guide_selectors.selectSizeButton);
      if (currentSizeEl) {
        currentSizeEl.innerHTML = newSize;
        currentSizeEl.classList.add('size-selected');
      }
      if (this.$sizeDropdown) {
        this.$sizeDropdown.value = newSize;
        if (triggerChange) {
          this.$sizeDropdown.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
      }
      if (button.classList.contains('qa')) {
        var siblings = Array.from(button.parentElement.children).filter(function (el) {
          return el !== button;
        });
        siblings.forEach(function (el) {
          el.classList.remove('current');
          el.removeAttribute('aria-current');
        });
        button.classList.add('current');
        button.setAttribute('aria-current', true);
      } else if (button.classList.contains('is-bundle')) {
        // Bundle products: just toggle current on the clicked button within its size panel
        var siblingsCircles = Array.from(button.parentElement.children).filter(function (el) {
          return el !== button && el.classList.contains('product__circle');
        });
        siblingsCircles.forEach(function (el) {
          el.classList.remove('current');
          el.removeAttribute('aria-current');
        });
        button.classList.add('current');
        button.setAttribute('aria-current', true);
      } else {
        var siblingsCircles = Array.from(button.parentElement.children).filter(function (el) {
          return el !== button && el.classList.contains('product__circle');
        });
        siblingsCircles.forEach(function (el) {
          el.classList.remove('current');
          el.removeAttribute('aria-current');
        });
        var variantId = button.dataset.variantId;
        var matchingCircles = document.querySelectorAll('.product-section .product__circle[data-variant-id="' + variantId + '"]');
        matchingCircles.forEach(function (el) {
          el.classList.add('current');
          el.setAttribute('aria-current', true);
        });
        var currentSizeEls = document.querySelectorAll('.current-size');
        currentSizeEls.forEach(function (el) {
          el.textContent = newSize;
          if (!el.classList.contains('show')) {
            el.classList.add('show');
          }
        });
      }

      // Check if this is a bundle product and dispatch event
      var isBundleEl = document.querySelector('.product__circle.is-bundle');
      var isBundle = isBundleEl !== null;
      if (isBundle) {
        var optionsCount = document.querySelectorAll('.product__options').length;
        document.dispatchEvent(new CustomEvent('bundle:size-changed', {
          detail: {
            size: newSize,
            button: button,
            selectedCount: document.querySelectorAll('.product__circle.is-bundle.current').length,
            totalCount: optionsCount
          },
          bubbles: true
        }));
      }
      this.setSizeInForm(newSize);

      // Clear size selection error message
      var sizeError = document.getElementById('sizeError');
      while (sizeError) {
        sizeError.parentNode.removeChild(sizeError);
        sizeError = document.getElementById('sizeError');
      }
    }
  }, {
    key: "setSizeInForm",
    value: function setSizeInForm(val) {
      var activeRadio = document.querySelector('#configGroupSize input:checked');
      var sizesOpt = document.querySelector('div[data-value="' + val.toUpperCase() + '"] input');
      if (activeRadio) activeRadio.checked = false;
      if (sizesOpt) sizesOpt.click();
    }
  }, {
    key: "initDropdowns",
    value: function initDropdowns() {
      var isOpen = false;
      var options = document.querySelectorAll(product_size_guide_selectors.sizeGuide.desktopOptions);
      var self = this;
      var selectorWrappers = document.querySelectorAll('.selector-wrapper');
      selectorWrappers.forEach(function (wrapper) {
        wrapper.addEventListener('click', function () {
          // Only run on the desktop
          if (!self.desktopMq.matches) return;
          this.classList.add('inFront');
          var desktopOpts = this.querySelector(product_size_guide_selectors.sizeGuide.desktopOptions);
          if (desktopOpts) desktopOpts.classList.add('show');
          resizeDropdown();
          setTimeout(function () {
            isOpen = true;
          }, 100);
        });
      });

      // Close the dropdown if clicking outside of them
      document.body.addEventListener('click', function (ev) {
        var clickedOutside = !ev.target.closest('[data-for-dropdown]');
        if (clickedOutside && isOpen) closeDropdown();
      });
      function closeDropdown() {
        options.forEach(function (el) {
          el.classList.remove('show');
        });
        var selWrappers = document.querySelectorAll('.selector-wrapper');
        selWrappers.forEach(function (el) {
          el.classList.remove('inFront');
        });
        isOpen = false;
      }

      // Keep the dropdowns in the right place
      window.addEventListener('resize', throttle(resizeDropdown, 250));
      function resizeDropdown() {
        var openedDropdown = document.querySelector('.desktop--options.show');
        var elIndex = 0;
        if (!openedDropdown) return;
        if (self.desktopMq.matches) {
          elIndex = 1;
        }
        var sizeGuideInners = document.querySelectorAll('.size-guide__inner');
        var containerRect = sizeGuideInners[elIndex] ? sizeGuideInners[elIndex].getBoundingClientRect() : {
          top: 0,
          height: 0
        };
        var prevEl = openedDropdown.previousElementSibling;
        var selectRect = prevEl ? prevEl.getBoundingClientRect() : {
          top: 0
        };
        openedDropdown.style.top = containerRect.top - selectRect.top + 'px';
        openedDropdown.style.height = containerRect.height + 'px';
      }
      options.forEach(function (optEl) {
        var liItems = optEl.querySelectorAll('li');
        liItems.forEach(function (li) {
          li.addEventListener('click', function (ev) {
            ev.stopPropagation();
            var value = li.value;
            var ulParent = li.closest('ul');
            var type = ulParent ? ulParent.dataset.forDropdown : '';
            var selectEl = document.querySelector('.dropdown-' + type);
            if (selectEl) {
              selectEl.value = value;
              selectEl.dispatchEvent(new Event('change', {
                bubbles: true
              }));
            }
            closeDropdown();
          });
        });
      });
    }
  }]);
}();
/* harmony default export */ var product_size_guide = (ProductSizeGuide);
;// ./src/js/components/Accordion.js
function Accordion_typeof(o) { "@babel/helpers - typeof"; return Accordion_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Accordion_typeof(o); }
function Accordion_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Accordion_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Accordion_toPropertyKey(o.key), o); } }
function Accordion_createClass(e, r, t) { return r && Accordion_defineProperties(e.prototype, r), t && Accordion_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Accordion_toPropertyKey(t) { var i = Accordion_toPrimitive(t, "string"); return "symbol" == Accordion_typeof(i) ? i : i + ""; }
function Accordion_toPrimitive(t, r) { if ("object" != Accordion_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Accordion_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Accordion = /*#__PURE__*/function () {
  function Accordion(el, trigger, body, mobile, onChange) {
    Accordion_classCallCheck(this, Accordion);
    if (el === null && trigger === null && body === null) {
      return;
    }
    this.el = el;
    this.mobile = mobile;
    this.trigger = trigger ? el.querySelector(trigger) : null;
    this.contentBody = el.querySelector(body);
    this.openClass = 'is-open';
    this.state = {
      isOpen: false,
      openHeight: null,
      closeHeight: 0
    };
    var nullAction = function nullAction() {}; // eslint-disable-line
    this.onChange = onChange || nullAction;
    this.init();
  }
  return Accordion_createClass(Accordion, [{
    key: "addEvents",
    value: function addEvents() {
      this.setOpenHeight();
      if (this.trigger) {
        this.trigger.addEventListener('click', this.toggleHeight.bind(this));
      }
      window.addEventListener('resize', throttle(this.setOpenHeight.bind(this), 400));
    }
  }, {
    key: "setOpenHeight",
    value: function setOpenHeight() {
      this.state.openHeight = this.contentBody.scrollHeight + 20;
    }
  }, {
    key: "open",
    value: function open() {
      var self = this;
      this.state.isOpen = true;
      if (this.trigger) {
        this.trigger.classList.add(this.openClass);
        this.trigger.setAttribute('aria-expanded', true);
      }
      this.contentBody.classList.add(this.openClass);
      slideDown(this.contentBody);
      if (this.mobile === true) {
        setTimeout(function () {
          var height = self.el.offsetHeight + 50;
          self.el.parentNode.style.height = "".concat(height, "px");
        }, 300);
      }
    }
  }, {
    key: "close",
    value: function close() {
      var self = this;
      this.state.isOpen = false;
      if (this.trigger) {
        this.trigger.classList.remove(this.openClass);
        this.trigger.setAttribute('aria-expanded', false);
      }
      slideUp(this.contentBody);
      if (this.mobile === true) {
        setTimeout(function () {
          var height = self.el.offsetHeight + 50;
          self.el.parentNode.style.height = "".concat(height, "px");
        }, 300);
      }
      this.contentBody.classList.remove(this.openClass);
    }
  }, {
    key: "toggleHeight",
    value: function toggleHeight(ev) {
      ev.preventDefault();
      if (this.state.isOpen) this.close(); // eslint-disable-line curly
      else this.open(); // eslint-disable-line curly

      this.onChange(this.state.isOpen, this);
    }
  }, {
    key: "init",
    value: function init() {
      this.addEvents();
      if (location.pathname.includes('e-gift-card')) {
        this.open();
      }
    }
  }]);
}();

;// ./src/js/utils/dom.js


/**
 * querySelector shorthand with optional context
 */
function qs(selector, context) {
  return (context || document).querySelector(selector);
}

/**
 * querySelectorAll returning a real Array
 */
function qsa(selector, context) {
  return Array.from((context || document).querySelectorAll(selector));
}

/**
 * Smooth scroll to a vertical position
 * Replaces $('html, body').animate({scrollTop: y}, speed)
 */
function smoothScrollTo(top) {
  window.scrollTo({
    top: top,
    behavior: 'smooth'
  });
}

/**
 * Get the top offset of an element relative to the document
 * Replaces $(el).offset().top
 */
function offsetTop(el) {
  return el.getBoundingClientRect().top + window.pageYOffset;
}

/**
 * Fetch JSON from a URL
 * Replaces $.getJSON(url)
 */
function fetchJSON(url) {
  return fetch(url).then(function (r) {
    if (!r.ok) throw new Error(r.statusText);
    return r.json();
  });
}

/**
 * Fetch text/HTML from a URL
 * Replaces $.get(url) for HTML content
 */
function fetchText(url) {
  return fetch(url).then(function (r) {
    if (!r.ok) throw new Error(r.statusText);
    return r.text();
  });
}

/**
 * Toggle slide animation on an element
 * Re-uses slideDown/slideUp from helpers.js
 */
function slideToggle(el) {
  if (!el) return;
  if (el.offsetHeight === 0 || window.getComputedStyle(el).display === 'none') {
    slideDown(el);
  } else {
    slideUp(el);
  }
}

/**
 * Find the next sibling element matching a selector
 * Replaces $(el).next(selector)
 */
function nextSibling(el, selector) {
  var sibling = el.nextElementSibling;
  while (sibling) {
    if (sibling.matches(selector)) return sibling;
    sibling = sibling.nextElementSibling;
  }
  return null;
}

/**
 * Poll for an element to appear in the DOM, then fire callback
 * Replaces the jQuery-based waitForEl polling pattern
 */
function waitForElement(selector, callback) {
  if (document.querySelector(selector)) {
    callback();
  } else {
    setTimeout(function () {
      waitForElement(selector, callback);
    }, 100);
  }
}

/**
 * Group an array of objects by a key
 * Replaces lodash-es/groupBy
 */
function groupBy(arr, key) {
  return arr.reduce(function (acc, item) {
    var groupKey = typeof key === 'function' ? key(item) : item[key];
    if (!acc[groupKey]) acc[groupKey] = [];
    acc[groupKey].push(item);
    return acc;
  }, {});
}
;// ./src/js/components/yotpo-reviews.js

var yotpo_reviews_selectors = {
  reviewsHead: '.pv-reviews-title',
  review: '.yotpo-review',
  reviewTitleLabel: '.yotpo_input_review_title',
  writeReviewForm: '.write-review',
  writeReviewButton: '.write-review-button',
  writeReviewHeadLabel: '.y-label',
  writeReviewWrapper: '.write-review-wrapper',
  reviewStars: '.yotpo-review-stars',
  reviewText: '.yotpo-main ',
  yotpoWraper: '.yotpo',
  yotpoPagination: '.yotpo-pager',
  yotpoPage: '.yotpo-page-element:not(.yotpo-disabled)',
  yotpoSizeRadio: '.yotpo-custom-tag-field',
  yotpoSizeRadioLabels: '.yotpo-rating-field-titles',
  yotpoRadioWrapper: '.yotpo-radio-wrapper',
  yotpoFormHeader: '.yotpo-header',
  yotpoSum: '.yotpo-stars-and-sum-reviews',
  yotpoNameLabel: '.name-input label',
  emptyReviewsLadyBug: '.ladybug--reviews',
  yotpoReviewStar: '.review-star',
  yotpoSizeBars: '.yotpo-product-related-fields-bars',
  yotpoSizeBarFull: '.yotpo-rating-bar-full',
  yotpoSizeBought: '.yotpo-product-related-field-name',
  yotpoReviews: '.yotpo-reviews',
  yotpoReviewFooter: '.yotpo-footer',
  yotpoUsername: '.yotpo-user-name',
  yotpoUsernameLabel: '.label-with-tooltip',
  yotpoHeaderElement: '.yotpo-header-element',
  yotpoUpperReview: '#upper-review',
  yotpoRelatedFields: '.product-related-fields-item ',
  yotpoRealtedFieldsValue: '.product-related-fields-item-value',
  yotpoFiterButton: '.list-category',
  yotpoSearchInProgress: '.search-in-progress',
  yotpoHidden: 'yotpo-hidden',
  yotpoPageLink: '.yotpo-page-element',
  yotpoDesktopClearAll: '.desktop-clear-all-btn',
  yotpoCustomReviewFields: '.yotpo-custom-tag-field',
  yotpoSingleChoiceField: '.yotpo-single-choice-field',
  yotpoFieldLabel: '.yotpo-field-option-label',
  yotpoSingleChoiceSelected: '.yotpo-single-choice-field__selected',
  yotpoUserRelatedFields: '.yotpo-user-related-fields',
  yotpoFieldOptionLabel: '.yotpo-field-option-label',
  yotpoRatingFieldContent: '.yotpo-rating-field-content',
  yotpoRatingField: '.yotpo-rating-field',
  yotpoUserFieldAnswer: '.yotpo-user-field-answer',
  yotpoShirtSizeAnswer: '.shirt-size-answer',
  yotpoBarsContainer: '.yotpo-field-bars-container',
  yotpoMandatoryExplain: '.yotpo-mandatory-explain',
  mainWrapper: '.yotpo.yotpo-main-widget',
  isLoading: 'is-loading'
};

// Helper to get siblings matching a selector
function getSiblings(el, selector) {
  var siblings = [];
  var sibling = el.parentNode ? el.parentNode.firstElementChild : null;
  while (sibling) {
    if (sibling !== el && (!selector || sibling.matches(selector))) {
      siblings.push(sibling);
    }
    sibling = sibling.nextElementSibling;
  }
  return siblings;
}
function yotpoReviews() {
  var reviewSectionHead = document.querySelector(yotpo_reviews_selectors.reviewsHead);
  var writeReviewButtonEl = document.querySelector(yotpo_reviews_selectors.writeReviewButton);
  var reviews = document.querySelectorAll(yotpo_reviews_selectors.review);
  var writeReviewFormEl = document.querySelector(yotpo_reviews_selectors.writeReviewForm);
  var yotpoFormHeaderEl = writeReviewFormEl ? writeReviewFormEl.querySelector(yotpo_reviews_selectors.yotpoFormHeader) : null;
  var yotpoSizeWrapper = document.querySelector(yotpo_reviews_selectors.yotpoSizeRadio);
  var yotpoFormScoreLabels = yotpoFormHeaderEl ? yotpoFormHeaderEl.querySelectorAll(yotpo_reviews_selectors.writeReviewHeadLabel) : [];
  var yotpoTitleInputLabels = writeReviewFormEl ? writeReviewFormEl.querySelectorAll(yotpo_reviews_selectors.writeReviewHeadLabel) : [];
  var formSscoreWrapper = yotpoFormScoreLabels[1] ? yotpoFormScoreLabels[1].nextElementSibling : null;
  var yotpoSummary = document.querySelector(yotpo_reviews_selectors.yotpoSum);
  var writeReviewWrapper = document.querySelector(yotpo_reviews_selectors.writeReviewWrapper);
  var emptyReviewsLadyBug = document.querySelector(yotpo_reviews_selectors.emptyReviewsLadyBug);
  var nameLabels = document.querySelectorAll(yotpo_reviews_selectors.yotpoNameLabel);
  var reviewStars = document.querySelectorAll(yotpo_reviews_selectors.yotpoReviewStar);
  var yotpoUpperReviewEl = document.querySelector(yotpo_reviews_selectors.yotpoUpperReview);
  var yotpoUpperReviewText = yotpoUpperReviewEl ? yotpoUpperReviewEl.querySelector('.write-review-btn-hidden') : null;
  var yotpoUpperReviewStars = yotpoUpperReviewEl ? yotpoUpperReviewEl.querySelectorAll('.yotpo-icon-empty-star') : [];
  var yotpoFiterButtons = document.querySelectorAll(yotpo_reviews_selectors.yotpoFiterButton);
  var yotpoSearchInProgress = document.querySelector(yotpo_reviews_selectors.yotpoSearchInProgress);
  var yotpoPageLinks = document.querySelectorAll(yotpo_reviews_selectors.yotpoPageLink);
  var yotpoMandatoryExplain = document.querySelector(yotpo_reviews_selectors.yotpoMandatoryExplain);
  var paragraph = '<p style="margin-top:0;">We love to hear from you, wrinkles and all!</p>';
  var mainWrapper = document.querySelector(yotpo_reviews_selectors.mainWrapper);
  var writeReviewButtonCounter = 0;
  var reviewsLoaded = false;
  var reviewCheck = setInterval(init, 300);
  function init() {
    var form = document.querySelector('.write-review-wrapper write-form') !== null;
    var main = document.querySelector('.main-widget.yotpo-display-wrapper') !== null;
    var button = document.querySelector(yotpo_reviews_selectors.writeReviewButton) !== null;
    reviewsLoaded = form && main && button;
    if (reviewsLoaded) {
      updateReviewUI();
      clearInterval(reviewCheck);
    }
  }
  function updateReviewUI() {
    setTimeout(function () {
      if (reviewStars[4]) reviewStars[4].click();
    }, 1500);
    if (reviews.length > 1) {
      if (yotpoSummary) yotpoSummary.classList.add('visible');
      if (emptyReviewsLadyBug) emptyReviewsLadyBug.classList.add('hidden');
    }
    addSizeNumber();
    moveRatingStartsAndUserRelatedFields();
    modifyPaginationNumbers();
    modifyText();
    insertBreak();
    events();
  }
  function events() {
    var yotpoSingleChoiceFields = document.querySelectorAll(yotpo_reviews_selectors.yotpoSingleChoiceField);
    var yotpoFieldLabels = document.querySelectorAll(yotpo_reviews_selectors.yotpoFieldLabel);
    var yotpoSizeRadioLabelsContainer = document.querySelector(yotpo_reviews_selectors.yotpoSizeRadioLabels);
    var yotpoSizeRadioLabels = yotpoSizeRadioLabelsContainer ? yotpoSizeRadioLabelsContainer.querySelectorAll('label') : [];
    var yotpoRatingFieldContent = document.querySelectorAll(yotpo_reviews_selectors.yotpoRatingFieldContent);
    var yotpoFieldOptionLabels = document.querySelectorAll(yotpo_reviews_selectors.yotpoFieldOptionLabel);
    if (writeReviewButtonEl) {
      writeReviewButtonEl.addEventListener('click', function () {
        writeReviewButtonEl.classList.toggle('open');
        if (writeReviewButtonCounter === 0) {
          ++writeReviewButtonCounter;
        } else {
          slideToggle(writeReviewWrapper);
          ++writeReviewButtonCounter;
        }
        yotpoSingleChoiceFields.forEach(function (field) {
          field.addEventListener('click', function (e) {
            var targetWrap = e.target.closest(yotpo_reviews_selectors.yotpoCustomReviewFields);
            var targetWrapSiblings = targetWrap ? getSiblings(targetWrap, yotpo_reviews_selectors.yotpoCustomReviewFields) : [];
            targetWrapSiblings.forEach(function (wrap) {
              var fieldset = wrap.querySelector('fieldset');
              var singleChoice = wrap.querySelector(yotpo_reviews_selectors.yotpoSingleChoiceField);
              if (fieldset) fieldset.classList.remove('is-visible');
              if (singleChoice) singleChoice.classList.remove('is-open');
            });
            if (yotpoRatingFieldContent[0]) {
              yotpoRatingFieldContent[0].parentNode.classList.remove('is-open');
            }
            var childFieldset = e.target.querySelector('fieldset');
            if (childFieldset) childFieldset.classList.toggle('is-visible');
            e.target.classList.toggle('is-open');
            var parentCustomField = e.target.closest('.yotpo-custom-tag-field');
            if (parentCustomField) parentCustomField.classList.toggle('active');
          });
        });
        yotpoFieldLabels.forEach(function (label) {
          label.addEventListener('click', function (e) {
            var forAttribute = label.getAttribute('for');
            var parentSingleChoice = e.target.closest(yotpo_reviews_selectors.yotpoSingleChoiceField);
            var parentFieldset = e.target.closest('fieldset');
            if (parentFieldset) parentFieldset.classList.remove('is-visible');
            if (parentSingleChoice) {
              parentSingleChoice.classList.toggle('is-open');
              var selectedEl = parentSingleChoice.querySelector(yotpo_reviews_selectors.yotpoSingleChoiceSelected);
              if (selectedEl) selectedEl.remove();
              var parentCustomField = parentSingleChoice.closest('.yotpo-custom-tag-field');
              if (parentCustomField) parentCustomField.classList.remove('active');
              var newDiv = document.createElement('div');
              if (!forAttribute.includes('yotpo_input_what_size_did_you_purchase_field_option')) {
                newDiv.className = 'yotpo-single-choice-field__selected';
              } else {
                newDiv.className = 'yotpo-single-choice-field__selected yotpo-single-choice-field__selected--size';
              }
              newDiv.innerHTML = e.target.innerHTML;
              parentSingleChoice.insertBefore(newDiv, parentSingleChoice.firstChild);
            }
          });
        });

        // add click events for size select
        Array.from(yotpoSizeRadioLabels).forEach(function (label, i) {
          if (i === 1) {
            label.click();
          }
          label.addEventListener('click', function () {
            Array.from(yotpoSizeRadioLabels).forEach(function (l) {
              l.classList.remove('selected');
            });
            label.classList.add('selected');
          });
        });
        if (yotpoRatingFieldContent[0]) {
          yotpoRatingFieldContent[0].addEventListener('click', function (e) {
            var target = e.target;
            target.parentNode.classList.toggle('is-open');
            target.parentNode.parentNode.classList.toggle('active');
            yotpoSingleChoiceFields.forEach(function (field) {
              var fieldset = field.querySelector('fieldset');
              if (fieldset) fieldset.classList.remove('is-visible');
              field.classList.remove('is-open');
            });
          });
        }
        yotpoFieldOptionLabels.forEach(function (label) {
          label.addEventListener('click', function (e) {
            var parentRatingContent = e.target.closest(yotpo_reviews_selectors.yotpoRatingFieldContent);
            var forAttribute = label.getAttribute('for');
            if (parentRatingContent) {
              parentRatingContent.classList.remove('is-open');
              parentRatingContent.classList.remove('active');
              var selectedEl = parentRatingContent.querySelector(yotpo_reviews_selectors.yotpoSingleChoiceSelected);
              if (selectedEl) selectedEl.remove();
              var parentRatingField = parentRatingContent.closest('.yotpo-rating-field');
              if (parentRatingField) {
                parentRatingField.classList.remove('is-open');
                var parentCustomField = parentRatingField.closest('.yotpo-custom-tag-field');
                if (parentCustomField) parentCustomField.classList.remove('active');
              }
              var newDiv = document.createElement('div');
              if (!forAttribute.includes('yotpo_input_what_size_did_you_purchase_field_option')) {
                newDiv.className = 'yotpo-single-choice-field__selected';
              } else {
                newDiv.className = 'yotpo-single-choice-field__selected yotpo-single-choice-field__selected--size';
              }
              newDiv.innerHTML = e.target.innerHTML;
              parentRatingContent.insertBefore(newDiv, parentRatingContent.firstChild);
            }
          });
        });
      });
    }
    yotpoFiterButtons.forEach(function (filter) {
      filter.addEventListener('click', function () {
        startInterval();
      });
    });
    yotpoPageLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        startInterval();
      });
    });
    addPaginationEvents();
  }
  function addPaginationEvents() {
    var pages = document.querySelectorAll(yotpo_reviews_selectors.yotpoPage);
    // add click events for pagination
    pages.forEach(function (page) {
      page.classList.add('data-hj-whitelist');
      page.addEventListener('click', function () {
        var yotpoReviewsEl = document.querySelector(yotpo_reviews_selectors.yotpoReviews);
        if (yotpoReviewsEl) yotpoReviewsEl.classList.add(yotpo_reviews_selectors.isLoading);
        setTimeout(function () {
          moveRatingStartsAndUserRelatedFields();
          addSizeNumber();
          modifyPaginationNumbers();
          addPaginationEvents();
          if (yotpoReviewsEl) yotpoReviewsEl.classList.remove(yotpo_reviews_selectors.isLoading);
        }, 1000);
      });
    });
  }
  function addPaginationEventsWithFilter() {
    var pages = document.querySelectorAll(yotpo_reviews_selectors.yotpoPage);
    // add click events for pagination
    pages.forEach(function (page) {
      page.classList.add('data-hj-whitelist');
      page.addEventListener('click', function () {
        startInterval();
      });
    });
  }
  function startInterval(skipClearAll) {
    var interval = setInterval(checkForClass, 10);
    var intervalCount = 0;
    function checkForClass() {
      if (yotpoSearchInProgress && yotpoSearchInProgress.classList.contains(yotpo_reviews_selectors.yotpoHidden)) {
        clearInterval(interval);
        moveRatingStartsAndUserRelatedFields();
        addSizeNumber();
        modifyPaginationNumbers();
        addPaginationEventsWithFilter();
        if (skipClearAll !== true) clearAllButtonEvent();
      } else {
        intervalCount++;
        if (intervalCount > 2000) {
          clearInterval(interval);
        }
      }
    }
  }
  function clearAllButtonEvent() {
    var clearAllButtons = document.querySelectorAll(yotpo_reviews_selectors.yotpoDesktopClearAll);
    var skipClearAll = true;
    clearAllButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        startInterval(skipClearAll);
      });
    });
  }
  function moveRatingStartsAndUserRelatedFields() {
    // move rating stars
    var currentReviews = document.querySelectorAll(yotpo_reviews_selectors.review);
    currentReviews.forEach(function (review) {
      var rating = review.querySelector(yotpo_reviews_selectors.reviewStars);
      var main = review.querySelector(yotpo_reviews_selectors.reviewText);
      var header = review.querySelector(yotpo_reviews_selectors.yotpoHeaderElement);
      var username = header ? header.querySelector(yotpo_reviews_selectors.yotpoUsername) : null;
      var usernameLabel = header ? header.querySelector(yotpo_reviews_selectors.yotpoUsernameLabel) : null;
      var reviewTitle = review.querySelector('.content-title');
      var yotpoUserRelatedFields = review.querySelector(yotpo_reviews_selectors.yotpoUserRelatedFields);
      var checkIfUsernameAdded = review.querySelector('.username-mobile') !== null;
      if (checkIfUsernameAdded === false && reviewTitle && username && usernameLabel) {
        var usernameMobile = document.createElement('div');
        usernameMobile.className = 'username-mobile';
        var usernameMobileName = username.cloneNode(true);
        usernameMobileName.classList.add('usernam-mobile__name');
        var usernameMobileLabel = usernameLabel.cloneNode(true);
        usernameMobileLabel.classList.add('username-mobile__label');
        reviewTitle.after(usernameMobile);
        usernameMobile.appendChild(usernameMobileName);
        usernameMobile.appendChild(usernameMobileLabel);
      }
      if (yotpoUserRelatedFields) {
        yotpoUserRelatedFields.remove();
        if (main) main.appendChild(yotpoUserRelatedFields);
      }
      if (rating && main) {
        main.parentNode.insertBefore(rating, main);
      }
    });
  }
  function modifyPaginationNumbers() {
    // add "0" to page numbers
    var pages = document.querySelectorAll(yotpo_reviews_selectors.yotpoPage);
    pages.forEach(function (page) {
      var pageNumber = page.getAttribute('data-page');
      var containsZero = page.innerHTML.includes('0');
      if (containsZero === false && pageNumber !== null && Number(pageNumber) < 10) {
        page.innerHTML = '0' + page.innerHTML;
        page.classList.add('data-hj-whitelist');
      }
    });
  }
  function modifyText() {
    if (yotpoUpperReviewStars.length === 5 && yotpoUpperReviewText) {
      yotpoUpperReviewText.innerHTML = 'Be the first to review this product';
    }
    var yotpoHeaders = document.querySelectorAll(yotpo_reviews_selectors.yotpoFormHeader);
    if (writeReviewButtonEl) {
      writeReviewButtonEl.insertAdjacentHTML('beforeend', paragraph);
    }
    if (yotpoTitleInputLabels[2]) {
      yotpoTitleInputLabels[2].innerHTML = 'Subject:';
    }
    if (nameLabels[0]) {
      nameLabels[0].innerHTML = 'Name';
    }
    if (yotpoFormHeaderEl && yotpoSizeWrapper) {
      yotpoFormHeaderEl.appendChild(yotpoSizeWrapper);
    }
    if (yotpoFormScoreLabels[1]) {
      yotpoFormScoreLabels[1].innerHTML = 'Score it 1-5:';
    }
    if (formSscoreWrapper && yotpoFormScoreLabels[1]) {
      formSscoreWrapper.insertBefore(yotpoFormScoreLabels[1], formSscoreWrapper.firstChild);
      formSscoreWrapper.classList.add('yotpo-form-score');
    }
    if (mainWrapper && yotpoSummary) {
      mainWrapper.insertBefore(yotpoSummary, mainWrapper.firstChild);
    }
    if (yotpoMandatoryExplain) {
      yotpoMandatoryExplain.remove();
    }
    if (yotpoHeaders && yotpoHeaders[6] && yotpoHeaders[6].firstElementChild) {
      yotpoHeaders[6].removeChild(yotpoHeaders[6].firstElementChild);
    }
  }
  function insertBreak() {
    var customReviewFields = document.querySelectorAll(yotpo_reviews_selectors.yotpoCustomReviewFields);
    if (customReviewFields[0]) {
      var breakDiv = document.createElement('div');
      breakDiv.className = 'yotpo-break';
      customReviewFields[0].after(breakDiv);
    }
  }
  function addSizeNumber() {
    var currentReviews = document.querySelectorAll(yotpo_reviews_selectors.review);
    currentReviews.forEach(function (review) {
      var sizebarFull = review.querySelectorAll(yotpo_reviews_selectors.yotpoSizeBarFull);
      var sizeOrdered = sizebarFull.length / 2;
      var relatedFieldValues = review.querySelectorAll(yotpo_reviews_selectors.yotpoRealtedFieldsValue);
      var yotpoUserShirtSizes = review.querySelectorAll(yotpo_reviews_selectors.yotpoShirtSizeAnswer);
      yotpoUserShirtSizes.forEach(function (el) {
        el.remove();
      });
      relatedFieldValues.forEach(function (fieldValue) {
        fieldValue.insertAdjacentHTML('beforeend', '<div class="yotpo-user-field-answer shirt-size-answer">0' + sizeOrdered + '</div>');
      });
    });
  }
}
/* harmony default export */ var yotpo_reviews = (yotpoReviews);
;// ./src/js/pages/product.js
function product_typeof(o) { "@babel/helpers - typeof"; return product_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, product_typeof(o); }
function product_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function product_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, product_toPropertyKey(o.key), o); } }
function product_createClass(e, r, t) { return r && product_defineProperties(e.prototype, r), t && product_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function product_toPropertyKey(t) { var i = product_toPrimitive(t, "string"); return "symbol" == product_typeof(i) ? i : i + ""; }
function product_toPrimitive(t, r) { if ("object" != product_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != product_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








var product = /*#__PURE__*/function () {
  function product() {
    product_classCallCheck(this, product);
    this.state = {};
  }
  return product_createClass(product, [{
    key: "init",
    value: function init() {
      // console.log(`Initialized ${this.constructor.name}`);
      // initialize functions

      var productForm = document.getElementById('addToBagForm') || document.getElementById('product__form');
      var isGiftCard = document.querySelector('#e-gift-card');
      var items = document.querySelectorAll('.js-acc-item');
      var sizeChartClose = document.querySelector('.size-chart__close');
      var accClose = document.querySelector('[aria-controls="pvSizeChart"] .circle-plus');

      // configurables
      new product_configurables({
        productForm: productForm
      });
      if (!isGiftCard) {
        // size chart
        new product_size_chart();

        // product size guide
        new product_size_guide();

        // product style with
        product_style_with();

        // product related
        //productRelated();
        // Defer yotpoReviews until the reviews section is near the viewport
        var yotpoTarget = document.querySelector('[data-yotpo-instance-id]') || document.getElementById('yotpo-reviews-main-widget');
        if (yotpoTarget && 'IntersectionObserver' in window) {
          var yotpoObserver = new IntersectionObserver(function (entries, observer) {
            if (entries[0].isIntersecting) {
              observer.disconnect();
              yotpo_reviews();
            }
          }, {
            rootMargin: '300px'
          });
          yotpoObserver.observe(yotpoTarget);
        } else {
          setTimeout(function () {
            yotpo_reviews();
          }, 1500);
        }
        if (sizeChartClose && accClose) {
          sizeChartClose.addEventListener('click', function () {
            accClose.click();
          });
        }
      }

      // accordion
      items.forEach(function (el) {
        new Accordion(el, '.js-acc-btn', '.js-acc-menu');
      });
      this.priceButtonHandle();
      this.reviewStars();
      this.sizeChart();
      this.riseGiftCardHandle();
      this.yotpoBlockedHandle();
    }
  }, {
    key: "priceButtonHandle",
    value: function priceButtonHandle() {
      document.querySelectorAll('.pv__price').forEach(function (priceEl) {
        var compareEl = priceEl.querySelector('.pv__price-compare');
        // Only check if there's a compare price with actual content
        if (!compareEl || !compareEl.textContent.trim()) return;
        var compareCount = compareEl.textContent.length;
        // Clone and remove compare to get just price text
        var clone = priceEl.cloneNode(true);
        var cloneCompare = clone.querySelector('.pv__price-compare');
        if (cloneCompare) cloneCompare.remove();
        var priceCount = clone.textContent.length;
        if (priceCount + compareCount > 25) {
          var parent = priceEl.parentElement;
          if (parent) parent.classList.add('btn-break');
        }
      });
    }
  }, {
    key: "reviewStars",
    value: function reviewStars() {
      function waitForEl(selector, callback) {
        if (document.querySelector(selector)) {
          callback();
        } else {
          setTimeout(function () {
            waitForEl(selector, callback);
          }, 100);
        }
      }
      waitForEl('.star-container', function () {
        document.querySelectorAll('.star-container').forEach(function (container) {
          var svg = container.querySelector('svg');
          if (svg && svg.classList.contains('yotpo-star-rating-icon')) {
            container.className = container.className + ' ' + svg.getAttribute('class');
          }
        });
      });
    }
  }, {
    key: "riseGiftCardHandle",
    value: function riseGiftCardHandle() {
      var initGiftingSessionSettings = {
        "url": "https://application.rise-ai.com/integrations/inbound/gifting/session",
        "method": "POST",
        "timeout": 0,
        "headers": {
          "x-rise-gifting-api-key": "a6ed22b4-ff65-4e91-85ce-4d2f91d46f68",
          "Content-Type": "application/json"
        }
      };
      if (document.querySelector('body[data-template-type="product.rise-gift-card"]')) {
        var accBtn = document.querySelector('.acc__btn');
        if (accBtn) accBtn.click(); // open description by default

        // check to expand price labels
        var option2Label = document.querySelector('[for="Option2-100"]');
        var option2Text = option2Label ? option2Label.textContent.trim() : '';
        if (option2Text.length > 7) {
          document.querySelectorAll('.config__giftcard .config__option label').forEach(function (label) {
            label.classList.add('expanded-xl');
          });
        } else if (option2Text.length > 4) {
          document.querySelectorAll('.config__giftcard .config__option label').forEach(function (label) {
            label.classList.add('expanded');
          });
        }
        // check for session
        console.log('rise session', getCookie('rise_gifting_session'));
        if (!getCookie('rise_gifting_session')) {
          // create session if no session present
          fetch(initGiftingSessionSettings.url, {
            method: initGiftingSessionSettings.method,
            headers: initGiftingSessionSettings.headers
          }).then(function (response) {
            return response.json();
          }).then(function (response) {
            var sessionId = response.session.id;
            setCookie('rise_gifting_session', sessionId);
          }).catch(function (error) {
            console.error('Error creating gifting session:', error);
          });
        }
        //card switch
        document.querySelectorAll('.gift-type > div').forEach(function (div) {
          div.addEventListener('click', function () {
            var self = this;
            // Add active to clicked, remove from siblings
            self.classList.add('active');
            var parent = self.parentElement;
            if (parent) {
              Array.from(parent.children).forEach(function (sibling) {
                if (sibling !== self) sibling.classList.remove('active');
              });
            }

            // Desktop shows one card image at a time. Toggle the class the
            // render-blocking rule in sections/product.liquid keys off — clearing an
            // inline display can't beat that rule, which left the physical card with
            // no image at all.
            if (innerWidth > 767) {
              document.querySelectorAll('.product__media').forEach(function (el) {
                el.classList.add('gift-media--hidden');
              });
            }
            var btnAddToBag = document.getElementById('btnAddToBag');
            var addToBag = document.getElementById('AddToBag');
            if (btnAddToBag) btnAddToBag.classList.add('hide');
            if (addToBag) addToBag.classList.add('hide');
            if (self.classList.contains('digital')) {
              if (addToBag) addToBag.classList.remove('hide');
              var eGiftOptions = document.querySelector('.e-gift-options');
              if (eGiftOptions) eGiftOptions.classList.remove('hide');
              var productTitle = document.querySelector('.product__title');
              if (productTitle) productTitle.textContent = 'Gift Card';
              // set variant query to digital variant id
              if (innerWidth > 767) {
                var firstMedia = document.querySelector('.product__media:first-child');
                if (firstMedia) firstMedia.classList.remove('gift-media--hidden');
              }
              // $('#AddToBag span').text('Send as a gift');
            } else {
              // `hide` is the only thing keeping this button hidden (see the <style>
              // block in snippets/product-actions.liquid) — clearing an inline display
              // here would not have been enough to beat a stylesheet rule.
              if (btnAddToBag) btnAddToBag.classList.remove('hide');
              var eGiftOptions = document.querySelector('.e-gift-options');
              if (eGiftOptions) eGiftOptions.classList.add('hide');
              var productTitle = document.querySelector('.product__title');
              if (productTitle) productTitle.textContent = 'Gift Card';
              // set variant query to active variant id
              var checkedOption = document.querySelector('[name="options[Title]"]:checked');
              var activeVariant = checkedOption && checkedOption.parentElement ? checkedOption.parentElement.dataset.variantId : '';
              // console.log(activeVariant);
              history.pushState({}, '', location.origin + location.pathname + '?variant=' + activeVariant);
              if (innerWidth > 767) {
                var lastMedia = document.querySelector('.product__media:last-child');
                if (lastMedia) lastMedia.classList.remove('gift-media--hidden');
              }
              // $('#AddToBag span').text('Add to Bag');
            }
          });
        });
        document.querySelectorAll('.js-config-variant').forEach(function (el) {
          el.addEventListener('click', function () {
            var self = this;
            var activeTypeDiv = document.querySelector('.gift-type div.active');
            if (activeTypeDiv && activeTypeDiv.classList.contains('physical')) {
              setTimeout(function () {
                var checkedInput = self.querySelector('input:checked');
                var activePrice = checkedInput ? checkedInput.dataset.price : null;
                var variantID = window.physicalGiftCard ? window.physicalGiftCard[activePrice] : null;
                // console.log('physical id', variantID, 'active price', activePrice);
                setTimeout(function () {
                  history.pushState({}, '', location.origin + location.pathname + '?variant=' + variantID);
                }, 500);
              }, 500);
            }
          });
        });

        // product submit handle
        ['AddToBag', 'btnAddToBag'].forEach(function (id) {
          var el = document.getElementById(id);
          if (el) {
            el.addEventListener('click', function (e) {
              var giftCardType = document.querySelector('.gift-type div.active');
              console.log(giftCardType ? giftCardType.classList.contains('physical') : false);
              if (giftCardType && giftCardType.classList.contains('physical')) {
                e.preventDefault();
                var checkedRadio = document.querySelector('.config__variant .js-config-radio:checked');
                var activePrice = checkedRadio ? checkedRadio.dataset.price : null;
                var variantToAdd = window.physicalGiftCard ? window.physicalGiftCard[activePrice] : null;
                if (variantToAdd) {
                  addItem(variantToAdd, 1, {}).then(function (data) {
                    var hasAmountValue = data.options_with_values[0].name === 'Amount';
                    var optionValue;
                    if (hasAmountValue) {
                      optionValue = data.options_with_values[0].value;
                    } else {
                      optionValue = data.options_with_values[1].value;
                    }
                    bagItems.unshift({
                      product_data: data,
                      id: data.id,
                      quantity: data.quantity,
                      price: data.price,
                      sku: data.sku,
                      size: optionValue,
                      subtitle: data.productSubtitle
                    });
                    // ga4 add_to_cart
                    dataLayer.push({
                      event: 'add_to_cart',
                      ecommerce: {
                        items: [{
                          item_name: data.product_title,
                          item_id: data.id,
                          price: (data.price / 100).toFixed(2),
                          item_brand: data.vendor,
                          item_category: data.product_type,
                          item_variant: data.variant_title,
                          index: 1,
                          quantity: 1
                        }]
                      }
                    });
                    showDrawer();
                    localStorage.pdpAddtoCart = true;
                    updateCart();
                  }).catch(function (err) {
                    var errorMessage = err.message || err.description || 'Error adding to cart';
                    console.error('Error: ' + errorMessage + '!');
                  });
                }
              }
            });
          }
        });
      }
    }
  }, {
    key: "sizeChart",
    value: function sizeChart() {
      if (document.querySelector('a[href="/pages/size-charts"]')) {
        // Get all sections that have an ID defined
        var sizeChart = document.querySelector(".sizeChart");
        var sections = document.querySelectorAll(".sizeChart section[id]");
        // Add an event listener listening for scroll
        if (sizeChart) {
          sizeChart.addEventListener("scroll", navHighlighter);
        }
        function navHighlighter() {
          // Get current scroll position
          var scrollY = sizeChart.scrollTop;

          // Now we loop through sections to get height, top and ID values for each
          sections.forEach(function (current) {
            var sectionHeight = current.offsetHeight;
            var sectionTop = current.offsetTop - 50;
            var sectionId = current.getAttribute("id");
            // console.log(scrollY, sectionTop, sectionTop + sectionHeight)
            /*
            - If our current scroll position enters the space where current section on screen is, add .active class to corresponding navigation link, else remove it
            - To know which link needs an active class, we use sectionId variable we are getting while looping through sections as an selector
            */
            var navLink = document.querySelector(".nav-toggles a[href*=" + sectionId + "]");
            if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
              if (navLink) navLink.classList.add("active");
            } else {
              if (navLink) navLink.classList.remove("active");
            }
            if (scrollY < 140) {
              var sizeGuideLink = document.querySelector(".nav-toggles a[href*=size-guide]");
              if (sizeGuideLink) sizeGuideLink.classList.add("active");
            }
          });
        }

        // unit toggle
        document.querySelectorAll('.unit-toggles li').forEach(function (li) {
          li.addEventListener('click', function () {
            var self = this;
            // Remove active from siblings
            var parent = self.parentElement;
            if (parent) {
              Array.from(parent.children).forEach(function (sibling) {
                if (sibling !== self) sibling.classList.remove('active');
              });
            }
            self.classList.add('active');
            var unit = self.dataset.unit;
            // console.log(unit)
            document.querySelectorAll('.unit-switch').forEach(function (unitSwitch) {
              unitSwitch.textContent = unitSwitch.dataset[unit];
            });
          });
        });
      }
    }
  }, {
    key: "yotpoBlockedHandle",
    value: function yotpoBlockedHandle() {
      function initPreferenceButton(button) {
        if (button) {
          button.addEventListener('click', function (e) {
            e.preventDefault();
            var reopenBanner = document.querySelector('[href="#reopenBanner"]');
            if (reopenBanner) reopenBanner.click();
          });
        }
      }
      // check consent status
      if (window.dataLayer) {
        var reversedDataLayer = window.dataLayer.slice().reverse();
        reversedDataLayer.some(function (item) {
          if (item[0] == 'consent' && item[1] == 'update') {
            // console.log('consent status:', item[2].ad_user_data, item[2].ad_personalization, item[2].ad_storage);
            if (item[2].ad_storage == 'denied') {
              var yotpoEl = document.querySelector('[data-yotpo-instance-id="423783"]');
              if (yotpoEl) {
                yotpoEl.insertAdjacentHTML('beforeend', '<div class="yotpo-blocked">\
                  <h4>You\'re missing our reviews</h4>\
                  <p>To read customer reviews, enable \'Functional Cookies\' in your Cookie Preferences below.</p>\
                  <a class="btn--outline uppercase btn--full">Open Cookie Preferences</a>\
                </div>');
              }
              // $('.yotpo.bottomLine').append(
              //   `<div class="yotpo-blocked text-only"><span>Open <a>Cookie Preferences</a> to view ratings</span></div>`
              // )
              var blockedBtn = document.querySelector('.yotpo-blocked a');
              initPreferenceButton(blockedBtn);
            }
            return true; // Stop iteration
          }
          return false;
        });
      }
    }
  }]);
}();
;// ./src/entries/page-product.js

document.addEventListener('DOMContentLoaded', function () {
  new product().init();
});
}();
/******/ })()
;